import { useState, useEffect, useRef, useCallback } from "react";

const API = "/api/v1";
const req = async (method, path, body, token, isForm) => {
  const h = {};
  if (token) h["Authorization"] = `Bearer ${token}`;
  const opts = { method, headers: h };
  if (body && !isForm) { h["Content-Type"] = "application/json"; opts.body = JSON.stringify(body); }
  else if (body && isForm) opts.body = body;
  const r = await fetch(API + path, opts);
  if (!r.ok) { const e = await r.json().catch(() => ({})); throw new Error(e.detail || "خطا"); }
  return r.json();
};

const toJalali=(gy,gm,gd)=>{const g=[0,31,59,90,120,151,181,212,243,273,304,334];let jy=gy<=1600?0:979;gy=gy<=1600?gy-621:gy-1600;const gy2=gm>2?gy+1:gy;let days=365*gy+Math.floor((gy2+3)/4)-Math.floor((gy2+99)/100)+Math.floor((gy2+399)/400)-80+gd+g[gm-1];jy+=33*Math.floor(days/12053);days%=12053;jy+=4*Math.floor(days/1461);days%=1461;if(days>365){jy+=Math.floor((days-1)/365);days=(days-1)%365;}const jm=days<186?1+Math.floor(days/31):7+Math.floor((days-186)/30);const jd=1+(days<186?days%31:(days-186)%30);return[jy,jm,jd];};
const numFa   = n => String(n ?? "").replace(/\d/g, d => "۰۱۲۳۴۵۶۷۸۹"[d]);
const fmtRial = n => numFa(Number((n ?? 0) * 10).toLocaleString("en-US"));

// ─── Export helpers ───
const TXN_LABELS = {silver_buy:"خرید ساچمه",bar_buy:"خرید شمش",gold_buy:"خرید طلا",silver_sell:"فروش نقره",silver_transfer:"انتقال نقره",physical_delivery:"تحویل فیزیکی",wallet_charge:"شارژ کیف پول",wallet_withdrawal:"برداشت",balance_adjustment:"اصلاح موجودی"};
const STATUS_LABELS = {pending:"در انتظار",approved:"تأیید شده",rejected:"رد شده",completed:"انجام شده",paid:"پرداخت شده"};
const exportTxnsCSV = (txns, title) => {
  const headers = ["ردیف","نوع","کد پیگیری","مبلغ (ریال)","نقره (گرم)","قیمت هر گرم","وضعیت","تاریخ"];
  const rows = txns.map((t,i)=>[
    i+1,
    TXN_LABELS[t.type]||t.type,
    t.tracking_code||"",
    Math.round((t.amount_rial||0)*10),
    t.silver_gram||0,
    Math.round((t.price_per_gram_rial||0)),
    STATUS_LABELS[t.status]||t.status,
    (t.created_at||"").substring(0,16)
  ]);
  const csv = [headers, ...rows].map(r=>r.map(x=>`"${String(x).replace(/"/g,'""')}"`).join(",")).join("\r\n");
  const blob = new Blob(["\uFEFF"+csv], {type:"text/csv;charset=utf-8;"});
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url; a.download = (title||"transactions")+".csv";
  document.body.appendChild(a); a.click(); document.body.removeChild(a);
  URL.revokeObjectURL(url);
};
const exportTxnsPDF = (txns, title) => {
  const rows = txns.map((t,i)=>`<tr><td>${i+1}</td><td>${TXN_LABELS[t.type]||t.type}</td><td>${t.tracking_code||""}</td><td>${Math.round((t.amount_rial||0)*10).toLocaleString("en-US")}</td><td>${t.silver_gram||0}</td><td>${STATUS_LABELS[t.status]||t.status}</td><td>${(t.created_at||"").substring(0,16)}</td></tr>`).join("");
  const html = `<html dir="rtl"><head><meta charset="utf-8"><title>${title||"سوابق"}</title><style>body{font-family:Tahoma,sans-serif;padding:20px}h2{color:#2F2C79}table{width:100%;border-collapse:collapse;font-size:12px}th,td{border:1px solid #ddd;padding:6px 8px;text-align:right}th{background:#2F2C79;color:#fff}tr:nth-child(even){background:#f5f5f8}</style></head><body><h2>${title||"سوابق تراکنش"}</h2><table><thead><tr><th>ردیف</th><th>نوع</th><th>کد پیگیری</th><th>مبلغ (ریال)</th><th>نقره (گرم)</th><th>وضعیت</th><th>تاریخ</th></tr></thead><tbody>${rows}</tbody></table><p style="margin-top:20px;color:#888;font-size:11px">قلک نقره مکعب — ${new Date().toLocaleDateString("fa-IR")}</p></body></html>`;
  const w = window.open("","_blank");
  w.document.write(html); w.document.close();
  setTimeout(()=>{ w.print(); }, 400);
};
const fmtGram = n => { const num = Number(n ?? 0); return numFa(Number.isInteger(num) ? num.toLocaleString("en-US") : num.toFixed(3).replace(/\.?0+$/, '')); };
const fmtDate = s => s ? s.substring(0,10).replace(/-/g,"/") : "";
const fmtDateFa = s => {if(!s)return"";const p=s.substring(0,10).split("-");if(p.length<3)return"";const[jy,jm,jd]=toJalali(parseInt(p[0]),parseInt(p[1]),parseInt(p[2]));return numFa(jy+"/"+String(jm).padStart(2,"0")+"/"+String(jd).padStart(2,"0"));};

const TOKEN_KEY = "mkb_token";
const ROLE_KEY  = "mkb_role";
const getToken  = () => localStorage.getItem(TOKEN_KEY);
const setToken  = t  => localStorage.setItem(TOKEN_KEY, t);
const getRole   = () => localStorage.getItem(ROLE_KEY);
const setRole   = r  => localStorage.setItem(ROLE_KEY, r);
const clearAuth = () => { localStorage.removeItem(TOKEN_KEY); localStorage.removeItem(ROLE_KEY); };

const C = {
  primary:      "#2F2C79",
  primaryDark:  "#1e1b5e",
  primaryLight: "#4340a8",
  primaryGlow:  "rgba(47,44,121,0.12)",
  secondary:    "#5a5a70",
  neutral:      "#E7E7E9",
  bg:           "#F5F5F8",
  bgDeep:       "#EDEDF2",
  bgCard:       "#FFFFFF",
  bgCardHover:  "#F5F5FA",
  bgGlass:      "#F0F0F5",
  border:       "rgba(0,0,0,0.08)",
  borderBrand:  "rgba(47,44,121,0.3)",
  text:         "#111128",
  textSub:      "#3a3a55",
  textMuted:    "#6a6a80",
  green:        "#16a34a",
  greenBg:      "rgba(22,163,74,0.08)",
  red:          "#dc2626",
  redBg:        "rgba(220,38,38,0.06)",
  yellow:       "#b45309",
  yellowBg:     "rgba(180,83,9,0.06)",
  // Admin accent colors
  indigo:       "#4338ca",
  indigoBg:     "rgba(67,56,202,0.08)",
  violet:       "#7c3aed",
  violetBg:     "rgba(124,58,237,0.08)",
  teal:         "#0d9488",
  tealBg:       "rgba(13,148,136,0.08)",
};

const STATUS = {
  pending:   { label:"در انتظار",   color:C.yellow,  bg:C.yellowBg },
  approved:  { label:"تأیید شده",  color:C.green,   bg:C.greenBg  },
  rejected:  { label:"رد شده",     color:C.red,     bg:C.redBg    },
  paid:      { label:"پرداخت شده", color:C.green,   bg:C.greenBg  },
  completed: { label:"تکمیل شده",  color:C.green,   bg:C.greenBg  },
  failed:    { label:"ناموفق",     color:C.red,     bg:C.redBg    },
  open:      { label:"باز",        color:C.primary, bg:C.primaryGlow },
  answered:  { label:"پاسخ داده",  color:C.teal,    bg:C.tealBg   },
  closed:    { label:"بسته",       color:C.textMuted,bg:"rgba(0,0,0,0.04)" },
  active:    { label:"فعال",       color:C.green,   bg:C.greenBg  },
  inactive:  { label:"غیرفعال",    color:C.yellow,  bg:C.yellowBg },
  blocked:   { label:"مسدود",      color:C.red,     bg:C.redBg    },
};

const G = `
  @font-face{font-family:'Ray';src:url('/fonts/Ray-Light.ttf') format('truetype');font-weight:300;font-display:swap}
  @font-face{font-family:'Ray';src:url('/fonts/Ray.ttf') format('truetype');font-weight:400;font-display:swap}
  @font-face{font-family:'Ray';src:url('/fonts/Ray-Medium.ttf') format('truetype');font-weight:500;font-display:swap}
  @font-face{font-family:'Ray';src:url('/fonts/Ray-Bold.ttf') format('truetype');font-weight:700;font-display:swap}
  @font-face{font-family:'Ray';src:url('/fonts/Ray-ExtraBold.ttf') format('truetype');font-weight:800;font-display:swap}
  @font-face{font-family:'Ray';src:url('/fonts/Ray-Black.ttf') format('truetype');font-weight:900;font-display:swap}
  @font-face{font-family:'Ray';src:url('/fonts/Ray-ExtraBlack.ttf') format('truetype');font-weight:950;font-display:swap}
  *,*::before,*::after{box-sizing:border-box;margin:0;padding:0}
  html{scroll-behavior:smooth}
  body{background:#F5F5F8;color:#111128;font-family:'Ray',sans-serif;direction:rtl;min-height:100vh;-webkit-font-smoothing:antialiased}
  input:-webkit-autofill{-webkit-box-shadow:0 0 0 100px #fff inset!important;-webkit-text-fill-color:#1a1a2e!important}
  ::-webkit-scrollbar{width:4px;height:4px}::-webkit-scrollbar-thumb{background:rgba(47,44,121,0.18);border-radius:2px}
  @keyframes fadeUp{from{opacity:0;transform:translateY(18px)}to{opacity:1;transform:translateY(0)}}
  @keyframes fadeIn{from{opacity:0}to{opacity:1}}
  @keyframes slideRight{from{transform:translateX(100%)}to{transform:translateX(0)}}
  @keyframes slideLeft{from{transform:translateX(-100%)}to{transform:translateX(0)}}
  @keyframes spin{from{transform:rotate(0deg)}to{transform:rotate(360deg)}}
  @keyframes pulse{0%,100%{opacity:1}50%{opacity:.5}}
  .fade-up{animation:fadeUp .35s ease both}
  .fade-in{animation:fadeIn .22s ease both}
  .admin-sidebar{background:#fff;border-left:1px solid rgba(0,0,0,0.07);width:230px;flex-shrink:0;height:100vh;position:sticky;top:0;display:flex;flex-direction:column;overflow-y:auto}
  @media(max-width:768px){.admin-sidebar{display:none}.admin-mobile-nav{display:flex!important}}
  .admin-mobile-nav{display:none;position:fixed;bottom:0;left:0;right:0;z-index:200;background:#fff;border-top:1px solid rgba(0,0,0,0.08);padding:8px 4px 14px;overflow-x:auto;gap:2px}
  .admin-layout{display:flex;min-height:100vh;direction:rtl}
  .admin-content{flex:1;min-width:0;overflow-x:hidden;background:#F5F5F8}
  .dashboard-grid{display:grid;grid-template-columns:1fr 1fr;gap:16px}
  @media(max-width:1100px){.dashboard-grid{grid-template-columns:1fr}}
`;

const Logo = ({ size=48, white=false }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 42.52 36.62"
    width={size} height={size*36.62/42.52} style={{display:"block",flexShrink:0}}>
    <path fill={white?"#fff":"#26247b"} d="M28.38,12.62V3.93c0-.39-.21-.76-.55-.96L23.09.16c-.3-.18-.66-.2-.98-.07l-7.28,2.93c-.42.17-.7.58-.7,1.03v7.65h0s5.1,3.28,5.1,3.28c.24.15.53.21.81.16l7.44-1.42c.53-.1.9-.56.9-1.09Z"/>
    <polygon fill={white?"rgba(255,255,255,0.6)":"#e6e7e8"} points="20.59 10.94 19.01 9.73 16.18 10.87 19.91 13.25 25.96 12.1 25.96 12.1 23.17 10.45 20.59 10.94"/>
    <path fill={white?"#fff":"#26247b"} d="M21.82,4.51h-.75c-.54,0-.76.05-.97.29l-1.09,4.93,1.58,1.21,2.58-.49-1.35-5.93Z"/>
    <path fill={white?"rgba(255,255,255,0.5)":"#a7a9ac"} d="M25.96,12.1l-2.12-9.77-.02.02h0l-.03-.02h-2.69c-.55,0-1.06.09-1.52.27l-.17.07c-.08.03-.15.07-.22.11-.01,0-.03.01-.04.02-.04.02-.07.04-.1.06-.55.32-.98.76-1.22,1.3l-.04.1-1.59,6.63,2.82-1.14,1.09-4.93c.21-.24.43-.29.97-.29h.75l1.35,5.93,2.79,1.65Z"/>
    <path fill={white?"#fff":"#26247b"} d="M14.84,36.53h-1.1v-4.35h-.03l-1.31,4.35h-1.07l-1.26-4.36h-.03v4.36h-1.08v-5.55h1.76l1.17,4.06h.03l1.17-4.06h1.76v5.55Z"/>
    <path fill={white?"#fff":"#26247b"} d="M17.71,32.45c-1.39,0-2.06.82-2.06,2.1,0,1.2.5,2.07,1.95,2.07s2.03-.85,2.03-2.15c0-1.18-.54-2.02-1.92-2.02ZM18.43,35.76h-1.56v-2.44h1.56v2.44Z"/>
    <path fill={white?"#fff":"#26247b"} d="M21.51,33.93l1.32-1.4h1.28l-1.33,1.43,1.43,2.56h-1.28l-1.04-1.82-.38.38v1.45h-1.16v-5.79h1.16v3.19Z"/>
    <path fill={white?"#fff":"#26247b"} d="M28.39,35.8c-.1.03-.17.05-.24.05-.2,0-.24-.09-.24-.31v-1.67c0-1-.54-1.41-1.6-1.41s-1.56.44-1.69,1.2l.98.19c.08-.39.22-.55.61-.55.51,0,.57.28.57.73v.15c-1.03,0-2.29.18-2.29,1.4,0,.4.19,1.07,1.19,1.07.55,0,.94-.18,1.19-.51.08.38.36.51.82.51.25,0,.58-.08.74-.15l-.03-.67ZM26.79,35.8l-1.29-.15v-.67l1.29-.15v.97Z"/>
    <path fill={white?"#fff":"#26247b"} d="M35.51,32.45c-.49,0-.88.13-1.2.44v-2.15h-1.13v5.79h.97l.05-.34h.02c.25.25.61.43,1.1.43.96,0,1.66-.61,1.66-2.18,0-1.47-.67-1.99-1.47-1.99ZM35.77,35.55l-1.44-.15v-1.73l1.44-.15v2.02Z"/>
    <path fill={white?"#fff":"#26247b"} d="M32.73,35.8c-.1.03-.17.05-.24.05-.2,0-.24-.09-.24-.31v-1.67c0-1-.54-1.41-1.6-1.41s-1.56.44-1.69,1.2l.98.19c.08-.39.22-.55.61-.55.51,0,.57.28.57.73v.15c-1.03,0-2.29.18-2.29,1.4,0,.4.19,1.07,1.19,1.07.55,0,.94-.18,1.19-.51.08.38.36.51.82.51.25,0,.58-.08.74-.15l-.03-.67ZM31.13,35.8l-1.29-.15v-.67l1.29-.15v.97Z"/>
    <path fill={white?"#fff":"#26247b"} d="M42.52,28.69l-2.04-9.39h-2.64c-1.46,0-2.69.69-3.15,1.75l-.04.09-1.31,5.45c-.13.29-.45.76-1.82.76-.67,0-.96-.16-1.06-.24-.09-.07-.14-.13-.14-.29v-1.04s0-.04,0-.06h0c0-1.14-.53-3.8-.79-5.15l7.04-3.14.02-2.32-9.67,4.31.19.94c.22,1.09.79,4.12.82,5.29-.06.26-.17.84-.89,1.34-.85.58-2.3.46-3.42.04,1.19-.69,1.75-2.06,1.75-3.85v-3.87h-8.98v5.81l2.95,1.8c-.17.06-.35.12-.54.18-.94.3-2.07.36-3.01.17-.78-.16-1.34-.47-1.5-.85-.13-.57-.21-4.69-.22-7.12h-2.38c0,2,.04,5.06.18,6.77-.98.67-2.78,1.58-5.28,1.58-2.8,0-3.44-.77-3.71-1.26-.52-.96-.52-4.22-.52-7.08H0c0,3.46,0,6.73.81,8.22,1.02,1.88,3.01,2.26,5.68,2.26s4.82-.9,6.1-1.66c.92,1.11,2.59,1.64,4.35,1.64.88,0,1.77-.13,2.6-.39.87-.27,1.61-.58,2.26-.94,2.03,1.8,5.19,1.55,6.49.46.1-.08.2-.18.32-.28.14.16.3.31.48.44.63.46,1.46.69,2.46.69,1.44,0,2.54-.38,3.29-1.14l1.89,1.21,5.81-1.11ZM23.26,23.52c0,1.42-.97,2.19-1.5,2.45-1-.67-3.2-1.98-3.26-2.03v-2.26h4.76v1.84ZM36.88,21.68c.21-.23.42-.28.94-.28h.72l1.3,5.7-2.48.47-1.52-1.16,1.05-4.73Z"/>
    <rect fill={white?"#fff":"#26247b"} x="4.48" y="30.93" width="2.65" height="2.65"/>
  </svg>
);

const Spinner = ({size=20,color=C.primary}) => (
  <div style={{width:size,height:size,border:`2px solid ${color}22`,borderTop:`2px solid ${color}`,
    borderRadius:"50%",animation:"spin .8s linear infinite",display:"inline-block",flexShrink:0}} />
);

// ─── Toast ───────────────────────────────────────────────────────────────────
const useToast = () => {
  const [t, setT] = useState(null);
  const show = useCallback((msg, type="success") => {
    setT({msg,type});
    setTimeout(() => setT(null), 3500);
  }, []);
  const El = t ? (
    <div style={{position:"fixed",bottom:82,left:"50%",transform:"translateX(-50%)",zIndex:9999,
      background:"#fff",boxShadow:"0 8px 32px rgba(0,0,0,0.14)",
      border:`1px solid ${({success:C.green,error:C.red,warning:C.yellow})[t.type]||C.border}`,
      borderRadius:14,padding:"12px 18px",display:"flex",alignItems:"center",gap:10,
      maxWidth:340,animation:"fadeUp .3s ease",fontFamily:"Ray,sans-serif"}}>
      <div style={{width:22,height:22,borderRadius:"50%",flexShrink:0,display:"flex",alignItems:"center",justifyContent:"center",
        fontSize:12,fontWeight:900,
        background:`${({success:C.green,error:C.red,warning:C.yellow})[t.type]||C.border}18`,
        color:({success:C.green,error:C.red,warning:C.yellow})[t.type]||C.border}}>
        {t.type==="success"?"✓":t.type==="error"?"✕":"!"}
      </div>
      <div style={{fontSize:14,color:C.text,flex:1}}>{t.msg}</div>
      <button onClick={()=>setT(null)} style={{background:"none",border:"none",color:C.textMuted,cursor:"pointer",fontSize:18,lineHeight:1}}>×</button>
    </div>
  ) : null;
  return {show, El};
};

// ─── Modal ───────────────────────────────────────────────────────────────────
const Modal = ({title, onClose, children, wide}) => (
  <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.28)",
    display:"flex",alignItems:"center",justifyContent:"center",zIndex:600,backdropFilter:"blur(3px)",padding:"20px",boxSizing:"border-box"}}
    onClick={onClose}>
    <div style={{background:"#fff",borderRadius:"22px",padding:"8px 22px 28px",
      width:"100%",maxWidth:wide?640:480,maxHeight:"88vh",overflowY:"auto",
      animation:"fadeUp .3s ease",boxShadow:"0 20px 60px rgba(0,0,0,0.18)"}}
      onClick={e=>e.stopPropagation()}>
      <div style={{width:40,height:4,background:C.border,borderRadius:2,margin:"8px auto 18px"}} />
      {title && <div style={{fontSize:16,fontWeight:700,color:C.text,marginBottom:18,paddingBottom:14,borderBottom:`1px solid ${C.border}`}}>{title}</div>}
      {children}
    </div>
  </div>
);

// ─── Drawer ───────────────────────────────────────────────────────────────────
const Drawer = ({open, onClose, title, children}) => {
  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "";
    return () => { document.body.style.overflow = ""; };
  }, [open]);
  if (!open) return null;
  return (
    <div style={{position:"fixed",inset:0,zIndex:500}} onClick={onClose}>
      <div style={{position:"absolute",inset:0,background:"rgba(0,0,0,0.22)",backdropFilter:"blur(4px)",animation:"fadeIn .25s ease"}} />
      <div style={{position:"absolute",top:0,right:0,bottom:0,width:"min(480px,96%)",
        background:"#fff",borderLeft:`1px solid ${C.border}`,display:"flex",flexDirection:"column",
        animation:"slideRight .3s cubic-bezier(.25,.46,.45,.94) both",boxShadow:"-8px 0 32px rgba(0,0,0,0.07)"}}
        onClick={e=>e.stopPropagation()}>
        <div style={{padding:"16px 20px",borderBottom:`1px solid ${C.border}`,display:"flex",
          justifyContent:"space-between",alignItems:"center",flexShrink:0,background:"rgba(47,44,121,0.03)"}}>
          <div style={{fontSize:16,fontWeight:700,color:C.text}}>{title}</div>
          <button onClick={onClose} style={{background:"none",border:"none",color:C.textMuted,cursor:"pointer",fontSize:24,lineHeight:1}}>×</button>
        </div>
        <div style={{flex:1,overflowY:"auto",padding:"22px 20px"}}>{children}</div>
      </div>
    </div>
  );
};

// ─── UI Primitives ────────────────────────────────────────────────────────────
const Input = ({label, error, style:s, type, onChange, value, ...props}) => {
  const isNum = type === "number";
  const displayVal = isNum && value !== "" && value !== undefined
    ? numFa(String(value).replace(/\B(?=(\d{3})+(?!\d))/g, ","))
    : value;
  const handleChange = isNum ? (e => {
    const raw = e.target.value.replace(/[,،٬]/g,"").replace(/[۰-۹]/g, d => String.fromCharCode(d.charCodeAt(0)-1728));
    if(onChange) onChange({...e, target:{...e.target, value: raw.replace(/[^0-9.]/g,"")}});
  }) : onChange;
  return (
  <div style={{marginBottom:14}}>
    {label && <div style={{fontSize:13,fontWeight:600,color:C.textSub,marginBottom:5}}>{label}</div>}
    <input {...props} type={isNum?"text":type} inputMode={isNum?"decimal":undefined}
      value={isNum ? displayVal : value}
      onChange={handleChange}
      style={{width:"100%",padding:"11px 14px",borderRadius:12,
      border:`1.5px solid ${error ? C.red : C.border}`,background:"#fff",
      color:C.text,fontSize:14,fontFamily:"Ray,sans-serif",direction:"rtl",outline:"none",...s}}
      onFocus={e=>e.target.style.borderColor=C.primary}
      onBlur={e=>e.target.style.borderColor=error?C.red:C.border} />
    {error && <div style={{fontSize:12,color:C.red,marginTop:3}}>{error}</div>}
  </div>
);};

const Select = ({label, children, ...props}) => (
  <div style={{marginBottom:14}}>
    {label && <div style={{fontSize:13,fontWeight:600,color:C.textSub,marginBottom:5}}>{label}</div>}
    <select {...props} style={{width:"100%",padding:"11px 14px",borderRadius:12,
      border:`1.5px solid ${C.border}`,background:"#fff",color:C.text,
      fontSize:14,fontFamily:"Ray,sans-serif",outline:"none",direction:"rtl",...props.style}}>
      {children}
    </select>
  </div>
);

const Btn = ({children, variant="primary", size="md", loading, fullWidth, ...props}) => {
  const V = {
    primary: {background:`linear-gradient(135deg,${C.primaryLight},${C.primary})`,color:"#fff",border:"none",boxShadow:"0 2px 8px rgba(47,44,121,0.18)"},
    white:   {background:"#fff",color:C.primary,border:"none"},
    outline: {background:"transparent",color:C.textSub,border:`1.5px solid ${C.border}`},
    ghost:   {background:"#EDEDF2",color:C.textSub,border:"none"},
    green:   {background:C.greenBg,color:C.green,border:`1px solid ${C.green}44`},
    red:     {background:C.redBg,color:C.red,border:`1px solid ${C.red}44`},
    danger:  {background:C.red,color:"#fff",border:"none",boxShadow:"0 2px 8px rgba(220,38,38,0.2)"},
    brand:   {background:C.primary,color:"#fff",border:"none"},
    yellow:  {background:C.yellowBg,color:C.yellow,border:`1px solid ${C.yellow}44`},
  };
  const S = {
    sm: {padding:"7px 13px",fontSize:13,borderRadius:9},
    md: {padding:"11px 18px",fontSize:14,borderRadius:12},
    lg: {padding:"14px 26px",fontSize:15,borderRadius:14},
  };
  return (
    <button {...props} disabled={loading||props.disabled} style={{
      ...V[variant],...S[size],cursor:props.disabled||loading?"not-allowed":"pointer",
      fontFamily:"Ray,sans-serif",fontWeight:700,width:fullWidth?"100%":"auto",
      opacity:props.disabled||loading?.6:1,transition:"all .18s",
      display:"inline-flex",alignItems:"center",justifyContent:"center",gap:7,
      flexShrink:0,...props.style}}
      onMouseEnter={e=>{if(!props.disabled&&!loading)e.currentTarget.style.opacity=".82"}}
      onMouseLeave={e=>{if(!props.disabled&&!loading)e.currentTarget.style.opacity="1"}}>
      {loading ? <Spinner size={15} color={variant==="white"||variant==="ghost"||variant==="outline"?C.primary:"#fff"} /> : children}
    </button>
  );
};

const Card = ({children, style, onClick, noPad}) => (
  <div onClick={onClick} style={{background:C.bgCard,border:`1px solid ${C.border}`,
    borderRadius:14,padding:noPad?0:16,transition:"all .18s",cursor:onClick?"pointer":"default",...style}}
    onMouseEnter={e=>{if(onClick){e.currentTarget.style.background=C.bgCardHover;e.currentTarget.style.borderColor=`${C.primary}22`;}}}
    onMouseLeave={e=>{if(onClick){e.currentTarget.style.background=C.bgCard;e.currentTarget.style.borderColor=C.border;}}}>
    {children}
  </div>
);

const Badge = ({status, label}) => {
  const s = STATUS[status] || {label:label||status, color:C.textMuted, bg:"rgba(0,0,0,0.04)"};
  return <span style={{fontSize:12,padding:"3px 9px",borderRadius:20,fontWeight:700,
    background:s.bg,color:s.color,border:`1px solid ${s.color}33`,display:"inline-block",whiteSpace:"nowrap"}}>
    {s.label}
  </span>;
};

const Empty = ({text="موردی یافت نشد", icon}) => (
  <div style={{textAlign:"center",padding:"52px 16px",color:C.textMuted}}>
    <div style={{marginBottom:12,opacity:.28}}>{icon||<IconEmpty />}</div>
    <div style={{fontSize:14}}>{text}</div>
  </div>
);

// ─── Icons ────────────────────────────────────────────────────────────────────
const iconProps = (active) => ({width:20,height:20,viewBox:"0 0 24 24",fill:"none",
  stroke:active?C.primary:"#6a6a80",strokeWidth:1.8,strokeLinecap:"round",strokeLinejoin:"round"});

const IconDashboard = ({active}) => <svg {...iconProps(active)}><rect x="3" y="3" width="7" height="7" rx="1"/><rect x="14" y="3" width="7" height="7" rx="1"/><rect x="3" y="14" width="7" height="7" rx="1"/><rect x="14" y="14" width="7" height="7" rx="1"/></svg>;
const IconBuy       = ({active}) => <svg {...iconProps(active)}><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 01-8 0"/></svg>;
const IconSell      = ({active}) => <svg {...iconProps(active)}><polyline points="23 6 13.5 15.5 8.5 10.5 1 18"/><polyline points="17 6 23 6 23 12"/></svg>;
const IconCharge    = ({active}) => <svg {...iconProps(active)}><rect x="1" y="4" width="22" height="16" rx="2"/><line x1="1" y1="10" x2="23" y2="10"/></svg>;
const IconWithdraw  = ({active}) => <svg {...iconProps(active)}><polyline points="17 11 12 6 7 11"/><line x1="12" y1="6" x2="12" y2="18"/><rect x="4" y="18" width="16" height="2" rx="1"/></svg>;
const IconDelivery  = ({active}) => <svg {...iconProps(active)}><rect x="1" y="3" width="15" height="13" rx="1"/><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg>;
const IconBank      = ({active}) => <svg {...iconProps(active)}><rect x="2" y="7" width="20" height="15" rx="2"/><polyline points="16 7 12 3 8 7"/><line x1="12" y1="3" x2="12" y2="7"/></svg>;
const IconTicket    = ({active}) => <svg {...iconProps(active)}><path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z"/></svg>;
const IconUsers     = ({active}) => <svg {...iconProps(active)}><path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 00-3-3.87"/><path d="M16 3.13a4 4 0 010 7.75"/></svg>;
const IconLogs      = ({active}) => <svg {...iconProps(active)}><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/><polyline points="10 9 9 9 8 9"/></svg>;
const IconSettings  = ({active}) => <svg {...iconProps(active)}><circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 00.33 1.82l.06.06a2 2 0 010 2.83 2 2 0 01-2.83 0l-.06-.06a1.65 1.65 0 00-1.82-.33 1.65 1.65 0 00-1 1.51V21a2 2 0 01-4 0v-.09A1.65 1.65 0 009 19.4a1.65 1.65 0 00-1.82.33l-.06.06a2 2 0 01-2.83-2.83l.06-.06A1.65 1.65 0 004.68 15a1.65 1.65 0 00-1.51-1H3a2 2 0 010-4h.09A1.65 1.65 0 004.6 9a1.65 1.65 0 00-.33-1.82l-.06-.06a2 2 0 012.83-2.83l.06.06A1.65 1.65 0 009 4.68a1.65 1.65 0 001-1.51V3a2 2 0 014 0v.09a1.65 1.65 0 001 1.51 1.65 1.65 0 001.82-.33l.06-.06a2 2 0 012.83 2.83l-.06.06A1.65 1.65 0 0019.4 9a1.65 1.65 0 001.51 1H21a2 2 0 010 4h-.09a1.65 1.65 0 00-1.51 1z"/></svg>;
const IconEmpty     = () => <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke={C.textMuted} strokeWidth="1.5"><circle cx="12" cy="12" r="10"/><path d="M8 15h8M9 9h.01M15 9h.01"/></svg>;
const IconCheck     = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"><polyline points="20 6 9 17 4 12"/></svg>;
const IconX         = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>;
const IconSend      = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><line x1="22" y1="2" x2="11" y2="13"/><polygon points="22 2 15 22 11 13 2 9 22 2"/></svg>;
const IconBack      = () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke={C.textSub} strokeWidth="2" strokeLinecap="round"><polyline points="9 18 15 12 9 6"/></svg>;
const IconFile      = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/><polyline points="14 2 14 8 20 8"/></svg>;

// ─── Stat Card ────────────────────────────────────────────────────────────────
const StatCard = ({label, value, sub, color, icon}) => (
  <Card style={{display:"flex",alignItems:"center",gap:14,padding:"16px"}}>
    {icon && <div style={{width:44,height:44,borderRadius:12,display:"flex",alignItems:"center",
      justifyContent:"center",background:color?`${color}12`:"rgba(47,44,121,0.07)",
      border:`1px solid ${color||C.primary}1a`,flexShrink:0}}>
      {icon}
    </div>}
    <div style={{flex:1,minWidth:0}}>
      <div style={{fontSize:12,color:C.textMuted,marginBottom:3}}>{label}</div>
      <div style={{fontSize:20,fontWeight:800,color:color||C.text,lineHeight:1}}>{value}</div>
      {sub && <div style={{fontSize:12,color:C.textMuted,marginTop:3}}>{sub}</div>}
    </div>
  </Card>
);

// ─── Section Header ───────────────────────────────────────────────────────────
const SectionHeader = ({title, count, color, action}) => (
  <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:16}}>
    <div style={{display:"flex",alignItems:"center",gap:10}}>
      <div style={{width:3,height:22,borderRadius:2,background:color||C.primary}} />
      <div style={{fontSize:16,fontWeight:800,color:C.text}}>{title}</div>
      {count!=null && count>0 && <span style={{fontSize:12,fontWeight:700,padding:"2px 8px",
        borderRadius:20,background:`${color||C.primary}15`,color:color||C.primary,
        border:`1px solid ${color||C.primary}33`}}>{numFa(count)}</span>}
    </div>
    {action}
  </div>
);

// ─── Tab Bar ──────────────────────────────────────────────────────────────────
const TabBar = ({tabs, active, onChange}) => (
  <div style={{display:"flex",background:C.bgCard,borderRadius:12,padding:3,
    marginBottom:16,border:`1px solid ${C.border}`,overflowX:"auto",gap:2}}>
    {tabs.map(([k,l,color]) => {
      const s = STATUS[k]||{};
      const c = color||(s.color)||C.primary;
      return (
        <button key={k} onClick={()=>onChange(k)} style={{flex:"1 0 auto",padding:"8px 12px",border:"none",cursor:"pointer",
          fontFamily:"Ray,sans-serif",fontSize:13,fontWeight:700,borderRadius:9,transition:"all .18s",
          background:active===k?`${c}14`:"transparent",color:active===k?c:C.textMuted,
          whiteSpace:"nowrap"}}>{l}</button>
      );
    })}
  </div>
);

// ─── Login Screens (unchanged) ────────────────────────────────────────────────
function LoginScreen({onLogin}) {
  const [mobile,setMobile]     = useState("");
  const [password,setPassword] = useState("");
  const [name,setName]         = useState("");
  const [mode,setMode]         = useState("login");
  const [loading,setLoading]   = useState(false);
  const [error,setError]       = useState("");
  const [prices,setPrices]     = useState(null);
  const [forgotModal,setForgotModal] = useState(false);
  const [forgotMobile,setForgotMobile] = useState("");
  const [forgotMsg,setForgotMsg] = useState("");
  const [forgotLoading,setForgotLoading] = useState(false);
  const {show, El} = useToast();

  useEffect(()=>{fetch("/api/v1/prices").then(r=>r.json()).then(setPrices).catch(()=>{});},[]);

  const submit = async () => {
    setError("");
    if (!mobile||!password) { setError("همه فیلدها را پر کنید"); return; }
    if (mode==="register" && (!name||name.trim().length<3)) { setError("نام و نام خانوادگی را کامل وارد کنید"); return; }
    setLoading(true);
    try {
      if (mode==="register") {
        await req("POST","/auth/register",{mobile,password,name});
        show("ثبت‌نام موفق","success"); setMode("login"); setName("");
      } else {
        const r = await req("POST","/auth/login",{mobile,password});
        setToken(r.token); setRole("user"); onLogin("user",r.user);
      }
    } catch(e) { setError(e.message); }
    setLoading(false);
  };

  const submitForgot = async () => {
    if (!forgotMobile) { setForgotMsg("شماره موبایل را وارد کنید"); return; }
    setForgotLoading(true);
    try {
      await req("POST","/user/tickets/public",{
        mobile: forgotMobile,
        subject: "فراموشی رمز عبور",
        category: "other",
        message: `کاربر با شماره ${forgotMobile} رمز عبور خود را فراموش کرده و درخواست بازیابی دارد.`
      });
      setForgotMsg("تیکت شما ثبت شد. پشتیبانی در اسرع وقت با شما تماس می‌گیرد.");
    } catch(e) {
      setForgotMsg("خطا در ارسال — لطفاً با پشتیبانی تماس بگیرید.");
    }
    setForgotLoading(false);
  };

  return (
    <div style={{minHeight:"100vh",background:C.bg,display:"flex",flexDirection:"column",overflowY:"auto"}}>
      <style>{G}</style>
      {El}
      <div style={{padding:"56px 24px 20px",textAlign:"center"}}>
        <div style={{display:"flex",justifyContent:"center",marginBottom:14}}><Logo size={90} /></div>
      </div>
      <div style={{flex:1,padding:"0 20px 40px",maxWidth:430,margin:"0 auto",width:"100%"}}>
        <div style={{background:"#fff",borderRadius:24,padding:"26px 20px",border:"1px solid rgba(0,0,0,0.06)",animation:"fadeUp .45s ease"}}>
          <div style={{marginBottom:14}}>
            <div style={{fontSize:20,fontWeight:800,color:C.text,marginBottom:6}}>
              {mode==="login" ? "ورود به حساب کاربری" : "ثبت‌نام در مکعب"}
            </div>
            <div style={{fontSize:14,color:C.textMuted}}>
              {mode==="login" ? "شماره موبایل و رمز عبور خود را وارد کنید" : "حساب جدید بسازید"}
            </div>
          </div>
          {error && <div style={{background:"rgba(220,38,38,0.08)",border:"1px solid rgba(220,38,38,0.15)",borderRadius:12,padding:"10px 14px",marginBottom:14,fontSize:14,color:C.red}}>{error}</div>}
          {mode==="register" && <div style={{marginBottom:13}}><div style={{fontSize:14,color:C.textMuted,marginBottom:5}}>نام کامل</div><input placeholder="نام و نام خانوادگی" value={name} onChange={e=>setName(e.target.value)} style={{width:"100%",padding:"13px 16px",borderRadius:14,border:"1px solid rgba(0,0,0,0.08)",background:"#fff",color:C.text,fontSize:14,fontFamily:"Ray,sans-serif",outline:"none"}} /></div>}
          <div style={{marginBottom:13}}><div style={{fontSize:14,color:C.textMuted,marginBottom:5}}>شماره موبایل</div><input type="tel" placeholder="09..." value={mobile} onChange={e=>setMobile(e.target.value)} style={{width:"100%",padding:"13px 16px",borderRadius:14,border:"1px solid rgba(0,0,0,0.08)",background:"#fff",color:C.text,fontSize:14,fontFamily:"Ray,sans-serif",outline:"none"}} /></div>
          <div style={{marginBottom:14}}><div style={{fontSize:14,color:C.textMuted,marginBottom:5}}>رمز عبور</div><input type="password" placeholder="رمز عبور" value={password} onChange={e=>setPassword(e.target.value)} onKeyDown={e=>e.key==="Enter"&&submit()} style={{width:"100%",padding:"13px 16px",borderRadius:14,border:"1px solid rgba(0,0,0,0.08)",background:"#fff",color:C.text,fontSize:14,fontFamily:"Ray,sans-serif",outline:"none"}} /></div>
          <button onClick={submit} disabled={loading} style={{width:"100%",padding:"15px",borderRadius:14,background:loading?"#F2F2F6":C.primary,color:loading?C.textSub:"#fff",border:"none",fontFamily:"Ray,sans-serif",fontSize:16,fontWeight:800,cursor:loading?"not-allowed":"pointer",display:"flex",alignItems:"center",justifyContent:"center",gap:8,opacity:loading?.7:1}}>
            {loading ? <><Spinner size={18} color={C.primary}/> در حال پردازش...</> : mode==="login" ? "ورود به حساب" : "ثبت‌نام"}
          </button>
          <div style={{textAlign:"center",marginTop:16}}>
            <button onClick={()=>{setMode(m=>m==="login"?"register":"login");setError("");}} style={{background:"none",border:"none",color:C.textMuted,fontSize:14,cursor:"pointer",fontFamily:"Ray,sans-serif"}}>
              {mode==="login" ? "حساب ندارید؟ ثبت‌نام کنید" : "حساب دارید؟ وارد شوید"}
            </button>
          </div>
          {mode==="login" && (
            <div style={{textAlign:"center",marginTop:10}}>
              <button onClick={()=>{setForgotModal(true);setForgotMsg("");setForgotMobile("");}} style={{background:"none",border:"none",color:C.primary,fontSize:13,cursor:"pointer",fontFamily:"Ray,sans-serif"}}>
                رمز عبور را فراموش کردم
              </button>
            </div>
          )}
        </div>
        <div style={{textAlign:"center",marginTop:18,fontSize:12,color:"#aaa"}}>مکعب © ۱۴۰۴</div>
        <div style={{textAlign:"center",marginTop:8}}><button onClick={()=>window.location.hash="admin"} style={{background:"none",border:"none",color:C.textMuted,fontSize:12,cursor:"pointer",fontFamily:"Ray,sans-serif"}}>ورود مدیریت</button> — سامانه هوشمند پس‌انداز با قلک نقره</div>
      </div>

      {forgotModal && (
        <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.28)",display:"flex",alignItems:"flex-end",justifyContent:"center",zIndex:600}} onClick={()=>setForgotModal(false)}>
          <div style={{background:"#fff",borderRadius:"22px 22px 0 0",padding:"8px 22px 40px",width:"100%",maxWidth:480,animation:"fadeUp .3s ease"}} onClick={e=>e.stopPropagation()}>
            <div style={{width:40,height:4,background:C.border,borderRadius:2,margin:"12px auto 20px"}} />
            <div style={{fontSize:16,fontWeight:700,color:C.text,marginBottom:6}}>فراموشی رمز عبور</div>
            <div style={{fontSize:13,color:C.textMuted,marginBottom:8,lineHeight:1.7}}>شماره موبایل خود را وارد کنید. پشتیبانی مکعب در اسرع وقت با شما تماس می‌گیرد.</div><div style={{fontSize:15,fontWeight:700,color:C.primary,marginBottom:16,textAlign:"center"}}>📞 ۰۹۹۱۳۷۹۰۰۷۴</div>
            {forgotMsg ? (
              <div style={{background:forgotMsg.includes("خطا")?C.redBg:C.greenBg,border:`1px solid ${forgotMsg.includes("خطا")?C.red:C.green}33`,borderRadius:12,padding:"12px 14px",fontSize:14,color:forgotMsg.includes("خطا")?C.red:C.green,lineHeight:1.7}}>
                {forgotMsg}
              </div>
            ) : (
              <>
                <div style={{marginBottom:14}}><div style={{fontSize:13,color:C.textMuted,marginBottom:5}}>شماره موبایل</div><input type="tel" placeholder="09..." value={forgotMobile} onChange={e=>setForgotMobile(e.target.value)} style={{width:"100%",padding:"13px 16px",borderRadius:14,border:`1px solid ${C.border}`,background:"#fff",color:C.text,fontSize:14,fontFamily:"Ray,sans-serif",outline:"none"}} /></div>
                <button onClick={submitForgot} disabled={forgotLoading} style={{width:"100%",padding:"14px",borderRadius:14,background:C.primary,color:"#fff",border:"none",fontFamily:"Ray,sans-serif",fontSize:15,fontWeight:700,cursor:"pointer",opacity:forgotLoading?.7:1}}>
                  {forgotLoading?"در حال ارسال...":"ارسال درخواست"}
                </button>
              </>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

// ─── User Panel (unchanged, kept intact) ─────────────────────────────────────
function UserPanel({user:initUser, onLogout}) {
  const [tab,setTab]         = useState("home");
  const [profile,setProfile] = useState(initUser);
  const [prices,setPrices]   = useState({});
  const [drawer,setDrawer]   = useState(null);
  const [unread,setUnread]   = useState(0);
  const [goals,setGoals]     = useState([]);
  const {show,El} = useToast();
  const token = getToken();
  const api = useCallback((m,p,b,f) => req(m,p,b,token,f), [token]);

  const refresh = useCallback(async () => {
    try {
      const [pr,px,gl,bh] = await Promise.all([api("GET","/user/profile"),api("GET","/prices"),api("GET","/user/goals"),api("GET","/user/bar-holdings")]);
      setProfile({...pr, barHoldings:bh}); setPrices(px); setGoals(gl);
    } catch {}
  }, [api]);

  const loadUnread = useCallback(async () => {
    try { const r = await api("GET","/user/notifications/unread-count"); setUnread(r.count||0); } catch {}
  }, [api]);

  useEffect(() => { refresh(); loadUnread(); }, []);

  const NAV = [
    {key:"home",    label:"خانه",      Icon:({a})=><svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke={a?"#2F2C79":"#444460"} strokeWidth="2" strokeLinecap="round"><path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z"/><polyline points="9,22 9,12 15,12 15,22"/></svg>},
    {key:"goals",   label:"اهداف",     Icon:({a})=><svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke={a?"#2F2C79":"#444460"} strokeWidth="2" strokeLinecap="round"><circle cx="12" cy="12" r="10"/><circle cx="12" cy="12" r="6"/><circle cx="12" cy="12" r="2"/></svg>},
    {key:"history", label:"تراکنش‌ها", Icon:({a})=><svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke={a?"#2F2C79":"#444460"} strokeWidth="2" strokeLinecap="round"><polyline points="22,12 18,12 15,21 9,3 6,12 2,12"/></svg>},
    {key:"profile", label:"پروفایل",   Icon:({a})=><svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke={a?"#2F2C79":"#444460"} strokeWidth="2" strokeLinecap="round"><path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>},
  ];

  return (
    <div style={{minHeight:"100vh",background:C.bg,paddingBottom:72}}>
      <style>{G}</style>
      {El}
      <div style={{position:"sticky",top:0,zIndex:100,background:"#fff",backdropFilter:"blur(16px)",borderBottom:`1px solid ${C.border}`,padding:"12px 18px",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
        <div style={{display:"flex",alignItems:"center",gap:10}}><Logo size={26} /><div style={{fontSize:15,fontWeight:700,color:C.text}}>{profile.first_name || profile.mobile}</div></div>
        <button onClick={()=>{loadUnread();setTab("notifications");}} style={{background:"none",border:"none",cursor:"pointer",position:"relative",color:C.textSub,fontSize:20,lineHeight:1,padding:4}}>
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#2F2C79" strokeWidth="2" strokeLinecap="round"><path d="M18 8A6 6 0 006 8c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.73 21a2 2 0 01-3.46 0"/></svg>
          {unread>0 && <span style={{position:"absolute",top:0,right:0,background:C.red,color:"#fff",fontSize:11,fontWeight:700,borderRadius:"50%",width:16,height:16,display:"flex",alignItems:"center",justifyContent:"center"}}>{unread>9?"9+":unread}</span>}
        </button>
      </div>
      <div style={{maxWidth:480,margin:"0 auto"}}>
        {tab==="home"          && <HomeTab profile={profile} prices={prices} onOpen={setDrawer} goals={goals} onGoalsTab={()=>setTab("goals")} />}
        {tab==="goals"         && <GoalsTab api={api} show={show} profile={profile} prices={prices} />}
        {tab==="history"       && <HistoryTab api={api} />}
        {tab==="profile"       && <ProfileTab profile={profile} api={api} show={show} onRefresh={refresh} onLogout={onLogout} />}
        {tab==="notifications" && <NotificationsTab api={api} show={show} onRead={loadUnread} onBack={()=>setTab("home")} />}
      </div>
      <div style={{position:"fixed",bottom:0,left:0,right:0,zIndex:100,background:"#fff",borderTop:`1px solid ${C.border}`,display:"flex",justifyContent:"space-around",padding:"10px 0 max(14px,env(safe-area-inset-bottom))",backdropFilter:"blur(16px)"}}>
        {NAV.map(n => (
          <button key={n.key} onClick={()=>setTab(n.key)} style={{background:"none",border:"none",cursor:"pointer",display:"flex",flexDirection:"column",alignItems:"center",gap:6,fontFamily:"Ray,sans-serif",opacity:tab===n.key?1:.7,transition:"opacity .2s",padding:"0 16px"}}>
            <n.Icon a={tab===n.key} />
            <span style={{fontSize:12,color:tab===n.key?C.primary:C.textMuted,fontWeight:tab===n.key?700:500}}>{n.label}</span>
          </button>
        ))}
      </div>
      <Drawer open={drawer==="buy"}      onClose={()=>setDrawer(null)} title="خرید ساچمه"><BuyDrawer api={api} show={show} prices={prices} profile={profile} onDone={()=>{setDrawer(null);refresh();}} /></Drawer>
      <Drawer open={drawer==="buybar"}    onClose={()=>setDrawer(null)} title="خرید شمش"><BuyBarDrawer api={api} show={show} prices={prices} profile={profile} onDone={()=>{setDrawer(null);refresh();}} onCharge={()=>setDrawer("charge")} /></Drawer>
      <Drawer open={drawer==="buygold"}   onClose={()=>setDrawer(null)} title="خرید طلا"><BuyGoldDrawer api={api} show={show} profile={profile} onDone={()=>{setDrawer(null);refresh();}} onCharge={()=>setDrawer("charge")} /></Drawer>
      <Drawer open={drawer==="sellbar"}   onClose={()=>setDrawer(null)} title="فروش شمش نقره"><SellBarDrawer api={api} show={show} profile={profile} onDone={()=>{setDrawer(null);refresh();}} /></Drawer>
      <Drawer open={drawer==="sellgold"}  onClose={()=>setDrawer(null)} title="فروش طلا"><SellGoldDrawer api={api} show={show} profile={profile} onDone={()=>{setDrawer(null);refresh();}} /></Drawer>
      <Drawer open={drawer==="sell"}     onClose={()=>setDrawer(null)} title="فروش نقره"><SellDrawer api={api} show={show} prices={prices} profile={profile} onDone={()=>{setDrawer(null);refresh();}} /></Drawer>
      <Drawer open={drawer==="transfer"} onClose={()=>setDrawer(null)} title="انتقال نقره"><TransferDrawer api={api} show={show} profile={profile} onDone={()=>{setDrawer(null);refresh();}} /></Drawer>
      <Drawer open={drawer==="delivery"} onClose={()=>setDrawer(null)} title="تحویل فیزیکی"><DeliveryDrawer api={api} show={show} profile={profile} onDone={()=>{setDrawer(null);refresh();}} onCharge={()=>setDrawer("charge")} /></Drawer>
      <Drawer open={drawer==="charge"}   onClose={()=>setDrawer(null)} title="شارژ کیف پول"><ChargeDrawer api={api} show={show} onDone={()=>{setDrawer(null);refresh();}} /></Drawer>
      <Drawer open={drawer==="withdraw"} onClose={()=>setDrawer(null)} title="برداشت از کیف پول"><WithdrawDrawer api={api} show={show} profile={profile} onDone={()=>{setDrawer(null);refresh();}} /></Drawer>
    </div>
  );
}

// ─── User Panel Sub-components (unchanged) ────────────────────────────────────
function GoldPriceInline() {
  return <div style={{fontSize:18,fontWeight:700,color:"#9CA3AF",lineHeight:1}}>به زودی</div>;
}

function HomeTab({profile, prices, onOpen, goals, onGoalsTab}) {
  const [goldPriceHome, setGoldPriceHome] = useState(0);
  useEffect(()=>{fetch("/api/v1/gold-price").then(r=>r.json()).then(d=>setGoldPriceHome(d.price_per_gram_toman||0)).catch(()=>{});},[]);
  const barGram = (profile.barHoldings||[]).reduce((s,h)=>s+h.total_gram,0);
  const silverVal = Math.round((profile.balance_gram||0) * (prices.buy_price||0) + barGram * (prices.buy_price||0) + (profile.balance_gram_gold||0) * goldPriceHome * 10);
  const uTime = (prices.updated_at||"").split(" ")[1]?.substring(0,5)||"";
  const assets = [
    {l:"ساچمه نقره", v:profile.balance_gram||0, show:true},
    {l:"طلای آب‌شده", v:profile.balance_gram_gold||0, show:(profile.balance_gram_gold||0)>0},
    ...((profile.barHoldings||[]).map(h=>({l:`شمش ${numFa(h.weight_gram)}گ نقره`, v:h.total_gram, show:true}))),
  ].filter(a=>a.show);

  const IcoSilver = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"><circle cx="12" cy="12" r="8"/><circle cx="12" cy="12" r="3"/></svg>;
  const IcoGold   = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"><polygon points="12,2 15.09,8.26 22,9.27 17,14.14 18.18,21.02 12,17.77 5.82,21.02 7,14.14 2,9.27 8.91,8.26"/></svg>;
  const IcoBar    = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"><rect x="2" y="8" width="20" height="8" rx="2"/><line x1="6" y1="8" x2="6" y2="16"/><line x1="12" y1="8" x2="12" y2="16"/><line x1="18" y1="8" x2="18" y2="16"/></svg>;
  const IcoBuy    = () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 01-8 0"/></svg>;
  const IcoSell   = () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><line x1="12" y1="5" x2="12" y2="19"/><polyline points="19,12 12,19 5,12"/></svg>;
  const IcoCube   = () => <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#2F2C79" strokeWidth="1.5" strokeLinecap="round"><path d="M21 16V8a2 2 0 00-1-1.73l-7-4a2 2 0 00-2 0l-7 4A2 2 0 003 8v8a2 2 0 001 1.73l7 4a2 2 0 002 0l7-4A2 2 0 0021 16z"/><polyline points="3.27,6.96 12,12.01 20.73,6.96"/><line x1="12" y1="22.08" x2="12" y2="12"/></svg>;

  const iconFor = (l) => {
    if(l.includes("طلا")) return <IcoGold/>;
    if(l.includes("شمش")) return <IcoBar/>;
    return <IcoSilver/>;
  };

  return (
    <div style={{padding:"12px 14px 0",background:"#F6F7FB",minHeight:"100vh",fontFamily:"Ray,sans-serif"}}>

      {/* ── کارت دارایی ── */}
      <div style={{background:"linear-gradient(150deg,#1e1b5e,#2F2C79)",borderRadius:28,padding:"20px",marginBottom:20,boxShadow:"0 8px 28px rgba(47,44,121,0.22)"}}>
        
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:16}}>
          <div>
            <div style={{fontSize:11,color:"rgba(255,255,255,0.5)",marginBottom:4}}>ارزش کل دارایی</div>
            <div style={{fontSize:34,fontWeight:900,color:"#fff",lineHeight:1,letterSpacing:-1}}>{fmtRial(silverVal)}</div>
            <div style={{fontSize:12,color:"rgba(255,255,255,0.4)",marginTop:3}}>ریال</div>
          </div>

        </div>

        <div style={{background:"rgba(255,255,255,0.07)",borderRadius:14,padding:"10px 12px",marginBottom:14,display:"flex",flexDirection:"column",gap:7}}>
          {assets.map((a,i)=>(
            <div key={i} style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
              <div style={{display:"flex",alignItems:"center",gap:6,color:"rgba(255,255,255,0.5)"}}>
                {iconFor(a.l)}
                <span style={{fontSize:13}}>{a.l}</span>
              </div>
              <span style={{fontSize:14,fontWeight:700,color:"#fff"}}>{fmtGram(a.v)} <span style={{fontSize:11,color:"rgba(255,255,255,0.4)"}}>گرم</span></span>
            </div>
          ))}
        </div>

        <div style={{fontSize:11,color:"rgba(255,255,255,0.35)",textAlign:"left"}}>بروزرسانی {numFa(uTime)}</div>
      </div>

      {/* ── قیمت لحظه‌ای ── */}
      {(()=>{
        const uAt = prices.updated_at||"";
        const uParts = uAt.split(" ");
        const uDate = uParts[0]||"";
        const uTime2 = uParts[1]?.substring(0,5)||"";
        const nowMs = Date.now();
        const uMs = uAt ? new Date(uAt.replace(" ","T")).getTime() : 0;
        const diffMin = uMs ? Math.floor((nowMs - uMs)/60000) : 999;
        const isStale = diffMin > 10;
        const jalaliDate = uDate ? fmtDateFa(uDate) : "";
        return (
          <div style={{background:"#fff",borderRadius:24,padding:"24px 20px",marginBottom:20,border:"1px solid #ECECEC",boxShadow:"0 8px 30px rgba(0,0,0,0.04)"}}>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:16}}>
              <div style={{display:"flex",alignItems:"center",gap:6}}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#2F2C79" strokeWidth="2" strokeLinecap="round"><polyline points="22,12 18,12 15,21 9,3 6,12 2,12"/></svg>
                <span style={{fontSize:14,fontWeight:700,color:"#111827"}}>قیمت لحظه‌ای نقره</span>
              </div>
              <div style={{textAlign:"left"}}>
                  <div style={{fontSize:10,color:"#9CA3AF"}}>آخرین بروزرسانی</div>
                  <div style={{fontSize:11,fontWeight:600,color:"#6B7280"}}>{jalaliDate} {numFa(uTime2)}</div>
                </div>
            </div>
            <div style={{display:"grid",gridTemplateColumns:"1fr 1px 1fr",gap:0,alignItems:"center"}}>
              <div style={{paddingLeft:8}}>
                <div style={{fontSize:12,color:"#9CA3AF",marginBottom:6}}>نقره</div>
                <div style={{fontSize:42,fontWeight:800,color:"#2F2C79",lineHeight:1,letterSpacing:-1}}>{fmtRial(Math.round((prices.sell_price||0)/10))}</div>
                <div style={{fontSize:12,color:"#9CA3AF",marginTop:4}}>ریال / گرم</div>
              </div>
              <div style={{background:"#F3F4F6",height:60,width:1}} />
              <div style={{paddingRight:8,textAlign:"left"}}>
                <div style={{fontSize:12,color:"#9CA3AF",marginBottom:6}}>طلای آب‌شده</div>
                <GoldPriceInline/>
                <div style={{fontSize:12,color:"#9CA3AF",marginTop:4}}>ریال / گرم</div>
              </div>
            </div>
          </div>
        );
      })()}

      {/* ── CTA ── */}
      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10,marginBottom:20}}>
        <button onClick={()=>onOpen("buy")} style={{height:56,borderRadius:16,background:"#2F2C79",color:"#fff",border:"none",fontFamily:"Ray,sans-serif",fontSize:15,fontWeight:800,cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center",gap:8}}>
          <IcoBuy/> خرید نقره
        </button>
        <button onClick={()=>onOpen("sell")} style={{height:56,borderRadius:16,background:"#fff",color:"#2F2C79",border:"2px solid #2F2C79",fontFamily:"Ray,sans-serif",fontSize:15,fontWeight:800,cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center",gap:8}}>
          <IcoSell/> فروش نقره
        </button>
      </div>

      {/* ── خدمات ── */}
      <div style={{marginBottom:20}}>
        <div style={{fontSize:11,fontWeight:600,color:"#9CA3AF",letterSpacing:0.5,marginBottom:12}}>خدمات</div>
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10}}>
          {[
            {k:"buygold",  l:"خرید طلا",      sub:"خرید آنلاین طلای آب‌شده",   color:"#a16207", d:"M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"},
            {k:"sellgold", l:"فروش طلا",      sub:"فروش طلا به مکعب",            color:"#a16207", d:"M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"},
            {k:"buybar",   l:"خرید شمش",      sub:"خرید سهمی از شمش نقره",       color:"#6B7280", d:"M20 7H4a2 2 0 00-2 2v6a2 2 0 002 2h16a2 2 0 002-2V9a2 2 0 00-2-2z"},
            {k:"sellbar",  l:"فروش شمش",      sub:"فروش شمش نقره به مکعب",      color:"#6B7280", d:"M20 7H4a2 2 0 00-2 2v6a2 2 0 002 2h16a2 2 0 002-2V9a2 2 0 00-2-2z"},
            {k:"transfer", l:"انتقال",        sub:"انتقال نقره به دیگران",        color:"#2F2C79", d:"M7 16l-4-4m0 0l4-4m-4 4h18"},
            {k:"delivery", l:"تحویل فیزیکی", sub:"دریافت نقره به‌صورت فیزیکی", color:"#0d9488", d:"M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4"},
            {k:"charge",   l:"شارژ کیف پول", sub:"افزایش موجودی ریالی",          color:"#16A34A", d:"M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z"},
            {k:"withdraw", l:"برداشت وجه",   sub:"برداشت از کیف پول ریالی",     color:"#16A34A", d:"M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2z"},
          ].map(({k,l,sub,color,d})=>(
            <button key={k} onClick={()=>onOpen(k)} style={{display:"flex",flexDirection:"column",alignItems:"flex-start",gap:6,padding:"14px",borderRadius:20,background:"#fff",border:"1px solid #ECECEC",cursor:"pointer",fontFamily:"Ray,sans-serif",boxShadow:"0 6px 24px rgba(0,0,0,0.05)",transition:"transform 180ms",minHeight:110,textAlign:"right"}}
              onMouseEnter={e=>e.currentTarget.style.transform="scale(1.02)"}
              onMouseLeave={e=>e.currentTarget.style.transform="scale(1)"}>
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d={d}/></svg>
              <div>
                <div style={{fontSize:13,fontWeight:700,color:"#111827"}}>{l}</div>
                <div style={{fontSize:11,color:"#9CA3AF",marginTop:2,lineHeight:1.4}}>{sub}</div>
              </div>
            </button>
          ))}
        </div>
      </div>

      {/* ── کیف پول ── */}
      <div style={{background:"#fff",borderRadius:24,padding:"16px",marginBottom:20,border:"1px solid #E5E7EB"}}>
        <div style={{fontSize:11,fontWeight:600,color:"#9CA3AF",letterSpacing:0.5,marginBottom:6}}>کیف پول ریالی</div>
        <div style={{fontSize:22,fontWeight:900,color:"#111827",marginBottom:12}}>{fmtRial(Math.round(profile.balance_rial||0))} <span style={{fontSize:12,color:"#9CA3AF",fontWeight:400}}>ریال</span></div>
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8}}>
          <button onClick={()=>onOpen("charge")} style={{height:44,borderRadius:12,background:"#2F2C79",color:"#fff",border:"none",fontFamily:"Ray,sans-serif",fontSize:14,fontWeight:700,cursor:"pointer"}}>شارژ</button>
          <button onClick={()=>onOpen("withdraw")} style={{height:44,borderRadius:12,background:"#fff",color:"#2F2C79",border:"2px solid #2F2C79",fontFamily:"Ray,sans-serif",fontSize:14,fontWeight:700,cursor:"pointer"}}>برداشت</button>
        </div>
      </div>

      <DashboardGoals goals={goals} onGoalsTab={onGoalsTab} />
      <div style={{height:20}} />
    </div>
  );
}


function DashboardGoals({goals, onGoalsTab}) {
  if (!goals || goals.length === 0) return (<div style={{background:"#fff",border:"1px solid rgba(0,0,0,0.08)",borderRadius:16,padding:"18px",display:"flex",justifyContent:"space-between",alignItems:"center"}}><div><div style={{fontSize:15,fontWeight:700,color:C.text,marginBottom:2}}>اهداف مالی</div><div style={{fontSize:13,color:C.textMuted}}>هنوز هدفی تعریف نکردید</div></div><Btn variant="ghost" size="sm" onClick={onGoalsTab}>+ هدف جدید</Btn></div>);
  const TYPES={car:"🚗",house:"🏠",travel:"✈️",custom:"⭐"};
  return (
    <div style={{background:"#fff",border:"1px solid rgba(0,0,0,0.08)",borderRadius:16,padding:"18px"}}>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:16}}><div style={{fontSize:15,fontWeight:700,color:C.text}}>اهداف مالی</div><button onClick={onGoalsTab} style={{background:"none",border:"none",color:C.primary,cursor:"pointer",fontSize:13,fontFamily:"Ray,sans-serif",fontWeight:600}}>همه ›</button></div>
      {goals.slice(0,3).map((g,i) => {const pct = Math.min(100, g.progress_percent||0);const currentVal = Math.round(g.target_amount_rial * pct / 100);return(<div key={g.id} style={{marginBottom:i<Math.min(2,goals.length-1)?16:0}}><div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:6}}><div style={{display:"flex",alignItems:"center",gap:8}}><span style={{fontSize:16}}>{TYPES[g.type]||"⭐"}</span><span style={{fontSize:14,fontWeight:700,color:C.text}}>{g.title}</span></div><span style={{fontSize:15,fontWeight:900,color:C.primary}}>{numFa(pct.toFixed(0))}%</span></div><div style={{height:8,background:"rgba(47,44,121,0.08)",borderRadius:4,overflow:"hidden",marginBottom:6}}><div style={{height:"100%",borderRadius:4,width:pct+"%",background:"linear-gradient(90deg,#2F2C79,#4340a8)",transition:"width .6s"}} /></div><div style={{fontSize:12,color:C.textMuted}}>{fmtRial(currentVal)} از {fmtRial(g.target_amount_rial)} ریال</div></div>);})}
    </div>
  );
}

function SellBarDrawer({api, show, profile, onDone}) {
  const [bars,setBars]=useState([]);const[barId,setBarId]=useState("");const[gram,setGram]=useState("");const[loading,setL]=useState(false);
  useEffect(()=>{fetch("/api/v1/bars").then(r=>r.json()).then(setBars).catch(()=>{});},[]); 
  const bar=bars.find(b=>b.id===parseInt(barId));
  const buybackPrice=bar?Math.round(bar.price_per_gram_rial*0.94):0;
  const total=Math.round(parseFloat(gram||0)*buybackPrice);
  const maxGram=(profile.balance_gram_bar||0);
  const canSell=parseFloat(gram||0)>0&&barId&&parseFloat(gram)<=maxGram;
  const submit=async()=>{
    setL(true);
    try{
      const r=await api("POST","/user/sell-bar",{bar_id:parseInt(barId),gram:parseFloat(gram)});
      show(`فروش شمش انجام شد — ${r.tracking_code}`,"success");setGram("");onDone();
    }catch(e){show(e.message,"error");}
    setL(false);
  };
  return(<div>
    <div style={{background:"rgba(47,44,121,0.04)",border:`1px solid ${C.border}`,borderRadius:14,padding:"12px 14px",marginBottom:14,fontSize:13,color:C.textSub}}>موجودی شمش: {fmtGram(maxGram)} گرم</div>
    <Select label="نوع شمش" value={barId} onChange={e=>setBarId(e.target.value)}>
      <option value="">انتخاب کنید...</option>
      {bars.map(b=><option key={b.id} value={b.id}>{b.name}</option>)}
    </Select>
    {bar&&<div style={{background:"#F5F5F8",borderRadius:12,padding:"10px 14px",marginBottom:14,fontSize:13,color:C.textMuted}}>قیمت بازخرید: {fmtRial(buybackPrice)} ریال/گرم</div>}
    <Input label="مقدار (گرم)" type="number" value={gram} onChange={e=>setGram(e.target.value)} />
    {parseFloat(gram)>0&&bar&&<div style={{background:"#F5F5F8",borderRadius:12,padding:"10px 14px",marginBottom:14}}><div style={{display:"flex",justifyContent:"space-between"}}><span style={{fontSize:14,color:C.textMuted}}>مبلغ دریافتی</span><span style={{fontSize:15,fontWeight:700,color:C.green}}>{fmtRial(total)} ریال</span></div></div>}
    <Btn variant="primary" fullWidth loading={loading} disabled={!canSell} onClick={submit}>فروش شمش</Btn>
  </div>);
}

function SellGoldDrawer({api, show, profile, onDone}) {
  const [gram,setGram]=useState("");const[loading,setL]=useState(false);const[goldPrice,setGoldPrice]=useState(0);
  useEffect(()=>{fetch("/api/v1/gold-price").then(r=>r.json()).then(d=>setGoldPrice(d.price_per_gram_toman||0)).catch(()=>{});},[]); 
  const buybackPrice=Math.round(goldPrice*0.99);
  const total=Math.round(parseFloat(gram||0)*buybackPrice*10);
  const maxGram=(profile.balance_gram_gold||0);
  const canSell=parseFloat(gram||0)>0&&parseFloat(gram)<=maxGram&&goldPrice>0;
  const submit=async()=>{
    setL(true);
    try{
      const r=await api("POST","/user/sell-gold",{gram:parseFloat(gram)});
      show(`فروش طلا انجام شد — ${r.tracking_code}`,"success");setGram("");onDone();
    }catch(e){show(e.message,"error");}
    setL(false);
  };
  return(<div>
    <div style={{background:"rgba(161,98,7,0.04)",border:"1px solid rgba(161,98,7,0.15)",borderRadius:14,padding:"12px 14px",marginBottom:14}}>
      <div style={{fontSize:13,color:"#a16207",marginBottom:2}}>قیمت بازخرید طلا</div>
      <div style={{fontSize:20,fontWeight:800,color:"#a16207"}}>{fmtRial(buybackPrice)} <span style={{fontSize:12}}>ریال/گرم</span></div>
      <div style={{fontSize:12,color:C.textMuted,marginTop:2}}>موجودی: {fmtGram(maxGram)} گرم</div>
    </div>
    <Input label="مقدار (گرم)" type="number" value={gram} onChange={e=>setGram(e.target.value)} />
    {parseFloat(gram)>0&&goldPrice>0&&<div style={{background:"#F5F5F8",borderRadius:12,padding:"10px 14px",marginBottom:14}}><div style={{display:"flex",justifyContent:"space-between"}}><span style={{fontSize:14,color:C.textMuted}}>مبلغ دریافتی</span><span style={{fontSize:15,fontWeight:700,color:C.green}}>{fmtRial(Math.round(total))} ریال</span></div></div>}
    <Btn variant="primary" fullWidth loading={loading} disabled={!canSell} onClick={submit}>فروش طلا</Btn>
  </div>);
}

function BuyGoldDrawer({api, show, profile, onDone, onCharge}) {
  const [gram,setGram]=useState("");const[method,setMethod]=useState("wallet");const[loading,setL]=useState(false);const fileRef=useRef();const[hasFile,setHasFile]=useState(false);const[goldPrice,setGoldPrice]=useState(0);
  useEffect(()=>{fetch("/api/v1/gold-price").then(r=>r.json()).then(d=>setGoldPrice(d.price_per_gram_toman||0)).catch(()=>{});},[]); 
  const total=Math.round(parseFloat(gram||0)*goldPrice);
  const hasEnough=(profile.balance_rial||0)>=total*10;
  const canBuy=parseFloat(gram||0)>0&&goldPrice>0&&(method!=="wallet"||hasEnough)&&(method!=="bank_transfer"||hasFile);
  const submit=async()=>{
    setL(true);
    try{
      const r=await api("POST","/user/buy-gold",{gram:parseFloat(gram),payment_method:method});
      if(method==="bank_transfer"&&fileRef.current?.files[0]&&r.tracking_code){
        const fd=new FormData();fd.append("tracking_code",r.tracking_code);fd.append("receipt",fileRef.current.files[0]);
        await api("POST","/user/buy-gold/receipt",fd,true);
      }
      show(`خرید طلا ثبت شد — ${r.tracking_code}`,"success");setGram("");onDone();
    }catch(e){show(e.message,"error");}
    setL(false);
  };
  return(<div>
    <div style={{background:"rgba(202,138,4,0.06)",border:"1px solid rgba(202,138,4,0.2)",borderRadius:14,padding:"14px 16px",marginBottom:20}}>
      <div style={{fontSize:13,color:"#a16207",marginBottom:2}}>قیمت لحظه‌ای طلا (۱۸ عیار)</div>
      <div style={{fontSize:24,fontWeight:800,color:"#ca8a04"}}>{fmtRial(goldPrice)} <span style={{fontSize:14,color:"#a16207"}}>ریال/گرم</span></div>
      <div style={{fontSize:12,color:"#a16207",marginTop:4}}>موجودی ریالی: {fmtRial(Math.round(profile.balance_rial||0))} ر</div>
    </div>
    <Input label="مقدار (گرم)" type="number" placeholder="مثال: ۱" value={gram} onChange={e=>setGram(e.target.value)} />
    {parseFloat(gram)>0&&goldPrice>0&&(
      <div style={{background:"#F5F5F8",borderRadius:12,padding:"12px 14px",marginBottom:14}}>
        <div style={{display:"flex",justifyContent:"space-between"}}>
          <span style={{fontSize:15,color:"#555"}}>مبلغ کل</span>
          <span style={{fontSize:15,fontWeight:700}}>{fmtRial(total)} ریال</span>
        </div>
        {method==="wallet"&&!hasEnough&&<div style={{fontSize:13,color:C.red,marginTop:6}}>موجودی کافی نیست — <button onClick={()=>{onDone();onCharge();}} style={{background:"none",border:"none",color:C.primary,cursor:"pointer",fontFamily:"Ray,sans-serif",fontSize:13}}>شارژ کیف پول</button></div>}
      </div>
    )}
    <Select label="روش پرداخت" value={method} onChange={e=>setMethod(e.target.value)}>
      <option value="wallet">کیف پول</option>
      <option value="bank_transfer">کارت به کارت</option>
    </Select>
    {method==="bank_transfer"&&(
      <div style={{marginBottom:16}}>
        <div style={{fontSize:14,color:C.textSub,marginBottom:6}}>آپلود فیش واریز</div>
        <input ref={fileRef} type="file" accept="image/*" onChange={e=>setHasFile(e.target.files?.length>0)} style={{fontSize:14,color:C.textSub,width:"100%"}} />
      </div>
    )}
    <Btn variant="primary" fullWidth loading={loading} disabled={!canBuy} onClick={submit} style={{background:"linear-gradient(135deg,#ca8a04,#a16207)"}}>ثبت سفارش طلا</Btn>
  </div>);
}

function BuyBarDrawer({api, show, prices, profile, onDone, onCharge}) {
  const [bars,setBars]=useState([]);const[barId,setBarId]=useState("");const[gram,setGram]=useState("");const[method,setMethod]=useState("wallet");const[loading,setL]=useState(false);const fileRef=useRef();const[hasFile,setHasFile]=useState(false);
  useEffect(()=>{fetch("/api/v1/bars").then(r=>r.json()).then(setBars).catch(()=>{});},[]); 
  const bar=bars.find(b=>b.id===parseInt(barId));
  const pricePerGram=bar?bar.price_per_gram_rial:0;
  const total=Math.round(parseFloat(gram||0)*pricePerGram);
  const hasEnough=(profile.balance_rial||0)>=total;
  const canBuy=parseFloat(gram||0)>0&&barId&&(method!=="wallet"||hasEnough)&&(method!=="bank_transfer"||hasFile);
  const submit=async()=>{
    setL(true);
    try{
      const r=await api("POST","/user/buy-bar",{bar_id:parseInt(barId),gram:parseFloat(gram),payment_method:method});
      if(method==="bank_transfer"&&fileRef.current?.files[0]&&r.tracking_code){
        const fd=new FormData();fd.append("tracking_code",r.tracking_code);fd.append("receipt",fileRef.current.files[0]);
        await api("POST","/user/buy-bar/receipt",fd,true);
      }
      show(`خرید شمش ثبت شد — ${r.tracking_code}`,"success");setGram("");onDone();
    }catch(e){show(e.message,"error");}
    setL(false);
  };
  return(<div>
    <div style={{background:"rgba(180,83,9,0.06)",border:"1px solid rgba(180,83,9,0.2)",borderRadius:14,padding:"14px 16px",marginBottom:20}}>
      <div style={{fontSize:13,color:"#92400e",marginBottom:2}}>خرید سهمی از شمش نقره</div>
      <div style={{fontSize:12,color:"#78350f",marginTop:4}}>موجودی ریالی: {fmtRial(Math.round(profile.balance_rial||0))} ر</div>
    </div>
    <Select label="نوع شمش" value={barId} onChange={e=>{setBarId(e.target.value);setGram("");}}>
      <option value="">انتخاب کنید...</option>
      {bars.map(b=><option key={b.id} value={b.id}>{b.name} — {fmtRial(b.price_per_gram_rial)} ر/گرم</option>)}
    </Select>
    {bar&&(
      <div style={{background:"#FFF7ED",borderRadius:12,padding:"12px 14px",marginBottom:14,fontSize:13,color:"#92400e"}}>
        حداکثر {numFa(bar.weight_gram)} گرم — قیمت هر گرم: {fmtRial(bar.price_per_gram_rial)} ریال
      </div>
    )}
    <Input label="مقدار (گرم)" type="number" placeholder="مثال: ۱۰" value={gram} onChange={e=>setGram(e.target.value)} />
    {parseFloat(gram)>0&&bar&&(
      <div style={{background:"#F5F5F8",borderRadius:12,padding:"12px 14px",marginBottom:14}}>
        <div style={{display:"flex",justifyContent:"space-between"}}>
          <span style={{fontSize:15,color:"#555"}}>مبلغ کل</span>
          <span style={{fontSize:15,fontWeight:700}}>{fmtRial(total)} ریال</span>
        </div>
        {method==="wallet"&&!hasEnough&&<div style={{fontSize:13,color:C.red,marginTop:6}}>موجودی کافی نیست — <button onClick={()=>{onDone();onCharge();}} style={{background:"none",border:"none",color:C.primary,cursor:"pointer",fontFamily:"Ray,sans-serif",fontSize:13}}>شارژ کیف پول</button></div>}
      </div>
    )}
    <Select label="روش پرداخت" value={method} onChange={e=>setMethod(e.target.value)}>
      <option value="wallet">کیف پول</option>
      <option value="bank_transfer">کارت به کارت</option>
    </Select>
    {method==="bank_transfer"&&(
      <div style={{marginBottom:16}}>
        <div style={{fontSize:14,color:C.textSub,marginBottom:6}}>آپلود فیش واریز</div>
        <input ref={fileRef} type="file" accept="image/*" onChange={e=>setHasFile(e.target.files?.length>0)} style={{fontSize:14,color:C.textSub,width:"100%"}} />
      </div>
    )}
    <Btn variant="primary" fullWidth loading={loading} disabled={!canBuy} onClick={submit} style={{background:"linear-gradient(135deg,#b45309,#92400e)"}}>ثبت سفارش شمش</Btn>
  </div>);
}

function BuyDrawer({api, show, prices, profile, onDone}) {
  const [gram,setGram]=useState("");const[method,setMethod]=useState("wallet");const[loading,setL]=useState(false);const fileRef=useRef();const[hasFile,setHasFile]=useState(false);
  const [companyCard,setCompanyCard]=useState("");const[companyOwner,setCompanyOwner]=useState("");
  useEffect(()=>{fetch("/api/v1/delivery-fee").then(()=>{}).catch(()=>{});fetch("/api/v1/company-info").then(r=>r.json()).then(d=>{setCompanyCard(d.card_number||"");setCompanyOwner(d.card_owner||"");}).catch(()=>{});},[]); 
  const total=Math.round(parseFloat(gram||0)*(prices.sell_price||0));const canBuy=parseFloat(gram||0)>=1&&(method!=="wallet"||(profile.balance_rial||0)>=total*10)&&(method!=="bank_transfer"||hasFile);
  const submit=async()=>{setL(true);try{const r=await api("POST","/user/buy",{gram:parseFloat(gram),payment_method:method});if(method==="bank_transfer"&&fileRef.current?.files[0]&&r.tracking_code){const fd=new FormData();fd.append("tracking_code",r.tracking_code);fd.append("receipt",fileRef.current.files[0]);await api("POST","/user/buy/receipt",fd,true);}show(`خرید ثبت شد — ${r.tracking_code}`,"success");setGram("");onDone();}catch(e){show(e.message,"error");}setL(false);};
  return(<div><div style={{background:"rgba(47,44,121,0.06)",border:`1px solid ${C.primary}33`,borderRadius:14,padding:"14px 16px",marginBottom:20}}><div style={{fontSize:13,color:C.textMuted,marginBottom:2}}>قیمت هر گرم</div><div style={{fontSize:26,fontWeight:800,color:C.text}}>{fmtRial(Math.round((prices.sell_price||0)/10))} <span style={{fontSize:15,color:C.textMuted}}>ریال</span></div><div style={{fontSize:13,color:C.textMuted,marginTop:4}}>موجودی ریالی: {fmtRial(Math.round(profile.balance_rial||0))} ر</div></div><Input label="مقدار (گرم) — حداقل ۱ گرم، فقط عدد صحیح" type="number" step="1" placeholder="مثال: ۵" value={gram} onChange={e=>setGram(e.target.value.replace(/[^0-9۰-۹]/g,""))} /><Select label="روش پرداخت" value={method} onChange={e=>setMethod(e.target.value)}><option value="wallet">کیف پول</option><option value="bank_transfer">کارت به کارت</option></Select>{parseFloat(gram)>0&&(<div style={{background:"#F5F5F8",borderRadius:12,padding:"12px 14px",marginBottom:14}}><div style={{display:"flex",justifyContent:"space-between"}}><span style={{fontSize:15,color:C.textMuted}}>مبلغ کل</span><span style={{fontSize:15,fontWeight:700,color:C.text}}>{fmtRial(total)} ریال</span></div>{method==="wallet"&&(profile.balance_rial||0)<total&&(<div style={{fontSize:14,color:C.red,marginTop:5}}>موجودی کافی نیست</div>)}</div>)}{method==="bank_transfer"&&(<div style={{marginBottom:16}}>{companyCard&&(<div style={{background:`${C.primary}08`,border:`1px solid ${C.primary}22`,borderRadius:12,padding:"12px 14px",marginBottom:12}}><div style={{fontSize:13,color:C.textMuted,marginBottom:4}}>واریز به کارت مکعب</div><div style={{fontSize:17,fontWeight:800,color:C.primary,letterSpacing:2,direction:"ltr",textAlign:"left"}}>{companyCard}</div>{companyOwner&&<div style={{fontSize:13,color:C.textSub,marginTop:2}}>{companyOwner}</div>}</div>)}<div style={{fontSize:14,color:C.textSub,marginBottom:6}}>آپلود فیش واریز</div><input ref={fileRef} type="file" accept="image/*" onChange={e=>setHasFile(e.target.files?.length>0)} style={{fontSize:14,color:C.textSub,width:"100%"}} /></div>)}<Btn variant="primary" fullWidth loading={loading} disabled={!canBuy} onClick={submit}>ثبت سفارش خرید</Btn></div>);
}

function SellDrawer({api, show, prices, profile, onDone}) {
  const [gram,setGram]=useState("");const[method,setMethod]=useState("wallet");const[accountId,setAccId]=useState("");const[accounts,setAccounts]=useState([]);const[lock,setLock]=useState(null);const[timeLeft,setTimeLeft]=useState(0);const[loading,setL]=useState(false);const timerRef=useRef();
  useEffect(()=>{api("GET","/user/bank-accounts").then(r=>setAccounts(r.filter(a=>a.status==="approved"))).catch(()=>{});lockPrice();return()=>{if(timerRef.current)clearInterval(timerRef.current);};},[]);
  useEffect(()=>{if(!lock)return;if(timerRef.current)clearInterval(timerRef.current);timerRef.current=setInterval(()=>{setTimeLeft(p=>{if(p<=1){clearInterval(timerRef.current);setLock(null);show("قیمت منقضی شد","warning");return 0;}return p-1;});},1000);return()=>clearInterval(timerRef.current);},[lock]);
  const lockPrice=async()=>{try{const r=await api("POST","/user/sell/lock-price",{});setLock(r);setTimeLeft(r.expires_seconds);}catch(e){show(e.message,"error");}};
  const lockedPrice=lock?.buy_price||prices.buy_price||0;const total=Math.round(parseFloat(gram||0)*lockedPrice);const profit=Math.round(parseFloat(gram||0)*(lockedPrice-(profile.avg_cost||0)));const canSell=lock&&timeLeft>0&&parseFloat(gram||0)>=1&&(profile.balance_gram||0)>=parseFloat(gram||0)&&(method==="wallet"||accountId);const timerColor=timeLeft>120?C.green:timeLeft>30?C.yellow:C.red;
  const submit=async()=>{setL(true);try{const r=await api("POST","/user/sell",{gram:parseFloat(gram),settlement_method:method,bank_account_id:accountId?parseInt(accountId):undefined});show(`فروش ثبت شد — ${r.tracking_code}`,"success");setGram("");onDone();}catch(e){show(e.message,"error");if(e.message.includes("قیمت نقره تغییر")){setLock(null);lockPrice();}}setL(false);};
  return(<div><div style={{background:lock&&timeLeft>0?`${timerColor}10`:`${C.red}10`,border:`1px solid ${lock&&timeLeft>0?timerColor:C.red}33`,borderRadius:14,padding:"14px 16px",marginBottom:20,display:"flex",justifyContent:"space-between",alignItems:"center"}}><div><div style={{fontSize:13,color:C.textMuted,marginBottom:2}}>قیمت قفل شده</div><div style={{fontSize:22,fontWeight:800,color:lock?C.text:C.textMuted}}>{lock?`${fmtRial(lock.buy_price)} ر/گرم`:"در حال دریافت..."}</div><div style={{fontSize:13,color:C.textMuted,marginTop:4}}>موجودی: {fmtGram(profile.balance_gram)} گرم</div></div>{lock&&timeLeft>0?(<div style={{textAlign:"center",minWidth:58}}><div style={{fontSize:12,color:C.textMuted,marginBottom:2}}>انقضا</div><div style={{fontSize:22,fontWeight:800,color:timerColor,fontVariantNumeric:"tabular-nums"}}>{numFa(Math.floor(timeLeft/60))}:{numFa(String(timeLeft%60).padStart(2,"0"))}</div></div>):(<Btn variant="ghost" size="sm" onClick={lockPrice}>🔒 قفل قیمت</Btn>)}</div><Input label="مقدار (گرم) — حداقل ۱ گرم" type="number" placeholder="مثال: ۱۰" value={gram} onChange={e=>setGram(e.target.value)} /><Select label="روش تسویه" value={method} onChange={e=>setMethod(e.target.value)}><option value="wallet">واریز به کیف پول</option><option value="bank_account">واریز به حساب بانکی</option></Select>{method==="bank_account"&&(accounts.length===0?(<div style={{fontSize:14,color:C.yellow,marginBottom:14}}>ابتدا حساب بانکی تأیید شده اضافه کنید</div>):(<Select label="حساب مقصد" value={accountId} onChange={e=>setAccId(e.target.value)}><option value="">انتخاب کنید...</option>{accounts.map(a=><option key={a.id} value={a.id}>{a.account_owner} — {a.iban||a.card_number}</option>)}</Select>))}{parseFloat(gram)>0&&lock&&(<div style={{background:"#F5F5F8",borderRadius:12,padding:"12px 14px",marginBottom:14}}><div style={{display:"flex",justifyContent:"space-between",marginBottom:4}}><span style={{fontSize:15,color:C.textMuted}}>دریافتی</span><span style={{fontSize:15,fontWeight:700}}>{fmtRial(total)} ر</span></div><div style={{display:"flex",justifyContent:"space-between"}}><span style={{fontSize:15,color:C.textMuted}}>سود/زیان تخمینی</span><span style={{fontSize:14,fontWeight:700,color:profit>=0?C.green:C.red}}>{profit>=0?"+":""}{fmtRial(profit)} ر</span></div></div>)}<Btn variant="primary" fullWidth loading={loading} disabled={!canSell} onClick={submit}>ثبت سفارش فروش</Btn>{(!lock||timeLeft===0)&&(<div style={{fontSize:13,color:C.yellow,textAlign:"center",marginTop:8}}>برای فروش باید قیمت قفل باشد</div>)}</div>);
}

function TransferDrawer({api, show, profile, onDone}) {
  const [step,setStep]=useState(1);const[mobile,setMobile]=useState("");const[rcv,setRcv]=useState(null);const[gram,setGram]=useState("");const[note,setNote]=useState("");const[loading,setL]=useState(false);
  const lookup=async()=>{if(mobile.length!==11){show("شماره موبایل معتبر نیست","error");return;}setL(true);try{const r=await api("GET",`/user/transfer/lookup?mobile=${mobile}`);setRcv(r);setStep(2);}catch(e){show(e.message,"error");}setL(false);};
  const submit=async()=>{setL(true);try{const r=await api("POST","/user/transfer",{to_mobile:mobile,gram:parseFloat(gram),note});show(`انتقال انجام شد — ${r.tracking_code}`,"success");onDone();}catch(e){show(e.message,"error");}setL(false);};
  if(step===1)return(<div><div style={{fontSize:14,color:C.textSub,marginBottom:16,lineHeight:1.8}}>انتقال فقط بین کاربران مکعب — کارمزد صفر<br/>موجودی: {fmtGram(profile.balance_gram)} گرم</div><Input label="شماره موبایل گیرنده" type="tel" placeholder="09..." value={mobile} onChange={e=>setMobile(e.target.value)} onKeyDown={e=>e.key==="Enter"&&lookup()} /><Btn variant="primary" fullWidth loading={loading} disabled={mobile.length<11} onClick={lookup}>جستجوی گیرنده</Btn></div>);
  if(step===2)return(<div><div style={{background:"rgba(47,44,121,0.06)",border:`1px solid ${C.primary}33`,borderRadius:18,padding:"24px",textAlign:"center",marginBottom:24}}><div style={{fontSize:13,color:C.textMuted,marginBottom:8}}>گیرنده یافت شد</div><div style={{fontSize:28,fontWeight:800,color:C.text,marginBottom:4}}>{rcv?.name}</div><div style={{fontSize:15,color:C.textMuted}}>{rcv?.mobile}</div></div><div style={{display:"flex",gap:10}}><Btn variant="outline" style={{flex:1}} onClick={()=>{setStep(1);setRcv(null);}}>اشتباه است</Btn><Btn variant="primary" style={{flex:1}} onClick={()=>setStep(3)}>تأیید گیرنده ✓</Btn></div></div>);
  return(<div><div style={{background:"rgba(47,44,121,0.06)",border:`1px solid ${C.primary}33`,borderRadius:14,padding:"12px 14px",marginBottom:20,display:"flex",justifyContent:"space-between",alignItems:"center"}}><div><div style={{fontSize:13,color:C.textMuted}}>گیرنده تأیید شده</div><div style={{fontSize:15,fontWeight:700}}>{rcv?.name}</div></div><button onClick={()=>setStep(1)} style={{background:"none",border:"none",color:C.textMuted,cursor:"pointer",fontSize:14}}>تغییر</button></div><Input label="مقدار (گرم) — حداقل ۱ گرم، فقط عدد صحیح" type="number" step="1" placeholder="مثال: ۵" value={gram} onChange={e=>setGram(e.target.value.replace(/[^0-9۰-۹]/g,""))} /><Input label="یادداشت (اختیاری)" placeholder="..." value={note} onChange={e=>setNote(e.target.value)} />{parseFloat(gram||0)>0&&(profile.balance_gram||0)<parseFloat(gram||0)&&(<div style={{fontSize:14,color:C.red,marginBottom:12}}>موجودی کافی نیست</div>)}<div style={{display:"flex",gap:10}}><Btn variant="outline" onClick={()=>setStep(2)}>← بازگشت</Btn><Btn variant="primary" style={{flex:1}} loading={loading} disabled={parseFloat(gram||0)<1||(profile.balance_gram||0)<parseFloat(gram||0)} onClick={submit}>انتقال نقره</Btn></div></div>);
}

function DeliveryDrawer({api, show, profile, onDone, onCharge}) {
  const [gram,setGram]=useState("");const[addrId,setAddrId]=useState("");const[method,setMethod]=useState("post");const[addresses,setAddrs]=useState([]);const[loading,setL]=useState(false);const[addAddr,setAddAddr]=useState(false);const[fee,setFee]=useState(0);
  useEffect(()=>{
    api("GET","/user/addresses").then(setAddrs).catch(()=>{});
    api("GET","/prices").then(()=>{}).catch(()=>{});
    fetch("/api/v1/delivery-fee").then(r=>r.json()).then(s=>{setFee(parseFloat(s.delivery_fee||0));}).catch(()=>{});
  },[]);
  const hasEnoughRial = fee===0 || (profile.balance_rial||0) >= fee;
  const submit=async()=>{
    if(fee>0 && !hasEnoughRial){show("موجودی کیف پول برای هزینه بسته‌بندی کافی نیست","error");return;}
    setL(true);try{const r=await api("POST","/user/delivery",{gram:parseInt(gram),address_id:parseInt(addrId),delivery_method:method});show(`درخواست ثبت شد — ${r.tracking_code}`,"success");setGram("");onDone();}catch(e){show(e.message,"error");}setL(false);
  };
  return(<div>
    <div style={{background:"rgba(47,44,121,0.04)",border:`1px solid ${C.border}`,borderRadius:14,padding:"12px 14px",marginBottom:18,fontSize:14,color:C.textSub,lineHeight:2}}>• حداقل ۱۰ گرم — فقط عدد صحیح<br/>• ساچمه نقره با هولوگرام امنیتی<br/>• هزینه ارسال پس‌کرایه (موقع تحویل)</div>
    <div style={{fontSize:14,color:C.textMuted,marginBottom:14}}>موجودی: {fmtGram(profile.balance_gram)} گرم</div>
    {fee>0&&(
      <div style={{background:hasEnoughRial?C.greenBg:C.redBg,border:`1px solid ${hasEnoughRial?C.green:C.red}33`,borderRadius:12,padding:"12px 14px",marginBottom:14}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
          <div>
            <div style={{fontSize:13,fontWeight:700,color:hasEnoughRial?C.green:C.red}}>هزینه بسته‌بندی</div>
            <div style={{fontSize:12,color:C.textMuted,marginTop:2}}>از کیف پول ریالی کسر می‌شود</div>
          </div>
          <div style={{fontSize:16,fontWeight:800,color:hasEnoughRial?C.green:C.red}}>{fmtRial(fee)} ر</div>
        </div>
        {!hasEnoughRial&&(
          <div style={{marginTop:10,paddingTop:10,borderTop:`1px solid ${C.red}22`}}>
            <div style={{fontSize:13,color:C.red,marginBottom:8}}>موجودی کیف پول کافی نیست</div>
            <Btn variant="primary" size="sm" fullWidth onClick={()=>{onDone();onCharge();}}>شارژ کیف پول</Btn>
          </div>
        )}
      </div>
    )}
    <Input label="مقدار (گرم صحیح)" type="number" step="1" placeholder="۱۰، ۵۰، ۱۰۰..." value={gram} onChange={e=>setGram(e.target.value)} />
    <Select label="روش تحویل" value={method} onChange={e=>setMethod(e.target.value)}><option value="post">پست</option><option value="in_person">حضوری</option></Select>
    {addresses.length===0?(<div style={{marginBottom:14}}><div style={{fontSize:14,color:C.yellow,marginBottom:8}}>آدرسی ثبت نشده</div><Btn variant="ghost" size="sm" onClick={()=>setAddAddr(true)}>+ افزودن آدرس</Btn></div>):(<Select label="آدرس تحویل" value={addrId} onChange={e=>setAddrId(e.target.value)}><option value="">انتخاب کنید...</option>{addresses.map(a=><option key={a.id} value={a.id}>{a.title} — {a.city}</option>)}</Select>)}
    <Btn variant="primary" fullWidth loading={loading} disabled={parseInt(gram||0)<10||!addrId||parseInt(gram)!==parseFloat(gram)||(!hasEnoughRial&&fee>0)} onClick={submit}>ثبت درخواست تحویل</Btn>
    {addAddr&&<AddAddressModal api={api} show={show} onClose={()=>setAddAddr(false)} onSaved={()=>{setAddAddr(false);api("GET","/user/addresses").then(setAddrs).catch(()=>{});}} />}
  </div>);
}

function ChargeDrawer({api, show, onDone}) {
  const [amount,setAmount]=useState("");const[method,setMethod]=useState("bank_transfer");const[loading,setL]=useState(false);const fileRef=useRef();const[hasFile,setHasFile]=useState(false);
  const [companyCard,setCompanyCard]=useState("");const[companyOwner,setCompanyOwner]=useState("");
  useEffect(()=>{fetch("/api/v1/company-info").then(r=>r.json()).then(d=>{setCompanyCard(d.card_number||"");setCompanyOwner(d.card_owner||"");}).catch(()=>{});},[]); 
  const submit=async()=>{setL(true);try{const r=await api("POST","/user/wallet/charge",{amount_rial:parseFloat(amount)*10,payment_method:method});if(method==="bank_transfer"&&fileRef.current?.files[0]&&r.tracking_code){const fd=new FormData();fd.append("tracking_code",r.tracking_code);fd.append("receipt",fileRef.current.files[0]);await api("POST","/user/wallet/charge/receipt",fd,true);}show(r.message||"شارژ ثبت شد","success");setAmount("");onDone();}catch(e){show(e.message,"error");}setL(false);};
  return(<div><Input label="مبلغ (ریال)" type="number" placeholder="مثال: ۵۰۰۰۰۰" value={amount} onChange={e=>setAmount(e.target.value)} /><Select label="روش پرداخت" value={method} onChange={e=>setMethod(e.target.value)}><option value="bank_transfer">کارت به کارت</option><option value="online_payment">پرداخت آنلاین (به زودی)</option></Select>{method==="bank_transfer"&&(<div style={{marginBottom:16}}>{companyCard&&(<div style={{background:`${C.primary}08`,border:`1px solid ${C.primary}22`,borderRadius:12,padding:"12px 14px",marginBottom:12}}><div style={{fontSize:13,color:C.textMuted,marginBottom:4}}>واریز به کارت مکعب</div><div style={{fontSize:17,fontWeight:800,color:C.primary,letterSpacing:2,direction:"ltr",textAlign:"left"}}>{companyCard}</div>{companyOwner&&<div style={{fontSize:13,color:C.textSub,marginTop:2}}>{companyOwner}</div>}</div>)}<div style={{fontSize:14,color:C.textSub,marginBottom:6}}>آپلود فیش</div><input ref={fileRef} type="file" accept="image/*" onChange={e=>setHasFile(e.target.files?.length>0)} style={{fontSize:14,color:C.textSub,width:"100%"}} /></div>)}<Btn variant="primary" fullWidth loading={loading} disabled={!amount||parseFloat(amount)<=0||(method==="bank_transfer"&&!hasFile)} onClick={submit}>{method==="bank_transfer"?"ارسال فیش":"پرداخت"}</Btn></div>);
}

function WithdrawDrawer({api, show, profile, onDone}) {
  const [amount,setAmount]=useState("");const[accId,setAccId]=useState("");const[accounts,setAcc]=useState([]);const[loading,setL]=useState(false);
  useEffect(()=>{api("GET","/user/bank-accounts").then(r=>setAcc(r.filter(a=>a.status==="approved"))).catch(()=>{});},[]);
  const submit=async()=>{setL(true);try{const r=await api("POST","/user/wallet/withdraw",{amount_rial:parseFloat(amount),bank_account_id:parseInt(accId)});show(`برداشت ثبت شد — ${r.tracking_code}`,"success");setAmount("");onDone();}catch(e){show(e.message,"error");}setL(false);};
  return(<div><div style={{fontSize:15,color:C.textMuted,marginBottom:16}}>موجودی ریالی: {fmtRial(Math.round(profile.balance_rial||0))} ریال</div><Input label="مبلغ برداشت (ریال)" type="number" placeholder="..." value={amount} onChange={e=>setAmount(e.target.value)} />{accounts.length===0?(<div style={{fontSize:14,color:C.yellow,marginBottom:14}}>ابتدا حساب بانکی تأیید شده اضافه کنید</div>):(<Select label="حساب مقصد" value={accId} onChange={e=>setAccId(e.target.value)}><option value="">انتخاب کنید...</option>{accounts.map(a=><option key={a.id} value={a.id}>{a.account_owner} — {a.iban||a.card_number}</option>)}</Select>)}<div style={{fontSize:13,color:C.textMuted,marginBottom:14}}>حداکثر ۲۰۰ میلیون ریال</div><Btn variant="primary" fullWidth loading={loading} disabled={!amount||!accId||parseFloat(amount)<=0} onClick={submit}>درخواست برداشت</Btn></div>);
}

function GoalsTab({api, show, profile, prices}) {
  const [goals,setGoals]=useState([]);const[modal,setModal]=useState(false);const load=()=>api("GET","/user/goals").then(setGoals).catch(()=>{});useEffect(()=>{load();},[]);
  const TYPES={car:"🚗 خودرو",house:"🏠 خانه",travel:"✈️ سفر",custom:"⭐ هدف"};
  const del=async id=>{try{await api("DELETE",`/user/goals/${id}`);show("حذف شد","success");load();}catch(e){show(e.message,"error");}};
  return(<div style={{padding:"16px"}}><div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:18}}><div style={{fontSize:18,fontWeight:800}}>اهداف مالی</div>{goals.length<3&&<Btn variant="primary" size="sm" onClick={()=>setModal(true)}>+ هدف جدید</Btn>}</div>{goals.length===0?<Empty text="هنوز هدفی تعریف نکردید" icon={<span style={{fontSize:32,opacity:.3}}>🎯</span>} />:goals.map(g=>(<Card key={g.id} style={{marginBottom:12}}><div style={{display:"flex",justifyContent:"space-between",marginBottom:12}}><div><div style={{fontSize:14,fontWeight:700}}>{TYPES[g.type]||g.type}</div><div style={{fontSize:14,color:C.textMuted}}>{g.title}</div></div><button onClick={()=>del(g.id)} style={{background:"none",border:"none",color:C.textMuted,cursor:"pointer",fontSize:20}}>×</button></div><div style={{marginBottom:6}}><div style={{display:"flex",justifyContent:"space-between",marginBottom:4}}><span style={{fontSize:14,color:C.textMuted}}>پیشرفت</span><span style={{fontSize:14,fontWeight:700,color:C.primary}}>{numFa(g.progress_percent)}٪</span></div><div style={{height:6,background:"rgba(47,44,121,0.08)",borderRadius:3,overflow:"hidden"}}><div style={{height:"100%",borderRadius:3,width:`${Math.min(100,g.progress_percent)}%`,background:`linear-gradient(90deg,${C.primary},${C.primaryLight})`,transition:"width .5s"}} /></div></div><div style={{fontSize:14,color:C.textMuted}}>هدف: {fmtRial(g.target_amount_rial)} ریال</div></Card>))}{modal&&<Modal title="افزودن هدف" onClose={()=>setModal(false)}><AddGoalForm api={api} show={show} onSaved={()=>{setModal(false);load();}} /></Modal>}</div>);
}

function AddGoalForm({api, show, onSaved}) {
  const [f,setF]=useState({type:"car"});const[loading,setL]=useState(false);const set=(k,v)=>setF(p=>({...p,[k]:v}));
  const submit=async()=>{setL(true);try{await api("POST","/user/goals",{type:f.type,title:f.title||"",target_amount_rial:parseFloat(f.target||0)});show("هدف اضافه شد","success");onSaved();}catch(e){show(e.message,"error");}setL(false);};
  return(<div><Select label="نوع هدف" value={f.type} onChange={e=>set("type",e.target.value)}><option value="car">🚗 خودرو</option><option value="house">🏠 خانه</option><option value="travel">✈️ سفر</option><option value="custom">⭐ هدف شخصی</option></Select><Input label="عنوان هدف" placeholder="مثال: خرید خانه" value={f.title||""} onChange={e=>set("title",e.target.value)} /><Input label="مبلغ هدف (ریال)" type="number" value={f.target||""} onChange={e=>set("target",e.target.value)} /><Btn variant="primary" fullWidth loading={loading} onClick={submit}>ذخیره هدف</Btn></div>);
}

function HistoryTab({api}) {
  const [txns,setTxns]=useState([]);const[filter,setFilter]=useState("all");const[loading,setL]=useState(true);
  const LABELS={silver_buy:"خرید ساچمه",bar_buy:"خرید شمش",silver_sell:"فروش نقره",silver_transfer:"انتقال نقره",physical_delivery:"تحویل فیزیکی نقره",wallet_charge:"شارژ کیف پول",wallet_withdrawal:"برداشت از کیف پول",balance_adjustment:"اصلاح موجودی"};
  const FILTERS=[{k:"all",l:"همه"},{k:"silver_buy",l:"خرید"},{k:"silver_sell",l:"فروش"},{k:"silver_transfer",l:"انتقال"},{k:"physical_delivery",l:"تحویل"},{k:"wallet_charge",l:"شارژ"},{k:"wallet_withdrawal",l:"برداشت"}];
  useEffect(()=>{setL(true);const p=filter==="all"?"/user/transactions":`/user/transactions?type=${filter}`;api("GET",p).then(setTxns).catch(()=>{}).finally(()=>setL(false));},[filter]);
  const exportName = "سوابق-تراکنش";
  return(<div style={{padding:"16px"}}><div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:14}}><div style={{fontSize:18,fontWeight:800}}>تراکنش‌ها</div>{txns.length>0&&<div style={{display:"flex",gap:6}}><button onClick={()=>exportTxnsCSV(txns,exportName)} style={{padding:"6px 12px",borderRadius:10,border:`1px solid ${C.border}`,background:"#fff",color:C.primary,cursor:"pointer",fontFamily:"Ray,sans-serif",fontSize:12,fontWeight:600}}>Excel</button><button onClick={()=>exportTxnsPDF(txns,exportName)} style={{padding:"6px 12px",borderRadius:10,border:`1px solid ${C.border}`,background:"#fff",color:C.primary,cursor:"pointer",fontFamily:"Ray,sans-serif",fontSize:12,fontWeight:600}}>PDF</button></div>}</div><div style={{display:"flex",gap:6,overflowX:"auto",paddingBottom:4,marginBottom:14}}>{FILTERS.map(f=>(<button key={f.k} onClick={()=>setFilter(f.k)} style={{padding:"7px 14px",borderRadius:20,border:"none",cursor:"pointer",fontFamily:"Ray,sans-serif",fontSize:13,fontWeight:600,whiteSpace:"nowrap",flexShrink:0,background:filter===f.k?"#2F2C79":"#fff",color:filter===f.k?"#fff":"#555570"}}>{f.l}</button>))}</div>{loading?<div style={{textAlign:"center",padding:40}}><Spinner size={32}/></div>:txns.length===0?<Empty/>:txns.map(t=>(<div key={t.id} style={{background:C.bgCard,border:`1px solid ${C.border}`,borderRadius:16,padding:"13px 15px",marginBottom:8}}><div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start"}}><div><div style={{fontSize:15,fontWeight:600}}>{LABELS[t.type]||t.type}</div><div style={{fontSize:12,color:C.textMuted,marginTop:2}}>{t.tracking_code}</div><div style={{fontSize:12,color:C.textMuted}}>{fmtDateFa(t.created_at)}</div></div><div style={{textAlign:"left"}}><Badge status={t.status}/>{t.silver_gram>0&&<div style={{fontSize:15,fontWeight:700,marginTop:4}}>{fmtGram(t.silver_gram)} گ</div>}{t.amount_rial>0&&<div style={{fontSize:14,color:C.textSub}}>{fmtRial(Math.round(t.amount_rial))} ر</div>}</div></div></div>))}</div>);
}

function NotificationsTab({api, show, onRead, onBack}) {
  const [items,setItems]=useState([]);const[loading,setL]=useState(true);
  useEffect(()=>{api("GET","/user/notifications").then(setItems).finally(()=>setL(false));},[]);
  const readAll=async()=>{await api("POST","/user/notifications/read-all",{});setItems(p=>p.map(n=>({...n,is_read:1})));onRead();};
  const del=async id=>{await api("DELETE",`/user/notifications/${id}`);setItems(p=>p.filter(n=>n.id!==id));onRead();};
  return(<div style={{padding:"16px"}}><div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:16}}><div style={{display:"flex",alignItems:"center",gap:12}}><button onClick={onBack} style={{background:"none",border:"none",color:C.textMuted,cursor:"pointer",fontSize:22,lineHeight:1}}>←</button><div style={{fontSize:18,fontWeight:800}}>اعلان‌ها</div></div>{items.some(n=>!n.is_read)&&<Btn variant="ghost" size="sm" onClick={readAll}>همه خوانده شد</Btn>}</div>{loading?<div style={{textAlign:"center",padding:40}}><Spinner size={32}/></div>:items.length===0?<Empty text="اعلانی ندارید" icon={<span style={{fontSize:32,opacity:.3}}>🔔</span>} />:items.map(n=>(<div key={n.id} style={{background:n.is_read?"#fff":"rgba(47,44,121,0.05)",border:`1px solid ${n.is_read?"rgba(0,0,0,0.08)":"rgba(47,44,121,0.15)"}`,borderRadius:16,padding:"13px 15px",marginBottom:8,display:"flex",justifyContent:"space-between",alignItems:"flex-start"}}><div style={{flex:1}}><div style={{fontSize:15,fontWeight:n.is_read?500:700}}>{n.title}</div><div style={{fontSize:14,color:C.textSub,marginTop:4,lineHeight:1.6}}>{n.message}</div><div style={{fontSize:12,color:C.textMuted,marginTop:6}}>{fmtDateFa(n.created_at)}</div></div><button onClick={()=>del(n.id)} style={{background:"none",border:"none",color:C.textMuted,cursor:"pointer",fontSize:20,flexShrink:0,marginRight:4}}>×</button></div>))}</div>);
}

function ProfileTab({profile, api, show, onRefresh, onLogout}) {
  const [tab,setTab]=useState("info");
  const TABS=[{k:"info",l:"اطلاعات"},{k:"identity",l:"هویت"},{k:"bank",l:"حساب‌ها"},{k:"address",l:"آدرس‌ها"},{k:"tickets",l:"پشتیبانی"},{k:"pass",l:"رمز"}];
  return(<div style={{padding:"16px"}}><div style={{fontSize:18,fontWeight:800,marginBottom:14}}>پروفایل</div><div style={{display:"flex",gap:6,overflowX:"auto",paddingBottom:4,marginBottom:16}}>{TABS.map(t=>(<button key={t.k} onClick={()=>setTab(t.k)} style={{padding:"8px 16px",borderRadius:20,border:"none",cursor:"pointer",fontFamily:"Ray,sans-serif",fontSize:13,fontWeight:600,whiteSpace:"nowrap",flexShrink:0,background:tab===t.k?"#2F2C79":"#fff",color:tab===t.k?"#fff":"#555570"}}>{t.l}</button>))}</div>{tab==="info"&&<ProfileInfo profile={profile} onLogout={onLogout} />}{tab==="identity"&&<IdentityTab profile={profile} api={api} show={show} onRefresh={onRefresh} />}{tab==="bank"&&<BankTab api={api} show={show} />}{tab==="address"&&<AddressTab api={api} show={show} />}{tab==="tickets"&&<TicketsTab api={api} show={show} />}{tab==="pass"&&<PassTab api={api} show={show} profile={profile} />}</div>);
}

function ProfileInfo({profile, onLogout}) {
  return(<Card><div style={{textAlign:"center",padding:"8px 0 16px"}}><div style={{width:60,height:60,borderRadius:"50%",background:"rgba(47,44,121,0.08)",display:"flex",alignItems:"center",justifyContent:"center",margin:"0 auto 12px",fontSize:24,border:"2px solid rgba(47,44,121,0.15)"}}>{(profile.first_name||"?")[0]}</div><div style={{fontSize:17,fontWeight:700}}>{profile.first_name||""} {profile.last_name||""}</div><div style={{fontSize:14,color:C.textMuted,marginTop:2}}>{profile.mobile}</div></div><div style={{height:1,background:C.border,marginBottom:14}} /><div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8,marginBottom:16}}>{[{l:"نقره",v:`${fmtGram(profile.balance_gram)} گ`},{l:"ریالی",v:`${fmtRial(Math.round(profile.balance_rial||0))} ر`},{l:"میانگین خرید",v:`${fmtRial(Math.round(profile.avg_cost||0))} ر/گ`},{l:"هویت",v:profile.is_verified?"تأیید شده ✓":"تأیید نشده"}].map(({l,v})=>(<div key={l} style={{background:"#F5F5F8",borderRadius:12,padding:"10px 12px"}}><div style={{fontSize:12,color:C.textMuted,marginBottom:3}}>{l}</div><div style={{fontSize:15,fontWeight:600}}>{v}</div></div>))}</div><Btn variant="red" size="sm" onClick={onLogout}>خروج از حساب</Btn></Card>);
}

function IdentityTab({profile, api, show, onRefresh}) {
  const [f,setF]=useState({national_code:profile.national_code||"",birth_date:profile.birth_date||""});const[loading,setL]=useState(false);
  const submit=async()=>{setL(true);try{await api("POST","/auth/identity",{national_code:f.national_code,birth_date:f.birth_date});show("ذخیره شد","success");onRefresh();}catch(e){show(e.message,"error");}setL(false);};
  return(<Card><div style={{fontSize:14,color:C.textMuted,marginBottom:14,background:"#F5F5F8",borderRadius:10,padding:"10px 12px",lineHeight:1.8}}>فاز ۱: ذخیره اطلاعات<br/>فاز ۲: تأیید از طریق شاهکار</div><Input label="کد ملی (۱۰ رقم)" placeholder="0000000000" value={f.national_code} onChange={e=>setF(p=>({...p,national_code:e.target.value.replace(/\D/g,"")}))} style={{letterSpacing:2,direction:"ltr"}} /><Input label="تاریخ تولد" type="date" value={f.birth_date} onChange={e=>setF(p=>({...p,birth_date:e.target.value}))} style={{direction:"ltr"}} /><Btn variant="primary" fullWidth loading={loading} disabled={f.national_code.length!==10||!f.birth_date} onClick={submit}>ذخیره اطلاعات هویتی</Btn></Card>);
}

function BankTab({api, show}) {
  const [accounts,setAcc]=useState([]);const[modal,setModal]=useState(false);const load=()=>api("GET","/user/bank-accounts").then(setAcc).catch(()=>{});useEffect(()=>{load();},[]);
  const del=async id=>{try{await api("DELETE",`/user/bank-accounts/${id}`);show("حذف شد","success");load();}catch(e){show(e.message,"error");}};
  return(<div>{accounts.map(a=>(<Card key={a.id} style={{marginBottom:8}}><div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start"}}><div><div style={{fontSize:15,fontWeight:600}}>{a.account_owner}</div>{a.iban&&<div style={{fontSize:13,color:C.textSub,letterSpacing:1}}>{a.iban}</div>}{a.card_number&&<div style={{fontSize:13,color:C.textSub}}>{a.card_number}</div>}</div><div style={{display:"flex",gap:8,alignItems:"center"}}><Badge status={a.status}/><button onClick={()=>del(a.id)} style={{background:"none",border:"none",color:C.red,cursor:"pointer",fontSize:18}}>×</button></div></div></Card>))}<Btn variant="primary" size="sm" style={{marginTop:4}} onClick={()=>setModal(true)}>+ افزودن حساب</Btn>{modal&&<Modal title="افزودن حساب بانکی" onClose={()=>setModal(false)}><AddBankForm api={api} show={show} onSaved={()=>{setModal(false);load();}} /></Modal>}</div>);
}

function AddBankForm({api, show, onSaved}) {
  const [f,setF]=useState({});const set=(k,v)=>setF(p=>({...p,[k]:v}));const[loading,setL]=useState(false);
  const submit=async()=>{setL(true);try{await api("POST","/user/bank-accounts",{account_owner:f.owner||"",iban:f.iban||"",card_number:f.card||"",bank_name:f.bank||""});show("حساب ثبت شد","success");onSaved();}catch(e){show(e.message,"error");}setL(false);};
  return(<div><Input label="نام صاحب حساب" value={f.owner||""} onChange={e=>set("owner",e.target.value)} /><Input label="شماره شبا (IR...)" placeholder="IR..." value={f.iban||""} onChange={e=>set("iban",e.target.value.toUpperCase())} /><Input label="شماره کارت (اختیاری)" value={f.card||""} onChange={e=>set("card",e.target.value)} /><Input label="نام بانک (اختیاری)" value={f.bank||""} onChange={e=>set("bank",e.target.value)} /><Btn variant="primary" fullWidth loading={loading} onClick={submit}>ثبت حساب</Btn></div>);
}

function AddressTab({api, show}) {
  const [addrs,setAddrs]=useState([]);const[modal,setModal]=useState(false);const load=()=>api("GET","/user/addresses").then(setAddrs).catch(()=>{});useEffect(()=>{load();},[]);
  const del=async id=>{try{await api("DELETE",`/user/addresses/${id}`);show("حذف شد","success");load();}catch(e){show(e.message,"error");}};
  return(<div>{addrs.map(a=>(<Card key={a.id} style={{marginBottom:8}}><div style={{display:"flex",justifyContent:"space-between"}}><div><div style={{fontSize:15,fontWeight:600}}>{a.title}</div><div style={{fontSize:13,color:C.textSub}}>{a.city}، {a.address}</div><div style={{fontSize:13,color:C.textMuted}}>{a.receiver_name} — {a.receiver_mobile}</div></div><button onClick={()=>del(a.id)} style={{background:"none",border:"none",color:C.red,cursor:"pointer",fontSize:18}}>×</button></div></Card>))}<Btn variant="primary" size="sm" style={{marginTop:4}} onClick={()=>setModal(true)}>+ افزودن آدرس</Btn>{modal&&<AddAddressModal api={api} show={show} onClose={()=>setModal(false)} onSaved={()=>{setModal(false);load();}} />}</div>);
}

function AddAddressModal({api, show, onClose, onSaved}) {
  const [f,setF]=useState({});const set=(k,v)=>setF(p=>({...p,[k]:v}));const[loading,setL]=useState(false);
  const submit=async()=>{setL(true);try{await api("POST","/user/addresses",{title:f.title||"خانه",province:f.province||"",city:f.city||"",address:f.address||"",postal_code:f.postal,receiver_name:f.rname||"",receiver_mobile:f.rmobile||""});show("آدرس اضافه شد","success");onSaved();}catch(e){show(e.message,"error");}setL(false);};
  return(<Modal title="افزودن آدرس" onClose={onClose}><Input label="عنوان" placeholder="خانه، محل کار..." value={f.title||""} onChange={e=>set("title",e.target.value)} /><Input label="استان" value={f.province||""} onChange={e=>set("province",e.target.value)} /><Input label="شهر" value={f.city||""} onChange={e=>set("city",e.target.value)} /><Input label="آدرس کامل" value={f.address||""} onChange={e=>set("address",e.target.value)} /><Input label="کد پستی" value={f.postal||""} onChange={e=>set("postal",e.target.value)} /><Input label="نام گیرنده" value={f.rname||""} onChange={e=>set("rname",e.target.value)} /><Input label="موبایل گیرنده" value={f.rmobile||""} onChange={e=>set("rmobile",e.target.value)} /><Btn variant="primary" fullWidth loading={loading} onClick={submit}>ذخیره آدرس</Btn></Modal>);
}

function TicketsTab({api, show}) {
  const [tickets,setT]=useState([]);const[modal,setModal]=useState(false);const load=()=>api("GET","/user/tickets").then(setT).catch(()=>{});useEffect(()=>{load();},[]);
  return(<div><div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:12}}><div style={{fontSize:14,fontWeight:600}}>تیکت‌های پشتیبانی</div><Btn variant="primary" size="sm" onClick={()=>setModal(true)}>+ تیکت جدید</Btn></div>{tickets.length===0?<Empty text="تیکتی ندارید" icon={<span style={{fontSize:32,opacity:.3}}>✉️</span>} />:tickets.map(t=>(<Card key={t.id} style={{marginBottom:8}}><div style={{display:"flex",justifyContent:"space-between"}}><div><div style={{fontSize:15,fontWeight:600}}>{t.subject}</div><div style={{fontSize:13,color:C.textMuted}}>{fmtDateFa(t.created_at)}</div></div><Badge status={t.status}/></div></Card>))}{modal&&<Modal title="تیکت جدید" onClose={()=>setModal(false)}><NewTicketForm api={api} show={show} onSaved={()=>{setModal(false);load();}} /></Modal>}</div>);
}

function NewTicketForm({api, show, onSaved}) {
  const [f,setF]=useState({category:"other"});const set=(k,v)=>setF(p=>({...p,[k]:v}));const[loading,setL]=useState(false);
  const submit=async()=>{setL(true);try{await api("POST","/user/tickets",{subject:f.subject||"",category:f.category,message:f.message||""});show("تیکت ثبت شد","success");onSaved();}catch(e){show(e.message,"error");}setL(false);};
  return(<div><Select label="دسته‌بندی" value={f.category} onChange={e=>set("category",e.target.value)}><option value="buy">خرید</option><option value="sell">فروش</option><option value="wallet">کیف پول</option><option value="delivery">تحویل</option><option value="verification">احراز هویت</option><option value="other">سایر</option></Select><Input label="موضوع" value={f.subject||""} onChange={e=>set("subject",e.target.value)} /><div style={{marginBottom:14}}><div style={{fontSize:13,fontWeight:600,color:C.textSub,marginBottom:5}}>پیام</div><textarea value={f.message||""} onChange={e=>set("message",e.target.value)} rows={4} style={{width:"100%",padding:"13px 16px",borderRadius:14,border:`1.5px solid ${C.border}`,background:C.bgCard,color:C.text,fontSize:14,fontFamily:"Ray,sans-serif",direction:"rtl",outline:"none",resize:"vertical"}} /></div><Btn variant="primary" fullWidth loading={loading} onClick={submit}>ارسال تیکت</Btn></div>);
}

function PassTab({api, show, profile}) {
  const [f,setF]=useState({});const set=(k,v)=>setF(p=>({...p,[k]:v}));const[loading,setL]=useState(false);const[showPass,setShowPass]=useState(false);
  const submit=async()=>{if(f.n1!==f.n2){show("رمزها یکسان نیستند","error");return;}setL(true);try{await api("POST","/auth/change-password",{old_password:f.old,new_password:f.n1});show("رمز تغییر کرد","success");setF({});}catch(e){show(e.message,"error");}setL(false);};
  return(<div>
    <Card style={{marginBottom:14}}>
      <div style={{fontSize:13,fontWeight:600,color:C.textMuted,marginBottom:10}}>رمز عبور فعلی</div>
      <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",background:"#F5F5F8",borderRadius:12,padding:"12px 14px"}}>
        <div style={{fontSize:16,fontWeight:700,letterSpacing:showPass?2:4,color:C.text,direction:"ltr"}}>{showPass?(profile?.raw_password||"نمایش در دسترس نیست"):"••••••••"}</div>
        <button onClick={()=>setShowPass(p=>!p)} style={{background:"none",border:"none",cursor:"pointer",color:C.primary,fontSize:13,fontFamily:"Ray,sans-serif"}}>{showPass?"پنهان":"نمایش"}</button>
      </div>
    </Card>
    <Card><div style={{fontSize:13,fontWeight:600,color:C.textMuted,marginBottom:10}}>تغییر رمز عبور</div><Input label="رمز فعلی" type="password" value={f.old||""} onChange={e=>set("old",e.target.value)} /><Input label="رمز جدید (حداقل ۶ کاراکتر)" type="password" value={f.n1||""} onChange={e=>set("n1",e.target.value)} /><Input label="تکرار رمز جدید" type="password" value={f.n2||""} onChange={e=>set("n2",e.target.value)} /><Btn variant="primary" fullWidth loading={loading} onClick={submit}>تغییر رمز</Btn></Card>
  </div>);
}

// ══════════════════════════════════════════════════════════════════════════════
// ADMIN PANEL — Full Redesign
// ══════════════════════════════════════════════════════════════════════════════

function AdminLoginScreen({onLogin}) {
  const [f,setF]=useState({});const[loading,setL]=useState(false);const[error,setErr]=useState("");
  const set=(k,v)=>setF(p=>({...p,[k]:v}));
  const submit=async()=>{setErr("");setL(true);try{await onLogin(f.username||"",f.password||"");}catch(e){setErr(e.message);}setL(false);};
  return (
    <div style={{minHeight:"100vh",background:C.bg,display:"flex",alignItems:"center",justifyContent:"center",padding:24}}>
      <style>{G}</style>
      <div style={{width:"100%",maxWidth:380,animation:"fadeUp .4s ease"}}>
        {/* Brand block */}
        <div style={{textAlign:"center",marginBottom:28}}>
          <div style={{display:"inline-flex",padding:16,borderRadius:20,background:"#fff",
            border:`1px solid ${C.border}`,marginBottom:16,boxShadow:"0 2px 16px rgba(47,44,121,0.08)"}}>
            <Logo size={52} />
          </div>
          <div style={{fontSize:20,fontWeight:800,color:C.text}}>پنل مدیریت مکعب</div>
          <div style={{fontSize:13,color:C.textMuted,marginTop:6,display:"flex",alignItems:"center",justifyContent:"center",gap:6}}>
            <span style={{display:"inline-block",width:8,height:8,borderRadius:"50%",background:C.green}} />
            فقط از شبکه مجاز قابل دسترس
          </div>
        </div>

        <Card style={{padding:"24px"}}>
          {error && (
            <div style={{background:C.redBg,border:`1px solid ${C.red}22`,borderRadius:10,
              padding:"10px 14px",marginBottom:16,fontSize:14,color:C.red,display:"flex",gap:8,alignItems:"center"}}>
              <IconX/> {error}
            </div>
          )}
          <Input label="نام کاربری" value={f.username||""} onChange={e=>set("username",e.target.value)}
            placeholder="username" style={{direction:"ltr",letterSpacing:.5}} />
          <Input label="رمز عبور" type="password" value={f.password||""} onChange={e=>set("password",e.target.value)}
            onKeyDown={e=>e.key==="Enter"&&submit()} placeholder="••••••••" style={{direction:"ltr"}} />
          <Btn variant="primary" fullWidth loading={loading} onClick={submit} size="lg">
            ورود به پنل
          </Btn>
        </Card>

        <div style={{textAlign:"center",marginTop:20,fontSize:12,color:C.textMuted}}>
          مکعب © ۱۴۰۴ — سامانه هوشمند پس‌انداز نقره
        </div>
      </div>
    </div>
  );
}

function AdminForceChangePw({onDone, onLogout}) {
  const [f,setF]=useState({});const[loading,setL]=useState(false);const[error,setErr]=useState("");
  const token=getToken();
  const submit=async()=>{if(f.n1!==f.n2){setErr("رمزها یکسان نیستند");return;}if((f.n1||"").length<8){setErr("حداقل ۸ کاراکتر");return;}
    setL(true);try{await req("POST","/admin/auth/change-password",{old_password:f.old,new_password:f.n1},token);onDone();}catch(e){setErr(e.message);}setL(false);};
  return (
    <div style={{minHeight:"100vh",background:C.bg,display:"flex",alignItems:"center",justifyContent:"center",padding:24}}>
      <style>{G}</style>
      <div style={{width:"100%",maxWidth:380,animation:"fadeUp .4s ease"}}>
        <div style={{textAlign:"center",marginBottom:24}}>
          <div style={{width:56,height:56,borderRadius:16,background:C.redBg,border:`1px solid ${C.red}33`,
            display:"flex",alignItems:"center",justifyContent:"center",margin:"0 auto 14px"}}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke={C.red} strokeWidth="2" strokeLinecap="round"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0110 0v4"/></svg>
          </div>
          <div style={{fontSize:18,fontWeight:800,color:C.red}}>تغییر رمز اجباری</div>
          <div style={{fontSize:13,color:C.textMuted,marginTop:8}}>رمز پیش‌فرض باید تغییر کند — حداقل ۸ کاراکتر</div>
        </div>
        <Card style={{padding:"24px"}}>
          {error && <div style={{background:C.redBg,borderRadius:10,padding:"10px 14px",marginBottom:14,fontSize:14,color:C.red}}>{error}</div>}
          <Input label="رمز فعلی" type="password" value={f.old||""} onChange={e=>setF(p=>({...p,old:e.target.value}))} style={{direction:"ltr"}} />
          <Input label="رمز جدید" type="password" value={f.n1||""} onChange={e=>setF(p=>({...p,n1:e.target.value}))} style={{direction:"ltr"}} />
          <Input label="تکرار رمز جدید" type="password" value={f.n2||""} onChange={e=>setF(p=>({...p,n2:e.target.value}))} style={{direction:"ltr"}} />
          <Btn variant="danger" fullWidth loading={loading} onClick={submit}>تغییر رمز و ورود</Btn>
          <Btn variant="ghost" fullWidth style={{marginTop:8}} onClick={onLogout}>خروج</Btn>
        </Card>
      </div>
    </div>
  );
}

// ─── Admin Nav Config ─────────────────────────────────────────────────────────
const ADMIN_NAV_GROUPS = [
  {
    label: null,
    items: [
      {k:"dashboard", l:"داشبورد", Icon:IconDashboard, roles:["super_admin","ceo","financial","operations"]},
    ]
  },
  {
    label: "معاملات",
    items: [
      {k:"buys",    l:"خرید ساچمه", Icon:IconBuy,  roles:["super_admin","financial"]},
      {k:"sells",   l:"فروش ساچمه", Icon:IconSell, roles:["super_admin","financial"]},
      {k:"barbuy",  l:"خرید شمش",  Icon:IconBuy,  roles:["super_admin","financial"]},
      {k:"goldbuy", l:"خرید طلا",  Icon:IconBuy,  roles:["super_admin","financial"]},
      {k:"bars",    l:"مدیریت شمش",Icon:IconBuy,  roles:["super_admin","financial"]},
    ]
  },
  {
    label: "مالی",
    items: [
      {k:"charges",     l:"شارژ",    Icon:IconCharge,  roles:["super_admin","financial"]},
      {k:"withdrawals", l:"برداشت",  Icon:IconWithdraw,roles:["super_admin","financial"]},
      {k:"ibans",       l:"حساب‌ها", Icon:IconBank,    roles:["super_admin","financial"]},
    ]
  },
  {
    label: "لجستیک",
    items: [
      {k:"deliveries", l:"تحویل فیزیکی", Icon:IconDelivery, roles:["super_admin","operations"]},
    ]
  },
  {
    label: "ارتباط با مشتری",
    items: [
      {k:"tickets", l:"تیکت‌ها",  Icon:IconTicket, roles:["super_admin","operations"]},
      {k:"users",   l:"کاربران",  Icon:IconUsers,  roles:["super_admin","ceo","operations"]},
    ]
  },
  {
    label: "سیستم",
    items: [
      {k:"logs",     l:"لاگ‌ها",    Icon:IconLogs,     roles:["super_admin","ceo"]},
      {k:"settings", l:"تنظیمات",  Icon:IconSettings, roles:["super_admin"]},
    ]
  },
];

const ADMIN_NAV = ADMIN_NAV_GROUPS.flatMap(g => g.items);

// ─── Admin Panel Root ─────────────────────────────────────────────────────────
function AdminPanel({admin:initAdmin, onLogout}) {
  const [view,setView]   = useState("dashboard");
  const [stats,setStats] = useState({});
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const {show,El}        = useToast();
  const token  = getToken();
  const role   = initAdmin.role;
  const api    = useCallback((m,p,b)=>req(m,p,b,token),[token]);
  const loadStats = useCallback(async()=>{try{setStats(await api("GET","/admin/stats"));}catch{}},[api]);
  useEffect(()=>{loadStats();},[]);

  const pending = stats.pending||{};
  const BADGES  = {buys:pending.buy,sells:pending.sell,charges:pending.charge,
    withdrawals:pending.withdraw,deliveries:pending.delivery,ibans:pending.iban,
    tickets:pending.tickets,barbuy:pending.barbuy,goldbuy:pending.goldbuy};

  const ROLE_LABELS = {super_admin:"ارشد",financial:"مالی",operations:"عملیات",ceo:"مدیرعامل"};

  const SidebarContent = () => (
    <div style={{display:"flex",flexDirection:"column",height:"100%"}}>
      {/* لوگو */}
      <div style={{padding:"20px 16px 16px",borderBottom:"1px solid #F1F5F9"}}>
        <div style={{display:"flex",alignItems:"center",gap:10}}>
          <Logo size={32}/>
          <div>
            <div style={{fontSize:15,fontWeight:800,color:"#0F172A"}}>مکعب</div>
            <div style={{fontSize:11,color:"#94A3B8"}}>پنل مدیریت</div>
          </div>
        </div>
      </div>

      {/* منو */}
      <div style={{flex:1,overflowY:"auto",padding:"12px 8px"}}>
        {ADMIN_NAV_GROUPS.map((group,gi)=>{
          const items = group.items.filter(n=>n.roles.includes(role));
          if(items.length===0) return null;
          return (
            <div key={gi} style={{marginBottom:4}}>
              {group.label && (
                <div style={{fontSize:10,fontWeight:700,color:"#94A3B8",letterSpacing:1,padding:"8px 10px 4px",textTransform:"uppercase"}}>
                  {group.label}
                </div>
              )}
              {items.map(item=>{
                const cnt = BADGES[item.k]||0;
                const active = view===item.k;
                return (
                  <button key={item.k} onClick={()=>{setView(item.k);setSidebarOpen(false);}} style={{
                    display:"flex",alignItems:"center",justifyContent:"space-between",
                    width:"100%",padding:"8px 10px",borderRadius:10,border:"none",cursor:"pointer",
                    fontFamily:"Ray,sans-serif",transition:"all .15s",marginBottom:2,
                    background:active?"#EEF2FF":"transparent",
                    color:active?"#2F2C79":"#475569",
                  }}>
                    <div style={{display:"flex",alignItems:"center",gap:8}}>
                      <item.Icon active={active}/>
                      <span style={{fontSize:13,fontWeight:active?700:400}}>{item.l}</span>
                    </div>
                    {cnt>0&&<span style={{background:active?"#2F2C79":"#EF4444",color:"#fff",fontSize:10,fontWeight:700,borderRadius:20,padding:"1px 7px",minWidth:20,textAlign:"center"}}>{cnt>99?"99+":cnt}</span>}
                  </button>
                );
              })}
            </div>
          );
        })}
      </div>

      {/* پروفایل ادمین */}
      <div style={{padding:"12px 16px",borderTop:"1px solid #F1F5F9"}}>
        <div style={{display:"flex",alignItems:"center",gap:10}}>
          <div style={{width:36,height:36,borderRadius:10,background:"#EEF2FF",display:"flex",alignItems:"center",justifyContent:"center",fontSize:14,fontWeight:800,color:"#2F2C79",flexShrink:0}}>
            {(initAdmin.username||"A")[0].toUpperCase()}
          </div>
          <div style={{flex:1,minWidth:0}}>
            <div style={{fontSize:13,fontWeight:700,color:"#0F172A",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{initAdmin.username}</div>
            <div style={{fontSize:11,color:"#94A3B8"}}>{ROLE_LABELS[role]||role}</div>
          </div>
          <button onClick={onLogout} title="خروج" style={{background:"none",border:"none",cursor:"pointer",color:"#94A3B8",padding:4,borderRadius:6,display:"flex",alignItems:"center"}}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4"/><polyline points="16,17 21,12 16,7"/><line x1="21" y1="12" x2="9" y2="12"/></svg>
          </button>
        </div>
      </div>
    </div>
  );

  return (
    <div style={{display:"flex",height:"100vh",background:"#F8FAFC",fontFamily:"Ray,sans-serif",direction:"rtl"}}>
      <style>{G}</style>
      {El}

      {/* Sidebar Desktop */}
      <div style={{width:220,flexShrink:0,background:"#fff",borderLeft:"1px solid #F1F5F9",height:"100vh",position:"sticky",top:0,display:"flex",flexDirection:"column"}}>
        <SidebarContent/>
      </div>

      {/* Sidebar Mobile Overlay */}
      {sidebarOpen&&(
        <div style={{position:"fixed",inset:0,zIndex:200,display:"flex"}}>
          <div style={{position:"absolute",inset:0,background:"rgba(0,0,0,0.3)"}} onClick={()=>setSidebarOpen(false)}/>
          <div style={{position:"relative",width:260,background:"#fff",height:"100%",zIndex:1,marginRight:"auto"}}>
            <SidebarContent/>
          </div>
        </div>
      )}

      {/* Main Content */}
      <div style={{flex:1,display:"flex",flexDirection:"column",minWidth:0,height:"100vh",overflowY:"auto"}}>
        {/* Top Bar */}
        <div style={{background:"#fff",borderBottom:"1px solid #F1F5F9",padding:"0 20px",height:56,display:"flex",alignItems:"center",justifyContent:"space-between",position:"sticky",top:0,zIndex:100}}>
          <button onClick={()=>setSidebarOpen(true)} style={{background:"none",border:"none",cursor:"pointer",color:"#64748B",padding:4,display:"flex",alignItems:"center"}}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="18" x2="21" y2="18"/></svg>
          </button>
          <div style={{fontSize:14,fontWeight:700,color:"#0F172A"}}>
            {ADMIN_NAV.find(n=>n.k===view)?.l||"داشبورد"}
          </div>
          <div style={{width:28}}/>
        </div>

        {/* Page Content */}
        <div style={{flex:1,padding:"20px",maxWidth:1200,width:"100%",margin:"0 auto"}}>
          {view==="dashboard"   && <AdminDashboard stats={stats} pending={pending} onNav={setView} api={api} />}
          {view==="buys"        && <AdminOrderList key="buys" title="خرید ساچمه" api={api} show={show} endpoint="/admin/buy-orders" onRefresh={loadStats} renderRow={o=><BuyRow o={o}/>} approveUrl={o=>`/admin/buy-orders/${o.id}/approve`} rejectUrl={o=>`/admin/buy-orders/${o.id}/reject`} />}
          {view==="barbuy"      && <AdminOrderList key="barbuy" title="خرید شمش" api={api} show={show} endpoint="/admin/bar-orders" onRefresh={loadStats} renderRow={o=><BarBuyRow o={o}/>} approveUrl={o=>`/admin/bar-orders/${o.id}/approve`} rejectUrl={o=>`/admin/bar-orders/${o.id}/reject`} />}
          {view==="goldbuy"     && <AdminOrderList key="goldbuy" title="خرید طلا" api={api} show={show} endpoint="/admin/gold-orders" onRefresh={loadStats} renderRow={o=><GoldBuyRow o={o}/>} approveUrl={o=>`/admin/gold-orders/${o.id}/approve`} rejectUrl={o=>`/admin/gold-orders/${o.id}/reject`} />}
          {view==="bars"        && <AdminBarsPanel api={api} show={show} />}
          {view==="sells"       && <AdminOrderList key="sells" title="فروش نقره" api={api} show={show} endpoint="/admin/sell-orders" onRefresh={loadStats} renderRow={o=><SellRow o={o}/>} approveUrl={o=>`/admin/sell-orders/${o.id}/approve`} rejectUrl={o=>`/admin/sell-orders/${o.id}/reject`} />}
          {view==="charges"     && <AdminOrderList key="charges" title="شارژ کیف پول" api={api} show={show} endpoint="/admin/wallet-charges" onRefresh={loadStats} renderRow={o=><ChargeRow o={o}/>} approveUrl={o=>`/admin/wallet-charges/${o.id}/approve`} rejectUrl={o=>`/admin/wallet-charges/${o.id}/reject`} />}
          {view==="withdrawals" && <AdminWithdrawalsList api={api} show={show} onRefresh={loadStats}/>}
          {view==="deliveries"  && <AdminDeliveriesList api={api} show={show} onRefresh={loadStats}/>}
          {view==="ibans"       && <AdminOrderList key="ibans" title="حساب‌های بانکی" api={api} show={show} endpoint="/admin/bank-accounts" onRefresh={loadStats} renderRow={o=><IbanRow o={o}/>} approveUrl={o=>`/admin/bank-accounts/${o.id}/approve`} rejectUrl={o=>`/admin/bank-accounts/${o.id}/reject`} />}
          {view==="tickets"     && <AdminTicketList api={api} show={show} />}
          {view==="users"       && <AdminUserList api={api} show={show} />}
          {view==="logs"        && <AdminLogList api={api} />}
          {view==="settings"    && <AdminSettingsPanel api={api} show={show} loadStats={loadStats} />}
        </div>
      </div>
    </div>
  );
}


function AdminDashboard({stats, pending, onNav, api}) {
  const [barStats,setBarStats] = useState(null);
  useEffect(()=>{if(api)api("GET","/admin/bar-stats").then(setBarStats).catch(()=>{});},[api]);
  const METRICS = [
    {label:"کاربران کل",    value:numFa(stats.users_total||0),
      sub:"نفر ثبت‌نام کرده", color:"#2F2C79", bg:"rgba(47,44,121,0.08)",
      icon:<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#2F2C79" strokeWidth="1.8" strokeLinecap="round"><path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 00-3-3.87"/><path d="M16 3.13a4 4 0 010 7.75"/></svg>},
    {label:"کل نقره",       value:`${numFa((stats.total_silver_gram||0).toFixed(1))}`,
      sub:"گرم در سیستم",    color:"#16a34a", bg:"rgba(22,163,74,0.08)",
      icon:<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#16a34a" strokeWidth="1.8" strokeLinecap="round"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>},
    {label:"ارزش نقره",     value:`${fmtRial(Math.round((stats.total_silver_value||0)/10))}`,
      sub:"ریال ارزش دارایی",color:"#0d9488", bg:"rgba(13,148,136,0.08)",
      icon:<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#0d9488" strokeWidth="1.8" strokeLinecap="round"><line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 000 7h5a3.5 3.5 0 010 7H6"/></svg>},
    {label:"کیف پول کل",    value:`${fmtRial(Math.round((stats.total_rial||0)/10))}`,
      sub:"ریال موجودی",color:"#b45309", bg:"rgba(180,83,9,0.08)",
      icon:<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#b45309" strokeWidth="1.8" strokeLinecap="round"><rect x="1" y="4" width="22" height="16" rx="2"/><line x1="1" y1="10" x2="23" y2="10"/></svg>},
  ];

  const TODAY = [
    {label:"خرید",    value:numFa(stats.today_buy||0),      unit:"سفارش", color:"#16a34a", bg:"rgba(22,163,74,0.07)"},
    {label:"فروش",    value:numFa(stats.today_sell||0),     unit:"سفارش", color:"#dc2626", bg:"rgba(220,38,38,0.07)"},
    {label:"انتقال",  value:numFa(stats.today_transfer||0), unit:"تراکنش",color:"#2F2C79", bg:"rgba(47,44,121,0.07)"},
    {label:"تحویل",   value:numFa(stats.today_delivery||0), unit:"درخواست",color:"#0d9488",bg:"rgba(13,148,136,0.07)"},
  ];


  const QUEUE = [
    {k:"buys",        l:"خرید ساچمه",      c:pending.buy,      color:"#16a34a"},
    {k:"barbuy",      l:"خرید شمش",        c:pending.barbuy,   color:"#b45309"},
    {k:"goldbuy",     l:"خرید طلا",         c:pending.goldbuy,  color:"#ca8a04"},
    {k:"sells",       l:"فروش نقره",       c:pending.sell,     color:"#dc2626"},
    {k:"charges",     l:"شارژ کیف پول",    c:pending.charge,   color:"#2F2C79"},
    {k:"withdrawals", l:"برداشت وجه",      c:pending.withdraw, color:"#b45309"},
    {k:"deliveries",  l:"تحویل فیزیکی",   c:pending.delivery, color:"#0d9488"},
    {k:"ibans",       l:"حساب‌های بانکی", c:pending.iban,     color:"#7c3aed"},
    {k:"tickets",     l:"تیکت پشتیبانی",  c:pending.tickets,  color:"#4338ca"},
  ];
  const barStatsCard = barStats&&barStats.bars&&barStats.bars.length>0?(
    <div style={{background:"#fff",border:`1px solid ${C.border}`,borderRadius:16,padding:"16px",marginBottom:16}}>
      <div style={{fontSize:13,fontWeight:700,color:C.textMuted,marginBottom:12}}>آمار شمش نقره</div>
      {barStats.bars.map((b,i)=>(
        <div key={i} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"8px 0",borderBottom:`1px solid ${C.border}`}}>
          <div><div style={{fontSize:14,fontWeight:600}}>{b.name}</div><div style={{fontSize:12,color:C.textMuted}}>{numFa(b.order_count||0)} سفارش</div></div>
          <div style={{textAlign:"left"}}><div style={{fontSize:15,fontWeight:700,color:"#b45309"}}>{fmtGram(b.total_sold_gram||0)} گرم</div>{b.pending_gram>0&&<div style={{fontSize:11,color:C.red}}>در انتظار: {fmtGram(b.pending_gram)} گ</div>}</div>
        </div>
      ))}
      <div style={{display:"flex",justifyContent:"space-between",marginTop:10,paddingTop:8,borderTop:`1px solid ${C.border}`}}>
        <span style={{fontSize:13,color:C.textMuted}}>کل ساچمه مورد نیاز برای تامین</span>
        <span style={{fontSize:14,fontWeight:700,color:C.primary}}>{fmtGram(barStats.total_shot_needed)} گرم</span>
      </div>
    </div>
  ):null;

  return (
    <div className="fade-up">
      {/* ۴ کارت متریک */}
      <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:12,marginBottom:20}}>
        {METRICS.map(m => (
          <div key={m.label} style={{background:"#fff",border:`1px solid ${C.border}`,
            borderRadius:14,padding:"16px",display:"flex",flexDirection:"column",gap:12}}>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start"}}>
              <div style={{fontSize:12,fontWeight:600,color:C.textMuted}}>{m.label}</div>
              <div style={{width:38,height:38,borderRadius:10,background:m.bg,
                display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
                {m.icon}
              </div>
            </div>
            <div>
              <div style={{fontSize:26,fontWeight:900,color:m.color,lineHeight:1,letterSpacing:-0.5}}>
                {m.value}
              </div>
              <div style={{fontSize:11,color:C.textMuted,marginTop:4}}>{m.sub}</div>
            </div>
          </div>
        ))}
      </div>

      {/* دو ستون */}
      <div className="dashboard-grid">

        {/* ستون چپ */}
        <div style={{display:"flex",flexDirection:"column",gap:16}}>
          {/* فعالیت امروز */}
          <div style={{background:"#fff",border:`1px solid ${C.border}`,borderRadius:14,padding:"16px"}}>
            <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:14}}>
              <div style={{width:7,height:7,borderRadius:"50%",background:C.green,animation:"pulse 2s infinite"}}/>
              <div style={{fontSize:13,fontWeight:700,color:C.text}}>فعالیت امروز</div>
            </div>
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10}}>
              {TODAY.map(t => (
                <div key={t.label} style={{borderRadius:12,padding:"14px 12px",background:t.bg,
                  display:"flex",flexDirection:"column",gap:4}}>
                  <div style={{fontSize:32,fontWeight:900,color:t.color,lineHeight:1}}>{t.value}</div>
                  <div style={{fontSize:12,color:C.textMuted}}>{t.label}</div>
                  <div style={{fontSize:11,color:t.color,opacity:.7}}>{t.unit}</div>
                </div>
              ))}
            </div>
          </div>

          {/* خلاصه */}
          <div style={{background:"#fff",border:`1px solid ${C.border}`,borderRadius:14,padding:"16px"}}>
            <div style={{fontSize:13,fontWeight:700,color:C.text,marginBottom:14}}>خلاصه سیستم</div>
            {[
              {l:"کاربران فعال",    v:numFa(stats.active_users||0),    color:C.green},
              {l:"کاربران تأیید شده",v:numFa(stats.verified_users||0), color:C.primary},
              {l:"تراکنش‌های امروز", v:numFa((stats.today_buy||0)+(stats.today_sell||0)), color:C.teal},
            ].map(({l,v,color})=>(
              <div key={l} style={{display:"flex",justifyContent:"space-between",alignItems:"center",
                padding:"10px 0",borderBottom:`1px solid ${C.border}`}}>
                <span style={{fontSize:13,color:C.textSub}}>{l}</span>
                <span style={{fontSize:15,fontWeight:800,color}}>{v}</span>
              </div>
            ))}
          </div>
          {barStatsCard&&<div style={{marginTop:16}}>{barStatsCard}</div>}
        </div>

        {/* ستون راست — صف انتظار */}
        <div style={{background:"#fff",border:`1px solid ${C.border}`,borderRadius:14,padding:"16px"}}>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:14}}>
            <div style={{fontSize:13,fontWeight:700,color:C.text}}>صف انتظار</div>
            {pending.total>0 && (
              <span style={{fontSize:12,fontWeight:700,padding:"2px 10px",borderRadius:20,
                background:C.redBg,color:C.red,border:`1px solid ${C.red}22`}}>
                {numFa(pending.total)} مورد
              </span>
            )}
          </div>
          <div style={{display:"flex",flexDirection:"column",gap:6}}>
            {QUEUE.map(({k,l,c,color}) => {
              const has = (c||0) > 0;
              return (
                <div key={k} onClick={()=>onNav(k)} style={{
                  display:"flex",justifyContent:"space-between",alignItems:"center",
                  padding:"11px 14px",borderRadius:10,cursor:"pointer",
                  background:has?`${color}06`:"#FAFAFA",
                  border:`1px solid ${has?`${color}22`:C.border}`,transition:"all .15s"}}
                  onMouseEnter={e=>{e.currentTarget.style.background=`${color}10`;}}
                  onMouseLeave={e=>{e.currentTarget.style.background=has?`${color}06`:"#FAFAFA";}}>
                  <div style={{display:"flex",alignItems:"center",gap:10}}>
                    <div style={{width:8,height:8,borderRadius:"50%",
                      background:has?color:"#ddd",flexShrink:0}} />
                    <span style={{fontSize:13,fontWeight:has?700:500,
                      color:has?C.text:C.textMuted}}>{l}</span>
                  </div>
                  <div style={{display:"flex",alignItems:"center",gap:8}}>
                    {has ? (
                      <span style={{fontSize:13,fontWeight:800,color:"#fff",
                        background:color,borderRadius:20,padding:"2px 10px",minWidth:28,textAlign:"center"}}>
                        {numFa(c)}
                      </span>
                    ) : (
                      <span style={{fontSize:12,color:"#ccc"}}>—</span>
                    )}
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none"
                      stroke={has?color:C.textMuted} strokeWidth="2.5" strokeLinecap="round">
                      <polyline points="9 18 15 12 9 6"/>
                    </svg>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}

// ─── Order Row Renderers ───────────────────────────────────────────────────────
const UserMeta = ({name, mobile, code, date}) => (
  <div>
    <div style={{fontSize:14,fontWeight:700,color:C.text}}>{name}</div>
    <div style={{fontSize:12,color:C.textSub,marginTop:1}}>{mobile}</div>
    {code && <div style={{fontSize:11,color:C.textMuted,marginTop:1,fontFamily:"monospace",letterSpacing:.5}}>{code}</div>}
    {date && <div style={{fontSize:11,color:C.textMuted}}>{fmtDateFa(date)}</div>}
  </div>
);

const GoldBuyRow = ({o}) => (
  <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",gap:8}}>
    <UserMeta name={`${o.first_name||""} ${o.last_name||""}`} mobile={o.mobile} code={o.tracking_code} date={o.created_at} />
    <div style={{textAlign:"left",flexShrink:0}}>
      <div style={{fontSize:14,fontWeight:700,color:"#ca8a04"}}>{fmtGram(o.gram)} گرم طلا</div>
      <div style={{fontSize:12,color:C.textSub}}>{fmtRial(Math.round(o.total_amount_rial))} ر</div>
      <div style={{fontSize:11,color:C.textMuted}}>{o.payment_method==="bank_transfer"?"کارت‌به‌کارت":"کیف پول"}</div>
      {o.receipt_file&&<a href={`/api/v1/uploads/${o.receipt_file}`} target="_blank" rel="noreferrer" style={{fontSize:11,color:C.primary,display:"flex",alignItems:"center",gap:3,marginTop:3,textDecoration:"none"}}><IconFile/>فیش</a>}
    </div>
  </div>
);

const BarBuyRow = ({o}) => (
  <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",gap:8}}>
    <UserMeta name={`${o.first_name||""} ${o.last_name||""}`} mobile={o.mobile} code={o.tracking_code} date={o.created_at} />
    <div style={{textAlign:"left",flexShrink:0}}>
      <div style={{fontSize:14,fontWeight:700,color:"#92400e"}}>{fmtGram(o.gram)} گرم شمش</div>
      <div style={{fontSize:12,color:C.textSub}}>{o.bar_name}</div>
      <div style={{fontSize:12,color:C.textSub}}>{fmtRial(Math.round(o.total_amount_rial))} ر</div>
      {o.shot_equivalent&&<div style={{fontSize:11,color:C.primary,marginTop:2}}>معادل ساچمه: {fmtGram(o.shot_equivalent)} گ</div>}
      {o.receipt_file&&<a href={`/api/v1/uploads/${o.receipt_file}`} target="_blank" rel="noreferrer" style={{fontSize:11,color:C.primary,display:"flex",alignItems:"center",gap:3,marginTop:3,textDecoration:"none"}}><IconFile/>فیش</a>}
    </div>
  </div>
);

const BuyRow = ({o}) => (
  <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",gap:8}}>
    <UserMeta name={`${o.first_name||""} ${o.last_name||""}`} mobile={o.mobile} code={o.tracking_code} date={o.created_at} />
    <div style={{textAlign:"left",flexShrink:0}}>
      <div style={{fontSize:14,fontWeight:700,color:C.text}}>{fmtGram(o.gram)} گرم</div>
      <div style={{fontSize:12,color:C.textSub}}>{fmtRial(Math.round(o.total_amount_rial))} ر</div>
      <div style={{fontSize:11,color:C.textMuted}}>{o.payment_method==="bank_transfer"?"کارت‌به‌کارت":"کیف پول"}</div>
      {o.receipt_file && <a href={`/api/v1/uploads/${o.receipt_file}`} target="_blank" rel="noreferrer" style={{fontSize:11,color:C.primary,display:"flex",alignItems:"center",gap:3,marginTop:3,textDecoration:"none"}}><IconFile/>فیش</a>}
    </div>
  </div>
);

const SellRow = ({o}) => (
  <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",gap:8}}>
    <UserMeta name={`${o.first_name||""} ${o.last_name||""}`} mobile={o.mobile} code={o.tracking_code} date={o.created_at} />
    <div style={{textAlign:"left",flexShrink:0}}>
      <div style={{fontSize:14,fontWeight:700,color:C.text}}>{fmtGram(o.gram)} گرم</div>
      <div style={{fontSize:12,color:C.textSub}}>{fmtRial(Math.round((o.total_amount_rial||0)/10))} ر</div>
      {o.iban && <div style={{fontSize:11,color:C.textMuted,fontFamily:"monospace"}}>شبا: {o.iban.slice(-8)}</div>}
    </div>
  </div>
);

const ChargeRow = ({o}) => (
  <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",gap:8}}>
    <UserMeta name={`${o.first_name||""} ${o.last_name||""}`} mobile={o.mobile} code={o.tracking_code} date={o.created_at} />
    <div style={{textAlign:"left",flexShrink:0}}>
      <div style={{fontSize:16,fontWeight:800,color:C.green}}>{fmtRial(Math.round(o.amount_rial))}</div>
      <div style={{fontSize:11,color:C.textMuted}}>ریال</div>
      {o.receipt_file && <a href={`/api/v1/uploads/${o.receipt_file}`} target="_blank" rel="noreferrer" style={{fontSize:11,color:C.primary,display:"flex",alignItems:"center",gap:3,marginTop:3,textDecoration:"none"}}><IconFile/>فیش</a>}
    </div>
  </div>
);

const IbanRow = ({o}) => (
  <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",gap:8}}>
    <UserMeta name={`${o.first_name||""} ${o.last_name||""}`} mobile={o.mobile} date={o.created_at} />
    <div style={{textAlign:"left",flexShrink:0,maxWidth:180}}>
      <div style={{fontSize:13,fontWeight:600}}>{o.account_owner}</div>
      <div style={{fontSize:11,color:C.textSub,fontFamily:"monospace",wordBreak:"break-all"}}>{o.iban||o.card_number}</div>
    </div>
  </div>
);

// ─── Generic Order List ────────────────────────────────────────────────────────
function AdminOrderList({title, api, show, endpoint, onRefresh, renderRow, approveUrl, rejectUrl}) {
  const [items,setItems]   = useState([]);
  const [tab,setTab]       = useState("pending");
  const [loading,setL]     = useState(true);
  const [confirm,setConfirm] = useState(null); // {item, action}

  const load = useCallback(() => {
    setL(true);
    api("GET",`${endpoint}?status=${tab}`).then(setItems).catch(()=>{}).finally(()=>setL(false));
  }, [api, endpoint, tab]);

  useEffect(()=>{ load(); },[tab]);

  const [rejNote,setRejNote] = useState("");
  const act = async (url, msg, body) => {
    try { await api("POST",url,body||{}); show(msg,"success"); setConfirm(null); setRejNote(""); load(); onRefresh(); }
    catch(e) { show(e.message,"error"); }
  };

  return (
    <div className="fade-up">
      <SectionHeader title={title} count={items.filter(i=>i.status==="pending").length} />

      <TabBar
        tabs={[["pending","در انتظار"],["approved","تأیید شده"],["rejected","رد شده"]]}
        active={tab} onChange={setTab} />

      {loading ? (
        <div style={{textAlign:"center",padding:48}}><Spinner size={32}/></div>
      ) : items.length===0 ? <Empty/> : items.map(item => (
        <Card key={item.id} style={{marginBottom:10}}>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:tab==="pending"?12:0}}>
            <div style={{flex:1}}>{renderRow(item)}</div>
            <div style={{marginRight:12,flexShrink:0}}><Badge status={item.status}/></div>
          </div>

          {tab==="pending" && (
            <div style={{display:"flex",gap:8,paddingTop:12,borderTop:`1px solid ${C.border}`}}>
              <Btn variant="green" style={{flex:1,gap:6}} onClick={()=>setConfirm({item,action:"approve"})}>
                <IconCheck/> تأیید
              </Btn>
              <Btn variant="red" style={{flex:1,gap:6}} onClick={()=>setConfirm({item,action:"reject"})}>
                <IconX/> رد
              </Btn>
            </div>
          )}
          {tab==="approved" && (
            <div style={{display:"flex",gap:8,paddingTop:12,borderTop:`1px solid ${C.border}`}}>
              <Btn variant="red" size="sm" style={{gap:6}} onClick={()=>setConfirm({item,action:"reject"})}>
                <IconX/> رد کردن با دلیل
              </Btn>
            </div>
          )}
        </Card>
      ))}

      {/* Confirm modal */}
      {confirm && (
        <Modal title={confirm.action==="approve"?"تأیید درخواست؟":"رد درخواست؟"} onClose={()=>{setConfirm(null);setRejNote("");}}>
          <div style={{fontSize:14,color:C.textSub,marginBottom:16,lineHeight:1.8}}>
            {confirm.action==="approve"
              ? "با تأیید این درخواست، عملیات انجام می‌شود و قابل بازگشت نیست."
              : confirm.item.status==="approved"
                ? "این درخواست قبلاً تأیید شده. با رد آن، مبلغ از موجودی کاربر کسر می‌شود. ذکر دلیل الزامی است."
                : "با رد این درخواست، وجه/موجودی به کاربر بازگردانده می‌شود."}
          </div>
          {confirm.action==="reject" && (
            <textarea value={rejNote} onChange={e=>setRejNote(e.target.value)} placeholder="دلیل رد..."
              style={{width:"100%",boxSizing:"border-box",minHeight:70,padding:"10px 12px",borderRadius:12,
                border:`1px solid ${C.border}`,fontFamily:"Ray,sans-serif",fontSize:14,marginBottom:16,resize:"vertical",outline:"none"}} />
          )}
          <div style={{display:"flex",gap:10}}>
            <Btn variant="ghost" style={{flex:1}} onClick={()=>{setConfirm(null);setRejNote("");}}>انصراف</Btn>
            <Btn variant={confirm.action==="approve"?"green":"danger"} style={{flex:1}}
              disabled={confirm.action==="reject" && confirm.item.status==="approved" && !rejNote.trim()}
              onClick={()=>act(confirm.action==="approve"?approveUrl(confirm.item):rejectUrl(confirm.item),
                confirm.action==="approve"?"تأیید شد":"رد شد",
                confirm.action==="reject"?{note:rejNote}:{})}>
              {confirm.action==="approve"?"تأیید نهایی":"رد نهایی"}
            </Btn>
          </div>
        </Modal>
      )}
    </div>
  );
}

// ─── Withdrawals ───────────────────────────────────────────────────────────────
function AdminWithdrawalsList({api, show, onRefresh}) {
  const [items,setItems]   = useState([]);
  const [tab,setTab]       = useState("pending");
  const [tracks,setTracks] = useState({});
  const [loading,setL]     = useState(true);
  const [confirm,setConfirm] = useState(null);

  const load = useCallback(() => {
    setL(true);
    api("GET",`/admin/withdrawals?status=${tab}`).then(setItems).catch(()=>{}).finally(()=>setL(false));
  }, [api, tab]);
  useEffect(()=>{load();},[tab]);

  const pay = async (w) => {
    try {
      await api("POST",`/admin/withdrawals/${w.id}/pay`,{payment_tracking_number:tracks[w.id]||""});
      show("پرداخت ثبت شد","success"); setConfirm(null); load(); onRefresh();
    } catch(e) { show(e.message,"error"); }
  };

  const reject = async (w) => {
    try {
      await api("POST",`/admin/withdrawals/${w.id}/reject`,{});
      show("رد شد","success"); setConfirm(null); load(); onRefresh();
    } catch(e) { show(e.message,"error"); }
  };

  return (
    <div className="fade-up">
      <SectionHeader title="برداشت از کیف پول" color={C.yellow} />
      <TabBar tabs={[["pending","در انتظار"],["paid","پرداخت شده"],["rejected","رد"]]} active={tab} onChange={setTab} />

      {loading ? <div style={{textAlign:"center",padding:48}}><Spinner size={32}/></div>
       : items.length===0 ? <Empty/>
       : items.map(w => (
        <Card key={w.id} style={{marginBottom:10}}>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:tab==="pending"?12:0}}>
            <UserMeta name={`${w.first_name||""} ${w.last_name||""}`} mobile={w.mobile} code={w.tracking_code} date={w.created_at} />
            <div style={{textAlign:"left",flexShrink:0}}>
              <div style={{fontSize:16,fontWeight:800,color:C.yellow}}>{fmtRial(Math.round(w.amount_rial))}</div>
              <div style={{fontSize:11,color:C.textMuted}}>ریال</div>
              <div style={{fontSize:11,color:C.textSub,maxWidth:140,overflow:"hidden",textOverflow:"ellipsis"}}>{w.account_owner}</div>
              {w.iban && <div style={{fontSize:10,color:C.textMuted,fontFamily:"monospace"}}>{w.iban.slice(-8)}</div>}
              <div style={{marginTop:4}}><Badge status={w.status}/></div>
            </div>
          </div>

          {tab==="pending" && (
            <div style={{paddingTop:12,borderTop:`1px solid ${C.border}`}}>
              <input value={tracks[w.id]||""} onChange={e=>setTracks(p=>({...p,[w.id]:e.target.value}))}
                placeholder="شماره پیگیری واریز (اختیاری)"
                style={{width:"100%",padding:"9px 12px",borderRadius:10,border:`1.5px solid ${C.border}`,
                  background:C.bgCard,color:C.text,fontSize:13,fontFamily:"Ray,sans-serif",
                  marginBottom:10,outline:"none",direction:"ltr"}} />
              <div style={{display:"flex",gap:8}}>
                <Btn variant="green" style={{flex:1,gap:6}} onClick={()=>setConfirm({w,action:"pay"})}>
                  <IconCheck/> پرداخت شد
                </Btn>
                <Btn variant="red" style={{flex:1,gap:6}} onClick={()=>setConfirm({w,action:"reject"})}>
                  <IconX/> رد
                </Btn>
              </div>
            </div>
          )}
          {w.payment_tracking_number && <div style={{fontSize:12,color:C.green,marginTop:8}}>شماره پیگیری: {w.payment_tracking_number}</div>}
        </Card>
      ))}

      {confirm && (
        <Modal title={confirm.action==="pay"?"تأیید پرداخت؟":"رد درخواست؟"} onClose={()=>setConfirm(null)}>
          <div style={{fontSize:14,color:C.textSub,marginBottom:20,lineHeight:1.8}}>
            {confirm.action==="pay" ? `پرداخت ${fmtRial(Math.round(confirm.w.amount_rial))} ریال به ${confirm.w.account_owner} تأیید می‌شود.`
              : "مبلغ درخواست به کیف پول کاربر بازمی‌گردد."}
          </div>
          <div style={{display:"flex",gap:10}}>
            <Btn variant="ghost" style={{flex:1}} onClick={()=>setConfirm(null)}>انصراف</Btn>
            <Btn variant={confirm.action==="pay"?"green":"danger"} style={{flex:1}}
              onClick={()=>confirm.action==="pay"?pay(confirm.w):reject(confirm.w)}>
              {confirm.action==="pay"?"تأیید پرداخت":"رد نهایی"}
            </Btn>
          </div>
        </Modal>
      )}
    </div>
  );
}

// ─── Deliveries ───────────────────────────────────────────────────────────────
function AdminDeliveriesList({api, show, onRefresh}) {
  const [items,setItems]   = useState([]);
  const [tab,setTab]       = useState("pending");
  const [tracks,setTracks] = useState({});
  const [loading,setL]     = useState(true);

  const load = useCallback(()=>{
    setL(true);
    api("GET",`/admin/deliveries?status=${tab}`).then(setItems).catch(()=>{}).finally(()=>setL(false));
  },[api,tab]);
  useEffect(()=>{load();},[tab]);

  const doAction = async (url, msg) => {
    try { await api("POST",url,{}); show(msg,"success"); load(); onRefresh(); } catch(e) { show(e.message,"error"); }
  };

  return (
    <div className="fade-up">
      <SectionHeader title="تحویل فیزیکی" color={C.teal} />
      <TabBar tabs={[["pending","در انتظار"],["approved","تأیید"],["completed","تکمیل"],["rejected","رد"]]} active={tab} onChange={setTab} />

      {loading ? <div style={{textAlign:"center",padding:48}}><Spinner size={32}/></div>
       : items.length===0 ? <Empty/>
       : items.map(d => (
        <Card key={d.id} style={{marginBottom:10}}>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:tab==="pending"?12:8}}>
            <UserMeta name={`${d.first_name||""} ${d.last_name||""}`} mobile={d.mobile} code={d.tracking_code} date={d.created_at} />
            <div style={{textAlign:"left",flexShrink:0}}>
              <div style={{fontSize:16,fontWeight:800,color:C.teal}}>{numFa(d.gram)} گرم</div>
              <div style={{fontSize:11,color:C.textSub}}>{d.city||""}</div>
              <div style={{fontSize:11,color:C.textMuted}}>{d.receiver_name||""}</div>
              <div style={{marginTop:4}}><Badge status={d.status}/></div>
            </div>
          </div>

          {d.tracking_number && (
            <div style={{fontSize:12,color:C.green,background:C.greenBg,borderRadius:8,padding:"6px 10px",marginBottom:tab==="pending"?8:0}}>
              کد رهگیری: {d.tracking_number}
            </div>
          )}

          {tab==="pending" && (
            <div style={{paddingTop:12,borderTop:`1px solid ${C.border}`}}>
              <div style={{display:"flex",gap:8,marginBottom:8}}>
                <input value={tracks[d.id]||""} onChange={e=>setTracks(p=>({...p,[d.id]:e.target.value}))}
                  placeholder="کد رهگیری پستی (اختیاری)"
                  style={{flex:1,padding:"9px 12px",borderRadius:10,border:`1.5px solid ${C.border}`,
                    background:C.bgCard,color:C.text,fontSize:13,fontFamily:"Ray,sans-serif",
                    outline:"none",direction:"ltr"}} />
                <Btn variant="brand" size="sm" onClick={async()=>{
                  try{await api("POST",`/admin/deliveries/${d.id}/set-tracking`,{tracking_number:tracks[d.id]||""});show("کد ثبت شد","success");load();}catch(e){show(e.message,"error");}
                }}>ثبت کد</Btn>
              </div>
              <div style={{display:"flex",gap:8}}>
                <Btn variant="green" style={{flex:1,gap:6}} onClick={()=>doAction(`/admin/deliveries/${d.id}/approve`,"تأیید شد")}>
                  <IconCheck/> تأیید
                </Btn>
                <Btn variant="red" style={{flex:1,gap:6}} onClick={()=>doAction(`/admin/deliveries/${d.id}/reject`,"رد شد")}>
                  <IconX/> رد
                </Btn>
              </div>
            </div>
          )}
        </Card>
      ))}
    </div>
  );
}

// ─── Tickets ──────────────────────────────────────────────────────────────────
function AdminTicketList({api, show}) {
  const [tickets,setT]   = useState([]);
  const [sel,setSel]     = useState(null);
  const [tab,setTab]     = useState("open");
  const [loading,setL]   = useState(true);

  const load = useCallback(()=>{
    setL(true);
    api("GET",`/admin/tickets?status=${tab}`).then(setT).catch(()=>{}).finally(()=>setL(false));
  },[api,tab]);
  useEffect(()=>{load();},[tab]);

  const openTicket = async (t) => {
    try { const d = await api("GET",`/user/tickets/${t.id}`); setSel({...d,ticket:{...d.ticket,mobile:t.mobile}}); }
    catch(e) { show(e.message,"error"); }
  };

  if (sel) return <TicketChat sel={sel} api={api} show={show} onBack={()=>{setSel(null);load();}} />;

  return (
    <div className="fade-up">
      <SectionHeader title="تیکت‌های پشتیبانی" color={C.indigo} />
      <TabBar
        tabs={[["open","باز",C.primary],["answered","پاسخ داده",C.teal],["closed","بسته",C.textMuted]]}
        active={tab} onChange={setTab} />

      {loading ? <div style={{textAlign:"center",padding:48}}><Spinner size={32}/></div>
       : tickets.length===0 ? <Empty text="تیکتی در این وضعیت نیست"/>
       : tickets.map(t => (
        <Card key={t.id} onClick={()=>openTicket(t)} style={{marginBottom:8,cursor:"pointer"}}>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start"}}>
            <div>
              <div style={{fontSize:14,fontWeight:700,color:C.text,marginBottom:3}}>{t.subject}</div>
              <div style={{fontSize:12,color:C.textSub}}>{t.mobile}</div>
              <div style={{fontSize:11,color:C.textMuted,marginTop:2}}>{fmtDateFa(t.created_at)}</div>
            </div>
            <div style={{display:"flex",flexDirection:"column",alignItems:"flex-end",gap:6}}>
              <Badge status={t.status}/>
              <div style={{color:C.textMuted,display:"flex"}}><IconBack/></div>
            </div>
          </div>
        </Card>
      ))}
    </div>
  );
}

// ─── Ticket Chat ───────────────────────────────────────────────────────────────
function TicketChat({sel, api, show, onBack}) {
  const [reply,setReply]   = useState("");
  const [loading,setL]     = useState(false);
  const [messages,setMsgs] = useState(sel.messages||[]);
  const bottomRef = useRef();

  useEffect(()=>{bottomRef.current?.scrollIntoView({behavior:"smooth"});},[messages]);

  const send = async () => {
    if (!reply.trim()) return;
    setL(true);
    try {
      await api("POST",`/admin/tickets/${sel.ticket.id}/reply`,{message:reply});
      show("ارسال شد","success");
      setReply("");
      const u = await api("GET",`/user/tickets/${sel.ticket.id}`);
      setMsgs(u.messages||[]);
    } catch(e) { show(e.message,"error"); }
    setL(false);
  };

  const close = async () => {
    try {
      await api("POST",`/admin/tickets/${sel.ticket.id}/close`,{});
      show("بسته شد","success");
      onBack();
    } catch(e) { show(e.message,"error"); }
  };

  return (
    <div className="fade-up" style={{display:"flex",flexDirection:"column",height:"calc(100vh - 120px)"}}>
      {/* Header */}
      <div style={{display:"flex",alignItems:"center",gap:12,marginBottom:16,flexShrink:0}}>
        <button onClick={onBack} style={{background:C.bgDeep,border:"none",borderRadius:10,
          width:36,height:36,display:"flex",alignItems:"center",justifyContent:"center",cursor:"pointer"}}>
          <IconBack/>
        </button>
        <div style={{flex:1}}>
          <div style={{fontSize:15,fontWeight:700,color:C.text}}>{sel.ticket.subject}</div>
          <div style={{fontSize:12,color:C.textMuted}}>{sel.ticket.mobile} — <Badge status={sel.ticket.status}/></div>
        </div>
        {sel.ticket.status!=="closed" && (
          <Btn variant="ghost" size="sm" onClick={close}>بستن تیکت</Btn>
        )}
      </div>

      {/* Messages */}
      <div style={{flex:1,overflowY:"auto",display:"flex",flexDirection:"column",gap:10,paddingBottom:8}}>
        {messages.map(m => {
          const isAdmin = m.sender_type==="admin";
          return (
            <div key={m.id} style={{display:"flex",flexDirection:"column",
              alignItems:isAdmin?"flex-end":"flex-start"}}>
              <div style={{
                maxWidth:"80%",padding:"10px 14px",borderRadius:isAdmin?"16px 4px 16px 16px":"4px 16px 16px 16px",
                background:isAdmin?`linear-gradient(135deg,${C.primaryLight},${C.primary})`:"#fff",
                color:isAdmin?"#fff":C.text,
                border:isAdmin?"none":`1px solid ${C.border}`,
                boxShadow:isAdmin?"0 2px 8px rgba(47,44,121,0.2)":"0 1px 4px rgba(0,0,0,0.06)"}}>
                <div style={{fontSize:14,lineHeight:1.7}}>{m.message}</div>
              </div>
              <div style={{fontSize:11,color:C.textMuted,marginTop:3,paddingRight:isAdmin?0:4,paddingLeft:isAdmin?4:0}}>
                {isAdmin?"ادمین":"کاربر"} — {fmtDateFa(m.created_at)}
              </div>
            </div>
          );
        })}
        <div ref={bottomRef} />
      </div>

      {/* Input */}
      {sel.ticket.status!=="closed" && (
        <div style={{flexShrink:0,paddingTop:12,borderTop:`1px solid ${C.border}`,display:"flex",gap:10}}>
          <textarea value={reply} onChange={e=>setReply(e.target.value)}
            placeholder="پاسخ ادمین..."
            rows={2} onKeyDown={e=>{if(e.key==="Enter"&&!e.shiftKey){e.preventDefault();send();}}}
            style={{flex:1,padding:"10px 14px",borderRadius:12,border:`1.5px solid ${C.border}`,
              background:"#fff",color:C.text,fontSize:14,fontFamily:"Ray,sans-serif",
              direction:"rtl",outline:"none",resize:"none",lineHeight:1.6}} />
          <Btn variant="primary" loading={loading} onClick={send} style={{alignSelf:"flex-end",gap:6}}>
            <IconSend/> ارسال
          </Btn>
        </div>
      )}
    </div>
  );
}

// ─── Users ────────────────────────────────────────────────────────────────────
function AdminBarsPanel({api, show}) {
  const [bars,setBars]=useState([]);const[loading,setL]=useState(true);const[modal,setModal]=useState(null);
  const [form,setForm]=useState({name:"",weight_gram:"",price_per_gram_rial:"",is_active:1});
  const load=()=>{api("GET","/admin/bars").then(setBars).catch(()=>{}).finally(()=>setL(false));};
  useEffect(()=>{load();},[]);
  const save=async()=>{
    try{
      if(modal.id){await api("PUT",`/admin/bars/${modal.id}`,form);}
      else{await api("POST","/admin/bars",form);}
      show("ذخیره شد","success");setModal(null);load();
    }catch(e){show(e.message,"error");}
  };
  return(<div>
    <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:16}}>
      <div style={{fontSize:16,fontWeight:800}}>مدیریت شمش‌ها</div>
      <Btn variant="primary" size="sm" onClick={()=>{setForm({name:"",weight_gram:"",price_per_gram_rial:"",is_active:1});setModal({});}}>+ افزودن شمش</Btn>
    </div>
    {loading?<div style={{textAlign:"center",padding:40}}><Spinner size={32}/></div>:bars.map(b=>(
      <Card key={b.id} style={{marginBottom:8}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
          <div>
            <div style={{fontSize:15,fontWeight:700}}>{b.name}</div>
            <div style={{fontSize:13,color:C.textMuted}}>{numFa(b.weight_gram)} گرم — {fmtRial(b.price_per_gram_rial)} ر/گرم</div>
            <div style={{fontSize:12,color:b.is_active?C.green:C.red,marginTop:2}}>{b.is_active?"فعال":"غیرفعال"}</div>
          </div>
          <Btn variant="ghost" size="sm" onClick={()=>{setForm({name:b.name,weight_gram:b.weight_gram,price_per_gram_rial:b.price_per_gram_rial,is_active:b.is_active});setModal(b);}}>ویرایش</Btn>
        </div>
      </Card>
    ))}
    {modal&&(
      <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.3)",display:"flex",alignItems:"flex-end",justifyContent:"center",zIndex:600}} onClick={()=>setModal(null)}>
        <div style={{background:"#fff",borderRadius:"22px 22px 0 0",padding:"8px 22px 40px",width:"100%",maxWidth:480}} onClick={e=>e.stopPropagation()}>
          <div style={{width:40,height:4,background:C.border,borderRadius:2,margin:"12px auto 20px"}}/>
          <div style={{fontSize:16,fontWeight:700,marginBottom:16}}>{modal.id?"ویرایش شمش":"افزودن شمش"}</div>
          <Input label="نام شمش" value={form.name} onChange={e=>setForm(p=>({...p,name:e.target.value}))}/>
          <Input label="وزن (گرم)" type="number" value={form.weight_gram} onChange={e=>setForm(p=>({...p,weight_gram:e.target.value}))}/>
          <Input label="قیمت هر گرم (ریال)" type="number" value={form.price_per_gram_rial} onChange={e=>setForm(p=>({...p,price_per_gram_rial:e.target.value}))}/>
          <Select label="وضعیت" value={form.is_active} onChange={e=>setForm(p=>({...p,is_active:parseInt(e.target.value)}))}>
            <option value={1}>فعال</option>
            <option value={0}>غیرفعال</option>
          </Select>
          <Btn variant="primary" fullWidth onClick={save}>ذخیره</Btn>
        </div>
      </div>
    )}
  </div>);
}

function ResetPasswordForm({api, show, userId}) {
  const [newPass,setNewPass]=useState("");const[loading,setL]=useState(false);
  const submit=async()=>{
    if(!newPass||newPass.length<6){show("رمز باید حداقل ۶ کاراکتر باشد","error");return;}
    setL(true);
    try{await api("POST",`/admin/users/${userId}/reset-password`,{new_password:newPass});show("رمز با موفقیت تغییر کرد","success");setNewPass("");}
    catch(e){show(e.message,"error");}
    setL(false);
  };
  return(<div style={{display:"flex",gap:8,alignItems:"flex-end"}}>
    <div style={{flex:1}}><Input label="رمز جدید" type="password" value={newPass} onChange={e=>setNewPass(e.target.value)}/></div>
    <Btn variant="primary" size="sm" loading={loading} onClick={submit} style={{marginBottom:14}}>ثبت</Btn>
  </div>);
}

function AdminUserList({api, show}) {
  const [users,setUsers]   = useState([]);
  const [search,setSearch] = useState("");
  const [sel,setSel]       = useState(null);
  const [loading,setL]     = useState(false);
  const [txns,setTxns]     = useState([]);
  const [adjModal,setAdjModal] = useState(false);
  const [adjType,setAdjType]   = useState("rial");
  const [adjAmount,setAdjAmount] = useState("");
  const [adjNote,setAdjNote]   = useState("");
  const [adjDir,setAdjDir]     = useState("add");
  const [adjLoading,setAdjL]   = useState(false);
  const [page,setPage]     = useState(1);
  const [total,setTotal]   = useState(0);
  useEffect(()=>{
    setL(true);setPage(1);
    api("GET",`/admin/users?search=${search}&page=1`).then(d=>{setUsers(d.users||d);setTotal(d.total||0);}).catch(()=>{}).finally(()=>setL(false));
  },[search]);
  useEffect(()=>{
    const onPop=()=>{ if(sel){ setSel(null); setTxns([]); setTimeout(restoreScroll,0); } };
    window.addEventListener("popstate",onPop);
    return ()=>window.removeEventListener("popstate",onPop);
  },[sel]);
  const loadMore=async()=>{
    const next=page+1;
    try{
      const d=await api("GET",`/admin/users?search=${search}&page=${next}`);
      setUsers(p=>[...p,...(d.users||[])]);
      setTotal(d.total||0);
      setPage(next);
    }catch(e){}
  };

  const userScroll = useRef(0);
  const scrollerEl = useRef(null);
  const findScroller = () => { let big=document.scrollingElement||document.documentElement, mx=big?big.scrollTop:0; document.querySelectorAll("div").forEach(d=>{if(d.scrollTop>mx){mx=d.scrollTop;big=d;}}); return big; };
  const openUser = async (u) => {
    try {
      const sc=findScroller(); scrollerEl.current=sc; userScroll.current=sc?sc.scrollTop:0;
      const d=await api("GET",`/admin/users/${u.id}`);
      setSel(d);
      window.history.pushState({userDetail:true},"");
      if(sc) sc.scrollTop=0;
      api("GET",`/admin/users/${u.id}/transactions`).then(setTxns).catch(()=>setTxns([]));
    } catch(e){show(e.message,"error");}
  };
  const restoreScroll = () => {
    const sc=scrollerEl.current;
    if(!sc) return;
    let tries=0;
    const tick=()=>{ sc.scrollTop=userScroll.current; if(++tries<10 && Math.abs(sc.scrollTop-userScroll.current)>2) requestAnimationFrame(tick); };
    requestAnimationFrame(tick);
  };
  const closeUser = () => { setSel(null); setTxns([]); setTimeout(restoreScroll,0); };

  const setStatus = async (status) => {
    try {
      await api("PUT",`/admin/users/${sel.id}/status`,{status});
      show("تغییر کرد","success");
      const d=await api("GET",`/admin/users/${sel.id}`); setSel(d);
    } catch(e){show(e.message,"error");}
  };

  const submitAdj = async () => {
    if(!adjAmount||parseFloat(adjAmount)<=0){show("مقدار را وارد کنید","error");return;}
    setAdjL(true);
    try {
      await api("POST",`/admin/users/${sel.id}/adjust`,{
        wallet_type: adjType,
        direction: adjDir,
        amount: parseFloat(adjAmount),
        note: adjNote
      });
      show("موجودی تغییر کرد","success");
      setAdjModal(false);setAdjAmount("");setAdjNote("");
      const d=await api("GET",`/admin/users/${sel.id}`); setSel(d);
      api("GET",`/admin/users/${sel.id}/transactions`).then(setTxns).catch(()=>{});
    } catch(e){show(e.message,"error");}
    setAdjL(false);
  };

  if (sel) return (
    <div className="fade-up">
      <div style={{display:"flex",alignItems:"center",gap:12,marginBottom:16}}>
        <button onClick={closeUser} style={{background:C.bgDeep,border:"none",borderRadius:10,
          width:36,height:36,display:"flex",alignItems:"center",justifyContent:"center",cursor:"pointer"}}>
          <IconBack/>
        </button>
        <div>
          <div style={{fontSize:16,fontWeight:800}}>{sel.first_name||""} {sel.last_name||""}</div>
          <div style={{fontSize:12,color:C.textMuted}}>{sel.mobile}</div>
          <div style={{fontSize:12,color:C.primary,fontWeight:700}}>{sel.user_code||""}</div>
        </div>
        <div style={{marginRight:"auto"}}><Badge status={sel.status}/></div>
      </div>

      {/* Stats */}
      <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:8,marginBottom:16}}>
        {[
          {l:"نقره",      v:`${fmtGram(sel.balance_gram)} گ`,                  color:C.teal},
          {l:"ریالی",     v:`${fmtRial(Math.round(sel.balance_rial||0))} ر`,   color:C.green},
          {l:"میانگین خرید",v:`${fmtRial(Math.round(sel.avg_cost||0))} ر/گ`,  color:C.primary},
        ].map(({l,v,color})=>(
          <div key={l} style={{background:`${color}08`,borderRadius:12,padding:"12px",border:`1px solid ${color}18`,textAlign:"center"}}>
            <div style={{fontSize:12,color:C.textMuted,marginBottom:4}}>{l}</div>
            <div style={{fontSize:14,fontWeight:700,color}}>{v}</div>
          </div>
        ))}
      </div>

      {/* Info */}
      <Card style={{marginBottom:12}}>
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10}}>
          {[
            {l:"کد ملی",v:sel.national_code||"—"},{l:"تاریخ تولد",v:sel.birth_date||"—"},
            {l:"هویت",v:sel.is_identity_verified?"تأیید ✓":"تأیید نشده"},{l:"وضعیت",v:<Badge status={sel.status}/>},
          ].map(({l,v})=>(
            <div key={l} style={{padding:"10px",background:"#F5F5F8",borderRadius:10}}>
              <div style={{fontSize:11,color:C.textMuted,marginBottom:3}}>{l}</div>
              <div style={{fontSize:13,fontWeight:600}}>{v}</div>
            </div>
          ))}
        </div>
      </Card>

      {/* Status actions */}
      <Card style={{marginBottom:12}}>
        <div style={{fontSize:13,fontWeight:600,color:C.textMuted,marginBottom:10}}>تغییر وضعیت</div>
        <div style={{display:"flex",gap:8,flexWrap:"wrap"}}>
          {["active","inactive","blocked"].map(s=>(
            <Btn key={s} variant={s==="blocked"?"red":s==="active"?"green":"ghost"} size="sm"
              disabled={sel.status===s} onClick={()=>setStatus(s)}>
              {STATUS[s]?.label||s}
            </Btn>
          ))}
        </div>
      </Card>

      {/* Balance adjustment */}
      <Card style={{marginBottom:12}}>
        <div style={{fontSize:13,fontWeight:600,color:C.textMuted,marginBottom:10}}>دستکاری موجودی</div>
        <Btn variant="primary" size="sm" onClick={()=>setAdjModal(true)}>+ تغییر موجودی</Btn>
      </Card>
      <Card style={{marginBottom:12}}>
        <div style={{fontSize:13,fontWeight:600,color:C.textMuted,marginBottom:10}}>ریست رمز عبور</div>
        <ResetPasswordForm api={api} show={show} userId={sel.id}/>
      </Card>

      {/* Transactions */}
      <Card>
        <div style={{fontSize:13,fontWeight:600,color:C.textMuted,marginBottom:10}}>سوابق تراکنش</div>
        {txns.length===0?<Empty text="تراکنشی نیست"/>:txns.slice(0,30).map(t=>(
          <div key={t.id} style={{borderBottom:`1px solid ${C.border}`,paddingBottom:10,marginBottom:10}}>
            <div style={{display:"flex",justifyContent:"space-between"}}>
              <div style={{fontSize:13,fontWeight:600}}>{{"silver_buy":"خرید نقره","silver_sell":"فروش نقره","silver_transfer":"انتقال نقره","physical_delivery":"تحویل فیزیکی نقره","wallet_charge":"شارژ کیف پول","wallet_withdrawal":"برداشت از کیف پول","balance_adjustment":"اصلاح دستی موجودی","buy":"خرید نقره","sell":"فروش نقره"}[t.type]||t.type}</div>
              <Badge status={t.status}/>
            </div>
            <div style={{fontSize:12,color:C.textMuted,marginTop:3}}>{t.tracking_code} — {t.created_at?.slice(0,10)}</div>
            {t.silver_gram&&<div style={{fontSize:12,color:C.teal}}>{fmtGram(t.silver_gram)} گرم</div>}
            {t.amount_rial&&<div style={{fontSize:12,color:C.green}}>{fmtRial(t.amount_rial)} ر</div>}
            {t.receipt_file&&<a href={`/api/v1/uploads/${t.receipt_file}`} target="_blank" rel="noreferrer" style={{fontSize:12,color:C.primary,textDecoration:"none",display:"inline-block",marginTop:3}}>📎 مشاهده فیش</a>}
          </div>
        ))}
      </Card>

      {adjModal&&(
        <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.3)",display:"flex",alignItems:"flex-end",justifyContent:"center",zIndex:600}} onClick={()=>setAdjModal(false)}>
          <div style={{background:"#fff",borderRadius:"22px 22px 0 0",padding:"8px 22px 40px",width:"100%",maxWidth:480}} onClick={e=>e.stopPropagation()}>
            <div style={{width:40,height:4,background:C.border,borderRadius:2,margin:"12px auto 20px"}}/>
            <div style={{fontSize:16,fontWeight:700,marginBottom:16}}>دستکاری موجودی</div>
            <Select label="نوع کیف پول" value={adjType} onChange={e=>setAdjType(e.target.value)}>
              <option value="rial">ریالی (ریال)</option>
              <option value="silver">نقره (گرم)</option>
            </Select>
            <Select label="عملیات" value={adjDir} onChange={e=>setAdjDir(e.target.value)}>
              <option value="add">افزایش</option>
              <option value="sub">کاهش</option>
            </Select>
            <Input label={adjType==="rial"?"مقدار (ریال)":"مقدار (گرم)"} type="number" value={adjAmount} onChange={e=>setAdjAmount(e.target.value)}/>
            <Input label="توضیح (اختیاری)" value={adjNote} onChange={e=>setAdjNote(e.target.value)}/>
            <Btn variant="primary" fullWidth loading={adjLoading} onClick={submitAdj}>ثبت تغییر</Btn>
          </div>
        </div>
      )}
    </div>
  );

  return (
    <div className="fade-up">
      <SectionHeader title="کاربران" color={C.primary} count={users.length} />
      <div style={{position:"relative",marginBottom:14}}>
        <input value={search} onChange={e=>setSearch(e.target.value)} placeholder="جستجو نام یا موبایل..."
          style={{width:"100%",padding:"11px 14px",borderRadius:12,border:`1.5px solid ${C.border}`,
            background:"#fff",color:C.text,fontSize:14,fontFamily:"Ray,sans-serif",outline:"none"}} />
      </div>
      {loading ? <div style={{textAlign:"center",padding:48}}><Spinner size={32}/></div>
       : users.length===0 ? <Empty text="کاربری یافت نشد"/>
       : users.map(u=>(
        <Card key={u.id} onClick={()=>openUser(u)} style={{marginBottom:8,cursor:"pointer"}}>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
            <div style={{display:"flex",alignItems:"center",gap:10}}>
              <div style={{width:36,height:36,borderRadius:10,background:"rgba(47,44,121,0.08)",
                display:"flex",alignItems:"center",justifyContent:"center",fontSize:14,fontWeight:800,
                color:C.primary,flexShrink:0}}>
                {(u.first_name||"?")[0]}
              </div>
              <div>
                <div style={{fontSize:14,fontWeight:700,color:C.text}}>{u.first_name||""} {u.last_name||""}</div>
                <div style={{fontSize:12,color:C.textSub}}>{u.mobile}</div>
                <div style={{fontSize:11,color:C.primary,fontWeight:600}}>{u.user_code||""}</div>
              </div>
            </div>
            <div style={{display:"flex",alignItems:"center",gap:10}}>
              <div style={{textAlign:"left"}}>
                <div style={{fontSize:13,fontWeight:600,color:C.teal}}>{fmtGram(u.balance_gram)} گ</div>
              </div>
              <Badge status={u.status}/>
            </div>
          </div>
        </Card>
      ))}
    {!loading && users.length < total && (
      <div style={{textAlign:"center",marginTop:12}}>
        <Btn variant="ghost" onClick={loadMore}>لود بیشتر ({total - users.length} نفر باقیمانده)</Btn>
      </div>
    )}
    </div>
  );
}

// ─── Logs ─────────────────────────────────────────────────────────────────────
function AdminLogList({api}) {
  const [logs,setLogs] = useState([]);
  const [loading,setL] = useState(true);
  useEffect(()=>{api("GET","/admin/logs").then(setLogs).catch(()=>{}).finally(()=>setL(false));},[]);

  const ACTION_LABELS = {
    login:"ورود",price_change:"تغییر قیمت",approve_buy:"تأیید خرید",reject_buy:"رد خرید",
    approve_sell:"تأیید فروش",reject_sell:"رد فروش",approve_charge:"تأیید شارژ",reject_charge:"رد شارژ",
    approve_delivery:"تأیید تحویل",reject_delivery:"رد تحویل",approve_iban:"تأیید شبا",reject_iban:"رد شبا",
    pay_withdrawal:"پرداخت برداشت",reject_withdrawal:"رد برداشت",balance_adjustment:"اصلاح موجودی",
    admin_create:"ساخت ادمین",admin_edit:"ویرایش ادمین",admin_deactivate:"غیرفعال ادمین",
    admin_activate:"فعال ادمین",admin_reset_password:"ریست رمز",backup:"بکاپ",
  };

  const ACTION_COLORS = {
    approve_buy:C.green,approve_sell:C.green,approve_charge:C.green,approve_delivery:C.green,approve_iban:C.green,pay_withdrawal:C.green,
    reject_buy:C.red,reject_sell:C.red,reject_charge:C.red,reject_delivery:C.red,reject_iban:C.red,reject_withdrawal:C.red,
    price_change:C.yellow,balance_adjustment:C.yellow,
    admin_create:C.primary,admin_edit:C.primary,
    login:C.teal,backup:C.teal,
  };

  return (
    <div className="fade-up">
      <SectionHeader title="لاگ مدیریتی" color={C.primary} />
      {loading ? <div style={{textAlign:"center",padding:48}}><Spinner size={32}/></div>
       : logs.length===0 ? <Empty text="لاگی ثبت نشده"/>
       : logs.map(l => {
        const color = ACTION_COLORS[l.action]||C.textMuted;
        return (
          <div key={l.id} style={{borderBottom:`1px solid ${C.border}`,padding:"12px 4px",display:"flex",gap:12,alignItems:"flex-start"}}>
            <div style={{width:8,height:8,borderRadius:"50%",background:color,marginTop:5,flexShrink:0}} />
            <div style={{flex:1}}>
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:2}}>
                <div style={{display:"flex",gap:8,alignItems:"center"}}>
                  <span style={{fontSize:13,fontWeight:700,color}}>{ACTION_LABELS[l.action]||l.action}</span>
                  <span style={{fontSize:12,color:C.textSub}}>{l.admin_name||`ادمین ${l.admin_id}`}</span>
                </div>
                <span style={{fontSize:11,color:C.textMuted,flexShrink:0}}>{fmtDateFa(l.created_at)}</span>
              </div>
              {l.description && <div style={{fontSize:12,color:C.textMuted,lineHeight:1.6}}>{l.description}</div>}
            </div>
          </div>
        );
      })}
    </div>
  );
}

// ─── Settings ─────────────────────────────────────────────────────────────────
function AdminSettingsPanel({api, show}) {
  const [tab,setTab] = useState("price");
  const TABS = [["price","قیمت"],["rules","قوانین"],["admins","ادمین‌ها"],["content","محتوا"],["backup","بکاپ"]];
  return (
    <div className="fade-up">
      <SectionHeader title="تنظیمات سیستم" color={C.primary} />
      <TabBar tabs={TABS} active={tab} onChange={setTab} />
      {tab==="price"   && <PriceSettingsPanel api={api} show={show} />}
      {tab==="rules"   && <RulesSettingsPanel api={api} show={show} />}
      {tab==="admins"  && <AdminMgmtPanel api={api} show={show} />}
      {tab==="content" && <ContentMgmtPanel api={api} show={show} />}
      {tab==="backup"  && <BackupPanel api={api} show={show} />}
    </div>
  );
}

function PriceSettingsPanel({api,show}) {
  const [f,setF]=useState({sell:"",disc:"6"});const[loading,setL]=useState(false);
  const [market,setMarket]=useState({buy:true,sell:true});const[mL,setML]=useState({buy:false,sell:false});
  useEffect(()=>{
    api("GET","/prices").then(p=>setF({sell:p.sell_price,disc:p.discount})).catch(()=>{});
    api("GET","/admin/settings").then(s=>setMarket({buy:s.buy_market_open!=="false",sell:s.sell_market_open!=="false",bar:s.bar_market_open!=="false",gold:s.gold_market_open!=="false"})).catch(()=>{});
  },[]);
  const buyPrice = Math.round(parseFloat(f.sell||0)*(1-parseFloat(f.disc||6)/100));
  const save=async()=>{setL(true);try{await api("POST","/admin/prices",{sell_price:parseFloat(f.sell||0),discount_percent:parseFloat(f.disc||6)});show("قیمت ذخیره شد","success");}catch(e){show(e.message,"error");}setL(false);};
  const toggle=async(type)=>{setML(p=>({...p,[type]:true}));const v=!market[type];const key=type==="bar"?"bar_market_open":`${type}_market_open`;try{await api("POST","/admin/settings",{[key]:v?"true":"false"});setMarket(p=>({...p,[type]:v}));show(`بازار ${v?"باز":"بسته"} شد`,"success");}catch(e){show(e.message,"error");}setML(p=>({...p,[type]:false}));};
  return (
    <div>
      <Card style={{marginBottom:12}}>
        <div style={{fontSize:13,fontWeight:700,color:C.textMuted,marginBottom:12}}>وضعیت بازار</div>
        {[{type:"buy",label:"بازار خرید ساچمه"},{type:"sell",label:"بازار فروش نقره"},{type:"bar",label:"بازار خرید شمش"},{type:"gold",label:"بازار خرید طلا"}].map(({type,label})=>(
          <div key={type} style={{display:"flex",justifyContent:"space-between",alignItems:"center",
            padding:"12px 14px",borderRadius:12,marginBottom:8,
            background:market[type]?C.greenBg:C.redBg,
            border:`1px solid ${market[type]?C.green:C.red}33`}}>
            <div>
              <div style={{fontSize:14,fontWeight:700,color:market[type]?C.green:C.red}}>{label}</div>
              <div style={{fontSize:12,color:C.textMuted}}>{market[type]?"فعال و باز است":"بسته است"}</div>
            </div>
            <Btn variant={market[type]?"red":"green"} size="sm" loading={mL[type]} onClick={()=>toggle(type)}>
              {market[type]?"بستن":"باز کردن"}
            </Btn>
          </div>
        ))}
      </Card>
      <Card>
        <div style={{fontSize:13,fontWeight:700,color:C.textMuted,marginBottom:14}}>قیمت‌گذاری نقره</div>
        <Input label="قیمت فروش به مشتری (ریال/گرم)" type="number" value={f.sell} onChange={e=>setF(p=>({...p,sell:e.target.value}))} />
        <Input label="درصد کسر بازخرید (%)" type="number" value={f.disc} onChange={e=>setF(p=>({...p,disc:e.target.value}))} />
        {parseFloat(f.sell)>0 && (
          <div style={{background:C.primaryGlow,borderRadius:12,padding:"12px 14px",marginBottom:14,
            border:`1px solid ${C.primary}22`,display:"flex",justifyContent:"space-between",alignItems:"center"}}>
            <span style={{fontSize:13,color:C.textSub}}>قیمت بازخرید محاسبه‌شده</span>
            <span style={{fontSize:16,fontWeight:800,color:C.primary}}>{fmtRial(buyPrice)} ر/گرم</span>
          </div>
        )}
        <Btn variant="primary" loading={loading} onClick={save}>ذخیره قیمت</Btn>
      </Card>
    </div>
  );
}

function RulesSettingsPanel({api,show}) {
  const [s,setS]=useState({});const[f,setF]=useState({});const[loading,setL]=useState(false);
  useEffect(()=>{api("GET","/admin/settings").then(d=>{setS(d);setF(d);}).catch(()=>{});},[]);
  const val=(k)=>f[k]!==undefined?f[k]:(s[k]||"");
  const save=async(keys)=>{const p={};keys.forEach(k=>{if(f[k]!==undefined)p[k]=f[k];});try{await api("POST","/admin/settings",p);show("ذخیره شد","success");api("GET","/admin/settings").then(d=>{setS(d);setF(d);}).catch(()=>{});}catch(e){show(e.message,"error");};};
  const FIELDS=[
    {k:"company_card_number",l:"شماره کارت مکعب",noFormat:true},
    {k:"company_card_owner",l:"نام صاحب کارت مکعب",noFormat:true,isText:true},
    {k:"min_buy_gram",    l:"حداقل خرید (گرم)"},
    {k:"min_sell_gram",   l:"حداقل فروش (گرم)"},
    {k:"delivery_fee",l:"هزینه بسته‌بندی تحویل (ریال)"},
    {k:"min_delivery_gram",l:"حداقل تحویل (گرم)"},
    {k:"max_withdrawal_rial",l:"سقف برداشت (ریال)"},
    {k:"login_max_attempts",l:"حداکثر تلاش ورود"},
    {k:"login_lockout_min", l:"مدت قفل (دقیقه)"},
  ];
  return (
    <Card>
      <div style={{fontSize:13,fontWeight:700,color:C.textMuted,marginBottom:14}}>قوانین و محدودیت‌ها</div>
      {FIELDS.map(({k,l,noFormat,isText})=>{
  const raw=val(k)||"";
  const display=noFormat||raw===""?raw:numFa(Number(raw.replace(/,/g,"")).toLocaleString("en-US"));
  return(<div key={k} style={{marginBottom:14}}><div style={{fontSize:13,fontWeight:600,color:C.textSub,marginBottom:5}}>{l}</div><input type={isText?"text":"text"} inputMode={isText?"text":"numeric"} value={isText?val(k):display} onChange={e=>{if(isText){setF(p=>({...p,[k]:e.target.value}));}else{const n=e.target.value.replace(/[^0-9۰-۹]/g,"").replace(/[۰-۹]/g,d=>String.fromCharCode(d.charCodeAt(0)-1728));setF(p=>({...p,[k]:n}));}}} style={{width:"100%",padding:"11px 14px",borderRadius:12,border:`1.5px solid ${C.border}`,background:"#fff",color:C.text,fontSize:14,fontFamily:"Ray,sans-serif",direction:"rtl",textAlign:"right",outline:"none"}} /></div>);
  return(<div key={k} style={{marginBottom:14}}>
    <div style={{fontSize:13,fontWeight:600,color:C.textSub,marginBottom:5}}>{l}</div>
    <input type="text" inputMode="numeric" value={display}
      onChange={e=>{const n=e.target.value.replace(/[^0-9۰-۹]/g,"").replace(/[۰-۹]/g,d=>String.fromCharCode(d.charCodeAt(0)-1728));setF(p=>({...p,[k]:n}));}}
      style={{width:"100%",padding:"11px 14px",borderRadius:12,border:`1.5px solid ${C.border}`,background:"#fff",color:C.text,fontSize:14,fontFamily:"Ray,sans-serif",direction:"rtl",textAlign:"right",outline:"none"}} />
  </div>);
})}
      <Btn variant="primary" loading={loading} onClick={()=>save(FIELDS.map(f=>f.k))}>ذخیره قوانین</Btn>
    </Card>
  );
}

function AdminMgmtPanel({api,show}) {
  const [admins,setAdmins]=useState([]);const[modal,setModal]=useState(null);
  const load=()=>api("GET","/admin/admins").then(setAdmins).catch(()=>{});
  useEffect(()=>{load();},[]);
  const ROLE_LABELS={super_admin:"ارشد",financial:"مالی",operations:"عملیات",ceo:"مدیرعامل"};
  const ROLE_COLORS={super_admin:C.primary,financial:C.green,operations:C.teal,ceo:C.violet};
  const act=async(method,path,body,msg)=>{try{await api(method,path,body||{});show(msg,"success");load();}catch(e){show(e.message,"error");}};

  return (
    <div>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:14}}>
        <div style={{fontSize:13,fontWeight:700,color:C.textMuted}}>ادمین‌های سیستم</div>
        <Btn variant="primary" size="sm" onClick={()=>setModal({type:"new"})}>+ ادمین جدید</Btn>
      </div>
      {admins.map(a=>(
        <Card key={a.id} style={{marginBottom:8}}>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:10}}>
            <div style={{display:"flex",alignItems:"center",gap:10}}>
              <div style={{width:36,height:36,borderRadius:10,flexShrink:0,
                background:`${ROLE_COLORS[a.role]||C.primary}12`,
                display:"flex",alignItems:"center",justifyContent:"center",
                fontSize:14,fontWeight:800,color:ROLE_COLORS[a.role]||C.primary}}>
                {(a.name||"A")[0]}
              </div>
              <div>
                <div style={{fontSize:14,fontWeight:700}}>{a.name}</div>
                <div style={{fontSize:12,color:C.textSub}}>@{a.username}</div>
              </div>
            </div>
            <div style={{display:"flex",gap:6,alignItems:"center"}}>
              <span style={{fontSize:11,fontWeight:700,padding:"2px 8px",borderRadius:20,
                background:`${ROLE_COLORS[a.role]||C.primary}12`,color:ROLE_COLORS[a.role]||C.primary}}>
                {ROLE_LABELS[a.role]||a.role}
              </span>
              <span style={{fontSize:11,fontWeight:600,color:a.is_active?C.green:C.red}}>
                {a.is_active?"●":"○"}
              </span>
            </div>
          </div>
          {a.must_change_password && <div style={{fontSize:12,color:C.yellow,background:C.yellowBg,borderRadius:8,padding:"4px 8px",marginBottom:8}}>⚠ باید رمز تغییر دهد</div>}
          <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
            <Btn variant="ghost" size="sm" onClick={()=>setModal({type:"edit",target:a})}>ویرایش</Btn>
            <Btn variant="ghost" size="sm" onClick={()=>setModal({type:"reset",target:a})}>ریست رمز</Btn>
            {a.is_active
              ? <Btn variant="red" size="sm" onClick={()=>act("PUT",`/admin/admins/${a.id}/deactivate`,{},"غیرفعال شد")}>غیرفعال</Btn>
              : <Btn variant="green" size="sm" onClick={()=>act("PUT",`/admin/admins/${a.id}/activate`,{},"فعال شد")}>فعال‌سازی</Btn>}
          </div>
        </Card>
      ))}
      {modal?.type==="new"  && <Modal title="ادمین جدید" onClose={()=>setModal(null)}><NewAdminForm api={api} show={show} onSaved={()=>{setModal(null);load();}} /></Modal>}
      {modal?.type==="edit" && <Modal title={`ویرایش: ${modal.target.username}`} onClose={()=>setModal(null)}><EditAdminForm api={api} show={show} target={modal.target} onSaved={()=>{setModal(null);load();}} /></Modal>}
      {modal?.type==="reset"&& <Modal title={`ریست رمز: ${modal.target.username}`} onClose={()=>setModal(null)}><ResetAdminPwForm api={api} show={show} target={modal.target} onSaved={()=>{setModal(null);load();}} /></Modal>}
    </div>
  );
}

function NewAdminForm({api,show,onSaved}) {
  const [f,setF]=useState({role:"financial"});const set=(k,v)=>setF(p=>({...p,[k]:v}));const[loading,setL]=useState(false);
  const submit=async()=>{setL(true);try{await api("POST","/admin/admins",{name:f.name||"",username:f.username||"",password:f.password||"",role:f.role,mobile:f.mobile||""});show("ادمین ساخته شد","success");onSaved();}catch(e){show(e.message,"error");}setL(false);};
  return(<div><Input label="نام کامل" value={f.name||""} onChange={e=>set("name",e.target.value)} /><Input label="نام کاربری" value={f.username||""} onChange={e=>set("username",e.target.value)} style={{direction:"ltr"}} /><Input label="رمز عبور (حداقل ۸ کاراکتر)" type="password" value={f.password||""} onChange={e=>set("password",e.target.value)} style={{direction:"ltr"}} /><Select label="نقش" value={f.role} onChange={e=>set("role",e.target.value)}><option value="financial">financial — مالی</option><option value="operations">operations — عملیات</option><option value="ceo">ceo — مدیرعامل</option><option value="super_admin">super_admin — ارشد</option></Select><Input label="موبایل (اختیاری)" value={f.mobile||""} onChange={e=>set("mobile",e.target.value)} /><Btn variant="primary" fullWidth loading={loading} onClick={submit}>ساخت ادمین</Btn></div>);
}

function EditAdminForm({api,show,target,onSaved}) {
  const [f,setF]=useState({name:target.name||"",mobile:target.mobile||"",role:target.role});const set=(k,v)=>setF(p=>({...p,[k]:v}));const[loading,setL]=useState(false);
  const submit=async()=>{setL(true);try{await api("PUT",`/admin/admins/${target.id}`,{name:f.name,mobile:f.mobile,role:f.role});show("ویرایش شد","success");onSaved();}catch(e){show(e.message,"error");}setL(false);};
  return(<div><Input label="نام کامل" value={f.name} onChange={e=>set("name",e.target.value)} /><Select label="نقش" value={f.role} onChange={e=>set("role",e.target.value)}><option value="financial">financial — مالی</option><option value="operations">operations — عملیات</option><option value="ceo">ceo — مدیرعامل</option><option value="super_admin">super_admin — ارشد</option></Select><Input label="موبایل" value={f.mobile} onChange={e=>set("mobile",e.target.value)} /><Btn variant="primary" fullWidth loading={loading} onClick={submit}>ذخیره</Btn></div>);
}

function ResetAdminPwForm({api,show,target,onSaved}) {
  const [pw,setPw]=useState("");const[loading,setL]=useState(false);
  const submit=async()=>{setL(true);try{await api("POST",`/admin/admins/${target.id}/reset-password`,{new_password:pw});show("رمز ریست شد","success");onSaved();}catch(e){show(e.message,"error");}setL(false);};
  return(<div><div style={{fontSize:14,color:C.textMuted,marginBottom:14}}>رمز جدید برای <strong>@{target.username}</strong></div><Input label="رمز جدید (حداقل ۸ کاراکتر)" type="password" value={pw} onChange={e=>setPw(e.target.value)} style={{direction:"ltr"}} /><Btn variant="danger" fullWidth loading={loading} disabled={pw.length<8} onClick={submit}>ریست رمز</Btn></div>);
}

function ContentMgmtPanel({api, show}) {
  const [slug,setSlug]   = useState("about_us");
  const [pages,setPages] = useState({});
  const [loading,setL]   = useState(false);
  const [saving,setSaving] = useState(false);

  const SLUGS = [
    {k:"about_us",  l:"درباره ما"},
    {k:"terms",     l:"قوانین"},
    {k:"faq",       l:"سوالات متداول"},
    {k:"contact",   l:"تماس با ما"},
    {k:"login_text",l:"متن ورود"},
  ];

  useEffect(() => {
    if (pages[slug] !== undefined) return;
    setL(true);
    fetch(`/api/v1/content/${slug}`).then(r=>r.json())
      .then(r => setPages(p=>({...p,[slug]:{title:r.title||"",content:r.content||""}})))
      .catch(()=> setPages(p=>({...p,[slug]:{title:"",content:""}})))
      .finally(()=>setL(false));
  }, [slug]);

  const cur = pages[slug] || {title:"",content:""};
  const setField = (f,v) => setPages(p=>({...p,[slug]:{...(p[slug]||{}),[f]:v}}));

  const save = async () => {
    setSaving(true);
    try { await api("PUT",`/content/${slug}`,{title:cur.title,content:cur.content}); show("محتوا ذخیره شد","success"); }
    catch(e) { show(e.message,"error"); }
    setSaving(false);
  };

  return (
    <div>
      <div style={{display:"flex",gap:6,overflowX:"auto",marginBottom:14,paddingBottom:4}}>
        {SLUGS.map(({k,l}) => (
          <button key={k} onClick={()=>setSlug(k)} style={{
            padding:"7px 14px",borderRadius:20,border:"none",cursor:"pointer",
            fontFamily:"Ray,sans-serif",fontSize:13,fontWeight:600,whiteSpace:"nowrap",flexShrink:0,
            background:slug===k?`${C.primary}18`:"#fff",color:slug===k?C.primary:C.textSub,
            outline:slug===k?`1px solid ${C.primary}44`:"none"}}>
            {l}
          </button>
        ))}
      </div>
      {loading ? <div style={{textAlign:"center",padding:32}}><Spinner size={28}/></div> : (
        <Card>
          <Input label="عنوان" value={cur.title} onChange={e=>setField("title",e.target.value)} />
          <div style={{marginBottom:14}}>
            <div style={{fontSize:13,fontWeight:600,color:C.textSub,marginBottom:5}}>محتوا</div>
            <textarea value={cur.content} onChange={e=>setField("content",e.target.value)} rows={10}
              style={{width:"100%",padding:"13px 16px",borderRadius:12,border:`1.5px solid ${C.border}`,
                background:"#fff",color:C.text,fontSize:14,fontFamily:"Ray,sans-serif",
                direction:"rtl",outline:"none",resize:"vertical",lineHeight:1.9}} />
          </div>
          <Btn variant="primary" loading={saving} onClick={save}>ذخیره محتوا</Btn>
        </Card>
      )}
    </div>
  );
}

function BackupPanel({api,show}) {
  const [backups,setB]=useState([]);const[loading,setL]=useState(false);
  useEffect(()=>{api("GET","/admin/backups").then(setB).catch(()=>{});},[]);
  const doBackup=async()=>{setL(true);try{const r=await api("POST","/admin/backup",{});show(`بکاپ ساخته شد: ${r.filename}`,"success");api("GET","/admin/backups").then(setB);}catch(e){show(e.message,"error");}setL(false);};
  return (
    <div>
      <Card style={{marginBottom:12}}>
        <div style={{fontSize:13,color:C.textMuted,marginBottom:14,lineHeight:2}}>
          • بکاپ خودکار روزانه فعال است<br/>
          • ۷ نسخه آخر نگه‌داری می‌شود<br/>
          • شامل دیتابیس + آپلودها
        </div>
        <Btn variant="primary" loading={loading} onClick={doBackup}>+ بکاپ دستی</Btn>
      </Card>
      {backups.map(b=>(
        <Card key={b.id} style={{marginBottom:8,display:"flex",justifyContent:"space-between",alignItems:"center"}}>
          <div>
            <div style={{fontSize:13,fontWeight:600,color:C.text}}>{b.filename}</div>
            <div style={{fontSize:11,color:C.textMuted,marginTop:2}}>{fmtDateFa(b.created_at)} — {(b.size_bytes/1024).toFixed(1)} KB</div>
          </div>
          <a href={`/api/v1/admin/backups/${b.filename}/download`}
            style={{fontSize:13,color:C.primary,textDecoration:"none",fontWeight:600,
              display:"flex",alignItems:"center",gap:4,background:C.primaryGlow,
              padding:"6px 12px",borderRadius:8}}>
            ⬇ دانلود
          </a>
        </Card>
      ))}
      {backups.length===0 && <Empty text="بکاپی ثبت نشده"/>}
    </div>
  );
}

// ══════════════════════════════════════════════════════════════════════════════
// App Root
// ══════════════════════════════════════════════════════════════════════════════
export default function App() {
  const [mode,setMode] = useState(() => {
    const t=getToken(), r=getRole();
    if (t && r==="admin") return "admin_loading";
    if (t && r==="user")  return "user_loading";
    if(window.location.hash==="#admin") return "admin_entry";
    return "splash";
  });
  const [userData,setUser]   = useState(null);
  const [adminData,setAdmin] = useState(null);

  useEffect(() => {
    if (mode==="user_loading")
      req("GET","/user/profile",null,getToken())
        .then(u => { setUser(u); setMode("user"); })
        .catch(() => { clearAuth(); setMode("splash"); });
    if (mode==="admin_loading")
      req("GET","/admin/stats",null,getToken())
        .then(() => {
          try {
            const p = JSON.parse(atob(getToken().split(".")[1]));
            setAdmin({id:p.id, role:p.role, name:p.name||"ادمین"});
          } catch { setAdmin({role:"super_admin",name:"ادمین"}); }
          setMode("admin");
        })
        .catch(() => { clearAuth(); setMode("splash"); });
  }, [mode]);

  const handleAdminLogin = async (username, password) => {
    const r = await req("POST","/admin/auth/login",{username,password});
    setToken(r.token); setRole("admin");
    setAdmin(r.admin);
    if (r.must_change_password) setMode("admin_must_change");
    else setMode("admin");
  };

  const logout = () => { window.location.hash=""; clearAuth(); setUser(null); setAdmin(null); setMode("splash"); };

  if (mode==="user_loading" || mode==="admin_loading") return (
    <div style={{minHeight:"100vh",background:C.bg,display:"flex",alignItems:"center",justifyContent:"center"}}>
      <style>{G}</style>
      <div style={{textAlign:"center"}}><Logo size={90} /><div style={{marginTop:24}}><Spinner size={36} /></div></div>
    </div>
  );

  if (mode==="splash")            return <LoginScreen onLogin={(role,data)=>{if(role==="user"){setUser(data);setMode("user");}}} />;
  if (mode==="admin_entry")       return <AdminLoginScreen onLogin={handleAdminLogin} />;
  if (mode==="admin_must_change") return <AdminForceChangePw onDone={()=>setMode("admin")} onLogout={logout} />;
  if (mode==="user" && userData)  return <UserPanel user={userData} onLogout={logout} />;
  if (mode==="admin" && adminData)return <AdminPanel admin={adminData} onLogout={logout} />;
  return <LoginScreen onLogin={(role,data)=>{if(role==="user"){setUser(data);setMode("user");}}} />;
}
 
